/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Date is a date formatted via ISO8601
   *
   * Example: 2018-05-02
   */
  Date: { input: any; output: any; }
  /**
   * Dollars is a float with either 0 or 2 digits following the decimal point
   * Specifying values with *ONLY* cents (such as 0.25) requires the 0
   *
   * Examples: 525.25, 525, 0.25
   */
  Dollars: { input: any; output: any; }
  /** JSON is a string representing any JSON object */
  JSON: { input: any; output: any; }
  /**
   * Time is a datetime of an event occurring
   *
   * Example: 2018-05-02T15:44:52-04:00
   */
  Time: { input: any; output: any; }
  /** URL is a string representing a URL. This string should be safe for linkification. */
  URL: { input: any; output: any; }
  UUID: { input: any; output: any; }
  /**
   * ZipCode is a string representing a ZIP Code.
   *
   * https://en.wikipedia.org/wiki/ZIP_Code
   *
   * This scalar is guaranteed to be one of two forms:
   * - 5 digit characters.
   * - 5 digit characters, followed by a hyphen (-) character, followed by 4 digit characters.
   *
   * Examples: 20165, 99577-0727
   */
  ZipCode: { input: any; output: any; }
  _Any: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
};

export type Aptc = {
  __typename?: 'APTC';
  amount?: Maybe<Scalars['Dollars']['output']>;
  change?: Maybe<EligibilityChange>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type AccountStatement = Document & {
  __typename?: 'AccountStatement';
  date: Scalars['Date']['output'];
  detail: Scalars['String']['output'];
  documentType: DocumentType;
  id: Scalars['ID']['output'];
  month: Scalars['String']['output'];
  planType: PlanType;
  providerId?: Maybe<Scalars['String']['output']>;
  type: StatementAccountType;
  vertical: Scalars['String']['output'];
};

export type AccountStatus = {
  __typename?: 'AccountStatus';
  id: Scalars['ID']['output'];
  isBankingKYCDenied?: Maybe<Scalars['Boolean']['output']>;
  isBankingReady?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isMigrating?: Maybe<Scalars['Boolean']['output']>;
  isWealthReady?: Maybe<Scalars['Boolean']['output']>;
};

export type AchTransfer = {
  __typename?: 'AchTransfer';
  amount: Scalars['Dollars']['output'];
  bankDetail?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  providerTransactionID?: Maybe<Scalars['String']['output']>;
  returnCode?: Maybe<Scalars['String']['output']>;
};

/**
 * ActivityConnection is a connection to a list of events, ordered by time
 * occurred with the most recent first.
 */
export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  edges: Array<Event>;
  pageInfo: PageInfo;
};

export type ActivityEvent = {
  __typename?: 'ActivityEvent';
  createdOn: Scalars['Time']['output'];
  eventType: ActivityEventType;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  subject: BaseUser;
  triggeredBy?: Maybe<BaseUser>;
};

export enum ActivityEventType {
  AgreementSigned = 'AGREEMENT_SIGNED',
  AutoTaxTurnedOff = 'AUTO_TAX_TURNED_OFF',
  AutoTaxTurnedOn = 'AUTO_TAX_TURNED_ON',
  BankDeleted = 'BANK_DELETED',
  BankLinked = 'BANK_LINKED',
  ConciergeRequested = 'CONCIERGE_REQUESTED',
  ConciergeScheduled = 'CONCIERGE_SCHEDULED',
  ConsentSent = 'CONSENT_SENT',
  ConsentSigned = 'CONSENT_SIGNED',
  ConversionStatusUpdated = 'CONVERSION_STATUS_UPDATED',
  DentalPlanEnrolled = 'DENTAL_PLAN_ENROLLED',
  EdeApplicationDeleted = 'EDE_APPLICATION_DELETED',
  EdeApplicationProgressed = 'EDE_APPLICATION_PROGRESSED',
  EdeApplicationResultsViewed = 'EDE_APPLICATION_RESULTS_VIEWED',
  EdeApplicationStarted = 'EDE_APPLICATION_STARTED',
  EdeApplicationSubmitted = 'EDE_APPLICATION_SUBMITTED',
  EdeBinderPaymentMade = 'EDE_BINDER_PAYMENT_MADE',
  EdeConnected = 'EDE_CONNECTED',
  EdeDisconnected = 'EDE_DISCONNECTED',
  EdeError = 'EDE_ERROR',
  EdeIssueDocSubmitted = 'EDE_ISSUE_DOC_SUBMITTED',
  EdeIssueResolved = 'EDE_ISSUE_RESOLVED',
  EdePlanCircumstanceChanged = 'EDE_PLAN_CIRCUMSTANCE_CHANGED',
  EdePlanEnrolled = 'EDE_PLAN_ENROLLED',
  FlagUpdated = 'FLAG_UPDATED',
  FundsDeposited = 'FUNDS_DEPOSITED',
  HealthEligibilityEstimated = 'HEALTH_ELIGIBILITY_ESTIMATED',
  HealthExplorerImported = 'HEALTH_EXPLORER_IMPORTED',
  HealthExplorerPlanSelected = 'HEALTH_EXPLORER_PLAN_SELECTED',
  HealthExplorerStarted = 'HEALTH_EXPLORER_STARTED',
  HealthExplorerUpdated = 'HEALTH_EXPLORER_UPDATED',
  HealthIdentityChecked = 'HEALTH_IDENTITY_CHECKED',
  HealthIdentityFailed = 'HEALTH_IDENTITY_FAILED',
  HealthIdentityPassed = 'HEALTH_IDENTITY_PASSED',
  HealthIdentityPending = 'HEALTH_IDENTITY_PENDING',
  HealthIdentityQuestionsAnswered = 'HEALTH_IDENTITY_QUESTIONS_ANSWERED',
  HealthLinkCompleted = 'HEALTH_LINK_COMPLETED',
  HealthLinkLookup = 'HEALTH_LINK_LOOKUP',
  HealthLinkStarted = 'HEALTH_LINK_STARTED',
  HealthPlanHandoff = 'HEALTH_PLAN_HANDOFF',
  IdentityVerificationPlaid = 'IDENTITY_VERIFICATION_PLAID',
  IdProofFarsSubmitted = 'ID_PROOF_FARS_SUBMITTED',
  IdProofQuestionsAnswered = 'ID_PROOF_QUESTIONS_ANSWERED',
  ImportedDentalPlan = 'IMPORTED_DENTAL_PLAN',
  ImportedPlan = 'IMPORTED_PLAN',
  IncomeTransactionCreated = 'INCOME_TRANSACTION_CREATED',
  KycRejected = 'KYC_REJECTED',
  OscarApplicationStarted = 'OSCAR_APPLICATION_STARTED',
  PreliminaryEligibility = 'PRELIMINARY_ELIGIBILITY',
  PrimaryBankUpdated = 'PRIMARY_BANK_UPDATED',
  PrivateExplorerImported = 'PRIVATE_EXPLORER_IMPORTED',
  PxHealthEligibilityEstimated = 'PX_HEALTH_ELIGIBILITY_ESTIMATED',
  TierUpdated = 'TIER_UPDATED',
  TransactionalEmailSent = 'TRANSACTIONAL_EMAIL_SENT',
  TransactionFailed = 'TRANSACTION_FAILED'
}

/** Address represents an address */
export type Address = {
  __typename?: 'Address';
  /** City of the address */
  city?: Maybe<Scalars['String']['output']>;
  /** The coordinates of this address for Google Maps */
  coordinates?: Maybe<Coordinates>;
  /** The 3 character alpha-3 designation of a country */
  country?: Maybe<Scalars['String']['output']>;
  /** The 5 digit county fips of the county the zip is in */
  countyfips?: Maybe<Scalars['String']['output']>;
  /** State of the address */
  state?: Maybe<Scalars['String']['output']>;
  /** Street address */
  street1?: Maybe<Scalars['String']['output']>;
  /** Additional street address information (apt number, etc) */
  street2?: Maybe<Scalars['String']['output']>;
  /** The 5 digit zip code */
  zip?: Maybe<Scalars['String']['output']>;
  /** The additional 4 digit more specific zip code */
  zip4?: Maybe<Scalars['String']['output']>;
};

/** The fields required for creating an address entity */
export type AddressInput = {
  /** City of the address */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The coordinates of this address for Google Maps */
  coordinates?: InputMaybe<CoordinatesInput>;
  /** The 3 character alpha-3 designation of a country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The 5 digit county fips of the county the zip is in - This is autopopulated with Smartystreets during EnsureHealthApplication but upsertable in case of explorer */
  countyfips?: InputMaybe<Scalars['String']['input']>;
  /** State of the address */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Street address */
  street1?: InputMaybe<Scalars['String']['input']>;
  /** Additional street address information (apt number, etc) */
  street2?: InputMaybe<Scalars['String']['input']>;
  /** The 5 digit zip code */
  zip?: InputMaybe<Scalars['String']['input']>;
  /** The additional 4 digit more specific zip code */
  zip4?: InputMaybe<Scalars['String']['input']>;
};

export type AdminEvent = Event & {
  __typename?: 'AdminEvent';
  action: AdminEventAction;
  adminUser?: Maybe<User>;
  eventType: AdminEventType;
  /** healthApplication is only relevant for HEALTH_APPLICATION (as of 3/30/2021) */
  healthApplication?: Maybe<HealthApplication>;
  /** healthExplorerData is only relevant for HEALTH_EXPLORER events */
  healthExplorerData?: Maybe<HealthExplorerData>;
  /** healthInsuranceEnrollment is only relevant for HEALTH_APPLICATION (deprecated) and HEALTH_ENROLLMENT events */
  healthInsuranceEnrollment?: Maybe<HealthInsuranceEnrollment>;
  /** The ID of the event */
  id: Scalars['ID']['output'];
  /** incomeAutomationRule is only relevant for PAYCHECK_IGNORED events */
  incomeAutomationRule?: Maybe<IncomeAutomationRule>;
  notes?: Maybe<Scalars['String']['output']>;
  /** referralUser is only relevant for REFERRAL events */
  referralUser?: Maybe<User>;
  requestID?: Maybe<Scalars['ID']['output']>;
  /** rewardCode is only relevant for REWARD and REFERRAL events */
  rewardCode?: Maybe<Scalars['String']['output']>;
  time: Scalars['Time']['output'];
  userType: AdminUserType;
};

export enum AdminEventAction {
  AssignTask = 'ASSIGN_TASK',
  BankLinkConnected = 'BANK_LINK_CONNECTED',
  BankLinkDeleted = 'BANK_LINK_DELETED',
  BankLinkError = 'BANK_LINK_ERROR',
  BankLinkReconnected = 'BANK_LINK_RECONNECTED',
  BankLinkSetPrimary = 'BANK_LINK_SET_PRIMARY',
  BankMigrationComplete = 'BANK_MIGRATION_COMPLETE',
  BankMigrationFailed = 'BANK_MIGRATION_FAILED',
  BankMigrationInitialFundsAvailable = 'BANK_MIGRATION_INITIAL_FUNDS_AVAILABLE',
  BankMigrationStarted = 'BANK_MIGRATION_STARTED',
  CancelOnboardingRequest = 'CANCEL_ONBOARDING_REQUEST',
  CancelTask = 'CANCEL_TASK',
  ClaimTask = 'CLAIM_TASK',
  CompleteTask = 'COMPLETE_TASK',
  CreateTask = 'CREATE_TASK',
  DepositToGoal = 'DEPOSIT_TO_GOAL',
  HealthAppDocsRequired = 'HEALTH_APP_DOCS_REQUIRED',
  HealthAppDocsSubmitted = 'HEALTH_APP_DOCS_SUBMITTED',
  HealthAppEbpAppPermissionsGranted = 'HEALTH_APP_EBP_APP_PERMISSIONS_GRANTED',
  HealthAppEbpAppPermissionsRevoked = 'HEALTH_APP_EBP_APP_PERMISSIONS_REVOKED',
  HealthAppEbpIssuesResolved = 'HEALTH_APP_EBP_ISSUES_RESOLVED',
  HealthAppEbpIssueEscalated = 'HEALTH_APP_EBP_ISSUE_ESCALATED',
  HealthAppEbpIssueExpired = 'HEALTH_APP_EBP_ISSUE_EXPIRED',
  HealthAppEbpIssueInsufficient = 'HEALTH_APP_EBP_ISSUE_INSUFFICIENT',
  HealthAppEbpIssueObsolete = 'HEALTH_APP_EBP_ISSUE_OBSOLETE',
  HealthAppEbpTaxFormEventReceived = 'HEALTH_APP_EBP_TAX_FORM_EVENT_RECEIVED',
  HealthAppEnsured = 'HEALTH_APP_ENSURED',
  HealthAppIdvCompleted = 'HEALTH_APP_IDV_COMPLETED',
  HealthAppIdvFail = 'HEALTH_APP_IDV_FAIL',
  HealthAppMemberUpserted = 'HEALTH_APP_MEMBER_UPSERTED',
  HealthAppSubmitted = 'HEALTH_APP_SUBMITTED',
  HealthEnrollmentBinderPaymentMade = 'HEALTH_ENROLLMENT_BINDER_PAYMENT_MADE',
  HealthEnrollmentDeleted = 'HEALTH_ENROLLMENT_DELETED',
  HealthExplorerStarted = 'HEALTH_EXPLORER_STARTED',
  Lock = 'LOCK',
  ModifyTask = 'MODIFY_TASK',
  OnboardingComplete = 'ONBOARDING_COMPLETE',
  OnboardingCompleteNoCharge = 'ONBOARDING_COMPLETE_NO_CHARGE',
  PaycheckIgnored = 'PAYCHECK_IGNORED',
  PlaidIdentityMatch = 'PLAID_IDENTITY_MATCH',
  PlaidIdentityMismatch = 'PLAID_IDENTITY_MISMATCH',
  PlaidIdentityUnableToVerify = 'PLAID_IDENTITY_UNABLE_TO_VERIFY',
  ReferralEarned = 'REFERRAL_EARNED',
  ReferralNew = 'REFERRAL_NEW',
  ReferralPaid = 'REFERRAL_PAID',
  ReferralSignup = 'REFERRAL_SIGNUP',
  RefreshPlaidIdentity = 'REFRESH_PLAID_IDENTITY',
  RequestOnboarding = 'REQUEST_ONBOARDING',
  RewardPaid = 'REWARD_PAID',
  RewardSignup = 'REWARD_SIGNUP',
  TaxPaymentCanceled = 'TAX_PAYMENT_CANCELED',
  TaxPaymentClaimed = 'TAX_PAYMENT_CLAIMED',
  TaxPaymentComplete = 'TAX_PAYMENT_COMPLETE',
  TaxPaymentInitiated = 'TAX_PAYMENT_INITIATED',
  Unlock = 'UNLOCK',
  UpdateUserTier = 'UPDATE_USER_TIER',
  UserInfoUpdated = 'USER_INFO_UPDATED',
  UserLegalAddressUpdated = 'USER_LEGAL_ADDRESS_UPDATED',
  WealthAccountDisabled = 'WEALTH_ACCOUNT_DISABLED',
  WealthAccountReenabled = 'WEALTH_ACCOUNT_REENABLED',
  WithdrawFromGoal = 'WITHDRAW_FROM_GOAL',
  XferRetirementToGoal = 'XFER_RETIREMENT_TO_GOAL'
}

export enum AdminEventType {
  BankLink = 'BANK_LINK',
  BankMigration = 'BANK_MIGRATION',
  HealthApplication = 'HEALTH_APPLICATION',
  HealthEnrollment = 'HEALTH_ENROLLMENT',
  HealthExplorer = 'HEALTH_EXPLORER',
  MoneyMovement = 'MONEY_MOVEMENT',
  PaycheckAction = 'PAYCHECK_ACTION',
  PlaidIdentity = 'PLAID_IDENTITY',
  RewardAction = 'REWARD_ACTION',
  StatusChange = 'STATUS_CHANGE',
  Task = 'TASK',
  TaxPayment = 'TAX_PAYMENT',
  UserTierUpdate = 'USER_TIER_UPDATE',
  UserUpdate = 'USER_UPDATE',
  VideoOnboarding = 'VIDEO_ONBOARDING',
  WealthAccountStatusChange = 'WEALTH_ACCOUNT_STATUS_CHANGE'
}

export enum AdminUserType {
  Admin = 'ADMIN',
  System = 'SYSTEM',
  User = 'USER'
}

export enum AgreementType {
  AttestedAetnaCoverage = 'ATTESTED_AETNA_COVERAGE',
  BrokerConsent = 'BROKER_CONSENT',
  CatchPrivacyPolicy = 'CATCH_PRIVACY_POLICY',
  CatchTermsOfUse = 'CATCH_TERMS_OF_USE',
  UnitDepositTermsAndConditions = 'UNIT_DEPOSIT_TERMS_AND_CONDITIONS',
  UnitElectronicDisclosuresConsent = 'UNIT_ELECTRONIC_DISCLOSURES_CONSENT'
}

export type Agreements = {
  __typename?: 'Agreements';
  /** If the user has acknowledged BBVA's account disclosures */
  acknowledgedAccountDisclosures: Scalars['Boolean']['output'];
  /** If the user has acknowledged CBW's account disclosures */
  acknowledgedCBWAccountDisclosures: Scalars['Boolean']['output'];
  /** If the user has acknowledged the BBVA to CBW migration */
  acknowledgedCBWMigration: Scalars['Boolean']['output'];
  /** If the user has acknowledged Unit's account disclosures */
  acknowledgedUnitAccountDisclosures: Scalars['Boolean']['output'];
  /** Returns true if the user has attested to having existing Aetna coverage */
  alreadyAetna: Scalars['Boolean']['output'];
  /** If the user has authorized Abound to enroll EFTPS */
  authorizedAboundEftpsEnrollment: Scalars['Boolean']['output'];
  brokerConsent: Scalars['Boolean']['output'];
  /** user id */
  id: Scalars['ID']['output'];
  /** Privacy Screen Checkbox */
  isPrivacyAuthorizeAgree: Scalars['Boolean']['output'];
  /** Privacy Screen Checkbox */
  isPrivacyDataUseAgree: Scalars['Boolean']['output'];
  /** Privacy Screen Checkbox */
  isPrivacyTruthfulAgree: Scalars['Boolean']['output'];
  /** Returns true when user has accepted CATCH_TERMS_OF_USE and CATCH_PRIVACY_POLICY */
  termsAndConditions: Scalars['Boolean']['output'];
  /** Returns true when user has accepted UNIT_DEPOSIT_TERMS_AND_CONDITIONS and UNIT_ELECTRONIC_DISCLOSURES_CONSENT */
  unitAccountDisclosures: Scalars['Boolean']['output'];
};

export type AnnualTaxIncome = {
  __typename?: 'AnnualTaxIncome';
  annualIncomeExplanationRequired: Scalars['Boolean']['output'];
  /** Not sure what this is, we think this is their calculated APTC individual income */
  attestedAnnualizedAPTCIndividualIncomeAmount?: Maybe<Scalars['Dollars']['output']>;
  /** 300 */
  hasReceivedUnemploymentCompensation?: Maybe<Scalars['Boolean']['output']>;
  /** #183, #184 */
  incomeAmount?: Maybe<Scalars['Dollars']['output']>;
  isIncomeLessExplained?: Maybe<Scalars['Boolean']['output']>;
  /** #182 */
  isUnknownIncome?: Maybe<Scalars['Boolean']['output']>;
  /** #181 */
  isVariableIncome?: Maybe<Scalars['Boolean']['output']>;
  taxHouseholdIncomeDifferenceReasonType?: Maybe<Array<TaxIncomeDifferenceReason>>;
  taxHouseholdIncomeDiscrepancyDescriptionText?: Maybe<Scalars['String']['output']>;
  variableIncomeDescriptionText?: Maybe<Scalars['String']['output']>;
};

export type AnnualTaxIncomeInput = {
  /** 300 */
  hasReceivedUnemploymentCompensation?: InputMaybe<Trinary>;
  /** #183, #184 */
  incomeAmount?: InputMaybe<Scalars['Dollars']['input']>;
  isIncomeLessExplained?: InputMaybe<Trinary>;
  /** #182 */
  isUnknownIncome?: InputMaybe<Trinary>;
  /** #181 */
  isVariableIncome?: InputMaybe<Trinary>;
  taxHouseholdIncomeDifferenceReasonType?: InputMaybe<Array<TaxIncomeDifferenceReason>>;
  taxHouseholdIncomeDiscrepancyDescriptionText?: InputMaybe<Scalars['String']['input']>;
  variableIncomeDescriptionText?: InputMaybe<Scalars['String']['input']>;
};

export type AnswerChoice = {
  __typename?: 'AnswerChoice';
  /** answer key */
  id: Scalars['ID']['output'];
  /** the text of the answer */
  text: Scalars['String']['output'];
};

export enum AnswerChoiceType {
  /** provide one or more answers */
  Multiple = 'MULTIPLE',
  /** provide zero or one answers */
  Optional = 'OPTIONAL',
  /** provide zero or more answers */
  OptionalMultiple = 'OPTIONAL_MULTIPLE',
  /** provide one answer */
  Required = 'REQUIRED'
}

/** The input for the AnswerQuestionsForIdentity mutation. */
export type AnswerQuestionsForIdentityInput = {
  answers: Array<QuestionAnswerInput>;
  applicationMemberID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * AnswerQuestionsForIdentityResponse gives back the users ID proof status after the answers
 * have been submitted to Experian.
 */
export type AnswerQuestionsForIdentityResponse = {
  __typename?: 'AnswerQuestionsForIdentityResponse';
  /** DSH Reference Number - the number user must provide to Experian */
  dshReferenceNumber?: Maybe<Scalars['String']['output']>;
  status: IdProofApplicationStatus;
};

export type AnswerQuestionsInput = {
  /** the answers to the questions asked. */
  questionAnswers: Array<QuestionAnswer>;
  /** The ID of the survey that was answered */
  surveyID: Scalars['ID']['input'];
};

export type Answers = {
  __typename?: 'Answers';
  /** If the user has health insurance */
  hasHealthInsurance?: Maybe<Scalars['Boolean']['output']>;
  /** The user's response to our life insurance questions */
  lifeInsuranceAnswer?: Maybe<LifeInsuranceAnswers>;
};

export enum AppPlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export enum ApplicationContext {
  Cic = 'CIC',
  Ebp = 'EBP',
  Fastlink = 'FASTLINK',
  FullApplication = 'FULL_APPLICATION',
  HealthRenew = 'HEALTH_RENEW',
  Slasher = 'SLASHER'
}

export type ApplicationMember = Member & {
  __typename?: 'ApplicationMember';
  /** The app member's age */
  age?: Maybe<Scalars['Int']['output']>;
  annualTaxIncome?: Maybe<AnnualTaxIncome>;
  applicationID?: Maybe<Scalars['ID']['output']>;
  applicationMemberID?: Maybe<Scalars['String']['output']>;
  /** Advanced Premium Tax Credit Eligibility */
  aptcEligibility?: Maybe<Aptc>;
  babyDueQuantity?: Maybe<Scalars['Int']['output']>;
  birthCountry?: Maybe<Scalars['String']['output']>;
  canRequestFullMedicaidDetermination?: Maybe<Scalars['Boolean']['output']>;
  /** Catastrophic eligibility indicator - will be accurate only after app is submitted */
  catastrophicEligibilityIndicator: Scalars['Boolean']['output'];
  /** Children's Health Insurance Plan Eligibility */
  chipEligibility?: Maybe<ChipEligibility>;
  chipWaitingPeriodStatus?: Maybe<ChipWaitingPeriodStatus>;
  chipWaitingPeriodStatusReason?: Maybe<ChipWaitingPeriodStatusReason>;
  citizenshipStatus?: Maybe<CitizenshipStatus>;
  citizenshipStatusReason?: Maybe<CitizenshipStatusReason>;
  /** The contact id that is linked to this application member */
  contactID?: Maybe<Scalars['ID']['output']>;
  /** #11 */
  contactMethod?: Maybe<ContactMethod>;
  coverageEndedReason?: Maybe<CoverageEndedReason>;
  coverageEndedReasonText?: Maybe<Scalars['String']['output']>;
  /** Date coverage was lost, if isLostCoverageLast60Days is true */
  coverageLostDate?: Maybe<Scalars['Date']['output']>;
  /** Date coverage will be lost, if isWillLoseCoverageNext60Days is true */
  coverageLostDateFuture?: Maybe<Scalars['Date']['output']>;
  /** Cost Sharing Reduction Eligibility */
  csrEligibility?: Maybe<Csr>;
  deductions?: Maybe<Array<Deductions>>;
  /** The Dental Enrollment this member is part of */
  dentalEnrollmentGroupID?: Maybe<Scalars['ID']['output']>;
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrollment?: Maybe<HealthInsuranceEnrollment>;
  /** @deprecated Use `healthEnrollmentGroupID` instead */
  enrollmentGroupID?: Maybe<Scalars['ID']['output']>;
  /** #129 */
  ethnicity?: Maybe<Array<Ethnicity>>;
  /** Qualifying Health Plan Exchange Eligibility */
  exchangeEligibility?: Maybe<ExchangeEligibility>;
  familyName?: Maybe<Scalars['String']['output']>;
  /** Their relation to the filer, if applicable */
  filerRelation?: Maybe<Relation>;
  fiveYearBarStatus?: Maybe<FiveYearBarStatus>;
  fiveYearBarStatusReason?: Maybe<FiveYearBarStatusReason>;
  fosterCareEndAge?: Maybe<Scalars['Int']['output']>;
  fosterCareState?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  genderDifferentTermText?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  hasAbsentParent?: Maybe<Scalars['Boolean']['output']>;
  hasCoverage60DaysBeforeMarriage?: Maybe<Scalars['Boolean']['output']>;
  hasCoverageLast60DaysBeforeRelocation?: Maybe<Scalars['Boolean']['output']>;
  hasDeductions: Scalars['Boolean']['output'];
  /** Indicates whether eligibility has changed since the last eligibility call for this member only. Note that if eligibility has not been called before this will return FALSE */
  hasEligibilityChanged: Scalars['Boolean']['output'];
  hasImmigrationStatusFiveYear?: Maybe<Scalars['Boolean']['output']>;
  hasLivedInUS5Years?: Maybe<Scalars['Boolean']['output']>;
  hasLivedOutsideUSLast60DaysBeforeMarriage?: Maybe<Scalars['Boolean']['output']>;
  hasNoAlienNumber?: Maybe<Scalars['Boolean']['output']>;
  /** The Health Enrollment this member is part of */
  healthEnrollmentGroupID?: Maybe<Scalars['ID']['output']>;
  /** Just use Enrollment edge */
  healthInsuranceEnrollmentID?: Maybe<Scalars['ID']['output']>;
  homeAddress?: Maybe<Address>;
  hraOffers?: Maybe<Array<HraOffer>>;
  /** The unique ID for the app member in our system */
  id: Scalars['ID']['output'];
  /** If a previous address is needed for ID Proofing, it should be set here. */
  idProofAddress?: Maybe<Address>;
  idProofApplication?: Maybe<Identity>;
  incarcerationStatus?: Maybe<PreliminaryStatus>;
  incarcerationStatusReason?: Maybe<IncarcerationStatusReason>;
  incarcerationType?: Maybe<IncarcerationType>;
  incomeSources?: Maybe<Array<IncomeSource>>;
  /** #153 */
  incomeThisMonth?: Maybe<Scalars['Boolean']['output']>;
  /** Initial Enrollment Period Eligibility */
  initialEnrollmentEligibility?: Maybe<InitialEnrollmentEligibility>;
  /** #136 */
  isAppliedDuringOeOrLifeChange?: Maybe<Scalars['Boolean']['output']>;
  /** #27 */
  isAttestedHeadOfHousehold?: Maybe<Scalars['Boolean']['output']>;
  /** #131 */
  isBlindOrDisabled?: Maybe<Scalars['Boolean']['output']>;
  isCitizen?: Maybe<Scalars['Boolean']['output']>;
  isClaimingTaxFilerNotOnApplication?: Maybe<Scalars['Boolean']['output']>;
  isClaimsDependent?: Maybe<Scalars['Boolean']['output']>;
  /** maybe #213 */
  isCoverageEnded?: Maybe<Scalars['Boolean']['output']>;
  isCoveredDependentChild?: Maybe<Scalars['Boolean']['output']>;
  isDeniedMedicaidLast90Days?: Maybe<Scalars['Boolean']['output']>;
  /** #191 */
  isEnrolledInHealthCoverage?: Maybe<Scalars['Boolean']['output']>;
  isEnrolledInIchra?: Maybe<Scalars['Boolean']['output']>;
  isFosterCare1825?: Maybe<Scalars['Boolean']['output']>;
  isFullTimeStudentStatus?: Maybe<Scalars['Boolean']['output']>;
  /** #223 */
  isGainDependent?: Maybe<Scalars['Boolean']['output']>;
  isGainedLawfulPresence?: Maybe<Scalars['Boolean']['output']>;
  /** #128 */
  isHispanicOrigin?: Maybe<Scalars['Boolean']['output']>;
  isImmigrationStatusChangeSinceDenied?: Maybe<Scalars['Boolean']['output']>;
  isInfoChangeSinceMedicaidEnded?: Maybe<Scalars['Boolean']['output']>;
  isLawfulPresenceStatus?: Maybe<Scalars['Boolean']['output']>;
  /** #227 */
  isLivedOutsideUsLast60Days?: Maybe<Scalars['Boolean']['output']>;
  /** #132 */
  isLongTermCare?: Maybe<Scalars['Boolean']['output']>;
  /** #213 */
  isLostCoverageLast60Days?: Maybe<Scalars['Boolean']['output']>;
  /** #223 */
  isMarriedLast60Days?: Maybe<Scalars['Boolean']['output']>;
  /** #133 */
  isMedicaidDenied?: Maybe<Scalars['Boolean']['output']>;
  isMedicaidDeniedDueToImmigration?: Maybe<Scalars['Boolean']['output']>;
  isMedicaidDuringFosterCare?: Maybe<Scalars['Boolean']['output']>;
  isMedicaidEnd?: Maybe<Scalars['Boolean']['output']>;
  isMedicaidEndingSoon?: Maybe<Scalars['Boolean']['output']>;
  /** #223 */
  isMoved?: Maybe<Scalars['Boolean']['output']>;
  /** #232 */
  isMovedFromOutsideUs?: Maybe<Scalars['Boolean']['output']>;
  isNaturalizedCitizen?: Maybe<Scalars['Boolean']['output']>;
  /** #223 */
  isNoChanges?: Maybe<Scalars['Boolean']['output']>;
  isNoHomeAddress?: Maybe<Scalars['Boolean']['output']>;
  isOfferedIchra?: Maybe<Scalars['Boolean']['output']>;
  /** Are they a parent?  Defaults to false. */
  isParent: Scalars['Boolean']['output'];
  /** Data was prefilled by the health enrollment agent */
  isPrefill: Scalars['Boolean']['output'];
  /** Are they pregnant?  Defaults to false. */
  isPregnant: Scalars['Boolean']['output'];
  /** #226, #234 */
  isQualifyingCoverageLast60Days?: Maybe<Scalars['Boolean']['output']>;
  /** #223 */
  isReleasedFromIncarceration?: Maybe<Scalars['Boolean']['output']>;
  /** #27 */
  isRequestingCoverage?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If the dependent is requesting that we submit their information for a full
   * medicaid determination following being denied.
   */
  isRequestingMedicaidDetermination?: Maybe<Scalars['Boolean']['output']>;
  /** Are they a smoker?  Defaults to false. */
  isSmoker?: Maybe<Scalars['Boolean']['output']>;
  /** maybe #226 or #234 */
  isStateHealthBenefit?: Maybe<Scalars['Boolean']['output']>;
  isTaxDependent?: Maybe<Scalars['Boolean']['output']>;
  isTaxFiler?: Maybe<Scalars['Boolean']['output']>;
  isTemporaryOutOfState?: Maybe<Scalars['Boolean']['output']>;
  isUnpaidBill?: Maybe<Scalars['Boolean']['output']>;
  isVeteran?: Maybe<Scalars['Boolean']['output']>;
  isVeteranSelf?: Maybe<Scalars['Boolean']['output']>;
  /** #218 */
  isWillLoseCoverageNext60Days?: Maybe<Scalars['Boolean']['output']>;
  /** The last date of regular tobacco use if within the last 6 months */
  lastTobaccoUseDate?: Maybe<Scalars['Date']['output']>;
  lawfulPresenceDocumentation?: Maybe<LawfulPresenceDocumentation>;
  lawfulPresenceGrantDate?: Maybe<Scalars['Date']['output']>;
  mailingAddress?: Maybe<Address>;
  /**
   * #S1
   * @deprecated Use application.maritalStatus as this is a screening question
   */
  maritalStatus?: Maybe<MaritalStatus>;
  /** #134, #140?? TODO: may need another field for this */
  medicaidDeniedDate?: Maybe<Scalars['Date']['output']>;
  /** Medicaid Eligibility */
  medicaidEligibility?: Maybe<MedicaidEligibility>;
  medicaidEndDate?: Maybe<Scalars['Date']['output']>;
  memberStateExchangeFields?: Maybe<MemberStateExchangeFields>;
  /** Metal Level Eligibilities */
  metalLevelOption?: Maybe<MetalLevelOption>;
  middleName?: Maybe<Scalars['String']['output']>;
  mobileNotificationPhoneNumber?: Maybe<Scalars['String']['output']>;
  nameSuffix?: Maybe<NameSuffix>;
  nonMemberVeteranRelationshipTypes: Array<NonMemberVeteranRelationshipType>;
  otherCoverages?: Maybe<Array<OtherCoverage>>;
  /** If ethnicity is OTHER, this value should exist. */
  otherEthnicityText?: Maybe<Scalars['String']['output']>;
  /** If race is OTHER, this value should exist. */
  otherRaceText?: Maybe<Scalars['String']['output']>;
  parent1WeeklyWorkHourQuantity?: Maybe<Scalars['Int']['output']>;
  parent2WeeklyWorkHourQuantity?: Maybe<Scalars['Int']['output']>;
  personTrackingNumber?: Maybe<Scalars['String']['output']>;
  /** The user's ... first phone */
  phone?: Maybe<Phone>;
  /** #215, #220 */
  planName?: Maybe<Scalars['String']['output']>;
  preliminaryAPTCStatus?: Maybe<PreliminaryStatus>;
  preliminaryCHIPStatus?: Maybe<PreliminaryStatus>;
  preliminaryEmergencyMedicaidStatus?: Maybe<PreliminaryStatus>;
  preliminaryEmergencyMedicaidStatusReason?: Maybe<PreliminaryEmergencyMedicaidStatusReason>;
  preliminaryMedicaidStatus?: Maybe<PreliminaryStatus>;
  /** Calculated on the backend based on CMS logic */
  preliminaryQHPStatus?: Maybe<PreliminaryStatus>;
  previousCountyLivedName?: Maybe<Scalars['String']['output']>;
  previousStateCode?: Maybe<Scalars['String']['output']>;
  /** #231 */
  previousZipcode?: Maybe<Scalars['String']['output']>;
  qhpLawfulPresenceStatus?: Maybe<LawfulPresenceStatus>;
  qhpResidencyStatus?: Maybe<PreliminaryStatus>;
  /** #130 */
  race?: Maybe<Array<Race>>;
  /** Their relation to the viewer */
  relation?: Maybe<Relation>;
  /** The user's ... second phone */
  secondaryPhone?: Maybe<Phone>;
  /** Special Enrollment Period Eligibility */
  sepEligibility?: Maybe<SepEligibility>;
  sex?: Maybe<Sex>;
  sexAssignedAtBirth?: Maybe<SexAssignedAtBirth>;
  sexAssignedAtBirthOtherText?: Maybe<Scalars['String']['output']>;
  sexualOrientation?: Maybe<SexualOrientation>;
  sexualOrientationDifferentTermText?: Maybe<Scalars['String']['output']>;
  /** #10 */
  spokenLanguageType?: Maybe<LanguageType>;
  /** Their relation to the spouse, if applicable */
  spouseRelation?: Maybe<Relation>;
  /** Returns the last 4 digits of the user's SSN */
  ssn?: Maybe<Scalars['String']['output']>;
  ssnAlternateName?: Maybe<Name>;
  ssnStatus?: Maybe<SsnStatus>;
  ssnStatusReason?: Maybe<SsnStatusReason>;
  taxReturnFilingStatusType?: Maybe<TaxReturnFilingStatusType>;
  /** Stringified JSON of format {str: bool}: e.g. {'249': true, '192': false, ...} */
  uiQuestionsToDisplay?: Maybe<Scalars['JSON']['output']>;
  /** #229 */
  whenBecomeADependent?: Maybe<Scalars['Date']['output']>;
  /** When member got immigration status */
  whenLawfulPresence?: Maybe<Scalars['Date']['output']>;
  /**
   * #214, #219
   * @deprecated Use `coverageLostDate` or `isWillLoseCoverageNext60Days` instead if they are populated.
   */
  whenLostCoverage?: Maybe<Scalars['Date']['output']>;
  /** #225 */
  whenMarried?: Maybe<Scalars['Date']['output']>;
  /** #235 */
  whenReleasedFromIncarceration?: Maybe<Scalars['Date']['output']>;
  /** #223 */
  whenRelocated?: Maybe<Scalars['Date']['output']>;
  /** #10 */
  writtenLanguageType?: Maybe<LanguageType>;
};

export type ApplicationMemberChangeInput = {
  /** Use like upsert. If updating or removing a member, pass in the ID. Otherwise, assume we are adding the member */
  applicationMember: ApplicationMemberInput;
  /** True if this is for the death of a member, which is handled differently */
  isDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the change causing the user to be removed */
  removeDate?: InputMaybe<Scalars['Date']['input']>;
  /** True if removing the member. Only need to provide ID in the applicationMember for this */
  removeMember?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Reason this user is being removed from the application */
  removeReason?: InputMaybe<RemoveMemberReason>;
};

export type ApplicationMemberInput = {
  /** The health dependent's age */
  age?: InputMaybe<Scalars['Int']['input']>;
  annualTaxIncome?: InputMaybe<AnnualTaxIncomeInput>;
  /** The member_id returned from create_application */
  applicationMemberID?: InputMaybe<Scalars['String']['input']>;
  babyDueQuantity?: InputMaybe<Scalars['Int']['input']>;
  birthCountry?: InputMaybe<Scalars['String']['input']>;
  /** The contact id that is linked to this application member */
  contactID?: InputMaybe<Scalars['ID']['input']>;
  /** #11 */
  contactMethod?: InputMaybe<ContactMethod>;
  coverageEndedReason?: InputMaybe<CoverageEndedReason>;
  coverageEndedReasonText?: InputMaybe<Scalars['String']['input']>;
  coverageLostDate?: InputMaybe<Scalars['Date']['input']>;
  coverageLostDateFuture?: InputMaybe<Scalars['Date']['input']>;
  deductions?: InputMaybe<Array<DeductionsInput>>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** #129 */
  ethnicity?: InputMaybe<Array<Ethnicity>>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  /** Their relation to the filer, if applicable */
  filerRelation?: InputMaybe<Relation>;
  fosterCareEndAge?: InputMaybe<Scalars['Int']['input']>;
  fosterCareState?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  genderDifferentTermText?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hasAbsentParent?: InputMaybe<Trinary>;
  hasCoverage60DaysBeforeMarriage?: InputMaybe<Trinary>;
  hasCoverageLast60DaysBeforeRelocation?: InputMaybe<Trinary>;
  hasDeductions?: InputMaybe<Scalars['Boolean']['input']>;
  hasImmigrationStatusFiveYear?: InputMaybe<Trinary>;
  hasLivedInUS5Years?: InputMaybe<Trinary>;
  hasLivedOutsideUSLast60DaysBeforeMarriage?: InputMaybe<Trinary>;
  hasNoAlienNumber?: InputMaybe<Trinary>;
  healthInsuranceEnrollmentID?: InputMaybe<Scalars['ID']['input']>;
  homeAddress?: InputMaybe<AddressInput>;
  /** Required if isOfferedIchra == YES */
  hraOffers?: InputMaybe<Array<HraOfferInput>>;
  /**
   * If provided, ID will target an existing app member for updating
   *
   * Otherwise, the member will be treated as a new member.
   *
   * When adding a NEW MEMBER, relation is REQUIRED.
   *
   * For anyone that isn't SELF, please link the contact_id to the Contact.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** If a previous address is needed for ID Proofing, it should be set here. */
  idProofAddress?: InputMaybe<AddressInput>;
  incarcerationType?: InputMaybe<IncarcerationType>;
  incomeSources?: InputMaybe<Array<IncomeSourceInput>>;
  /** #153 */
  incomeThisMonth?: InputMaybe<Trinary>;
  /** #136 */
  isAppliedDuringOeOrLifeChange?: InputMaybe<Trinary>;
  /** #27 */
  isAttestedHeadOfHousehold?: InputMaybe<Trinary>;
  /** #131 */
  isBlindOrDisabled?: InputMaybe<Trinary>;
  isCitizen?: InputMaybe<Trinary>;
  isClaimingTaxFilerNotOnApplication?: InputMaybe<Trinary>;
  isClaimsDependent?: InputMaybe<Trinary>;
  /** maybe #213 */
  isCoverageEnded?: InputMaybe<Trinary>;
  isCoveredDependentChild?: InputMaybe<Trinary>;
  isDeniedMedicaidLast90Days?: InputMaybe<Trinary>;
  /** #191 */
  isEnrolledInHealthCoverage?: InputMaybe<Trinary>;
  /** Required if preliminary APTC == True, exchange Eligible, Application hasn't been submitted before */
  isEnrolledInIchra?: InputMaybe<Trinary>;
  isFosterCare1825?: InputMaybe<Trinary>;
  isFullTimeStudentStatus?: InputMaybe<Trinary>;
  /** #223 */
  isGainDependent?: InputMaybe<Trinary>;
  isGainedLawfulPresence?: InputMaybe<Trinary>;
  /** #128 */
  isHispanicOrigin?: InputMaybe<Trinary>;
  isImmigrationStatusChangeSinceDenied?: InputMaybe<Trinary>;
  isInfoChangeSinceMedicaidEnded?: InputMaybe<Trinary>;
  isLawfulPresenceStatus?: InputMaybe<Trinary>;
  /** #227 */
  isLivedOutsideUsLast60Days?: InputMaybe<Trinary>;
  /** #132 */
  isLongTermCare?: InputMaybe<Trinary>;
  /** #213 */
  isLostCoverageLast60Days?: InputMaybe<Trinary>;
  /** #223 */
  isMarriedLast60Days?: InputMaybe<Trinary>;
  /** #133 */
  isMedicaidDenied?: InputMaybe<Trinary>;
  isMedicaidDeniedDueToImmigration?: InputMaybe<Trinary>;
  isMedicaidDuringFosterCare?: InputMaybe<Trinary>;
  isMedicaidEnd?: InputMaybe<Trinary>;
  isMedicaidEndingSoon?: InputMaybe<Trinary>;
  /** #223 */
  isMoved?: InputMaybe<Trinary>;
  /** #232 */
  isMovedFromOutsideUs?: InputMaybe<Trinary>;
  isNaturalizedCitizen?: InputMaybe<Trinary>;
  /** #223 */
  isNoChanges?: InputMaybe<Trinary>;
  isNoHomeAddress?: InputMaybe<Trinary>;
  /** Required if isEnrolledInIchra == NO */
  isOfferedIchra?: InputMaybe<Trinary>;
  /** Are they a parent? */
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are they pregnant? */
  isPregnant?: InputMaybe<Scalars['Boolean']['input']>;
  /** #226, #234 */
  isQualifyingCoverageLast60Days?: InputMaybe<Trinary>;
  /** #223 */
  isReleasedFromIncarceration?: InputMaybe<Trinary>;
  /** #27 */
  isRequestingCoverage?: InputMaybe<Trinary>;
  /**
   * If the member is requesting that we submit their information for a full
   * medicaid determination following being denied.
   */
  isRequestingMedicaidDetermination?: InputMaybe<Trinary>;
  /** Are they a smoker? */
  isSmoker?: InputMaybe<Scalars['Boolean']['input']>;
  /** maybe #226 or #234 */
  isStateHealthBenefit?: InputMaybe<Trinary>;
  isTaxDependent?: InputMaybe<Trinary>;
  isTaxFiler?: InputMaybe<Trinary>;
  isTemporaryOutOfState?: InputMaybe<Trinary>;
  isUnpaidBill?: InputMaybe<Trinary>;
  isVeteran?: InputMaybe<Trinary>;
  isVeteranSelf?: InputMaybe<Trinary>;
  /** #218 */
  isWillLoseCoverageNext60Days?: InputMaybe<Trinary>;
  /** The last date of regular tobacco use if within the last 6 months */
  lastTobaccoUseDate?: InputMaybe<Scalars['Date']['input']>;
  lawfulPresenceDocumentation?: InputMaybe<LawfulPresenceDocumentationInput>;
  lawfulPresenceGrantDate?: InputMaybe<Scalars['Date']['input']>;
  mailingAddress?: InputMaybe<AddressInput>;
  /** #134, #140?? TODO: may need another field for this */
  medicaidDeniedDate?: InputMaybe<Scalars['Date']['input']>;
  /** Must be populated if isMedicaidEnd is YES */
  medicaidEndDate?: InputMaybe<Scalars['Date']['input']>;
  memberStateExchangeFields?: InputMaybe<MemberStateExchangeFieldsInput>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobileNotificationPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<NameSuffix>;
  nonMemberVeteranRelationshipTypes?: InputMaybe<Array<NonMemberVeteranRelationshipType>>;
  otherCoverages?: InputMaybe<Array<OtherCoverageInput>>;
  /** If the person selected OTHER as their ethnicity, we should fill this in. */
  otherEthnicityText?: InputMaybe<Scalars['String']['input']>;
  /** If the person selected OTHER as their race, we should fill this in */
  otherRaceText?: InputMaybe<Scalars['String']['input']>;
  parent1WeeklyWorkHourQuantity?: InputMaybe<Scalars['Int']['input']>;
  parent2WeeklyWorkHourQuantity?: InputMaybe<Scalars['Int']['input']>;
  personTrackingNumber?: InputMaybe<Scalars['String']['input']>;
  /** The user's ... first phone */
  phone?: InputMaybe<PhoneInput>;
  /** #215, #220 */
  planName?: InputMaybe<Scalars['String']['input']>;
  previousCountyLivedName?: InputMaybe<Scalars['String']['input']>;
  previousStateCode?: InputMaybe<Scalars['String']['input']>;
  /** #231 */
  previousZipcode?: InputMaybe<Scalars['String']['input']>;
  /** #130 */
  race?: InputMaybe<Array<Race>>;
  /** Their relation to the viewer. This is required when adding a NEW MEMBER */
  relation?: InputMaybe<Relation>;
  /** The user's ... second phone */
  secondaryPhone?: InputMaybe<PhoneInput>;
  sex?: InputMaybe<Sex>;
  sexAssignedAtBirth?: InputMaybe<SexAssignedAtBirth>;
  sexAssignedAtBirthOtherText?: InputMaybe<Scalars['String']['input']>;
  sexualOrientation?: InputMaybe<SexualOrientation>;
  sexualOrientationDifferentTermText?: InputMaybe<Scalars['String']['input']>;
  /** #10 */
  spokenLanguageType?: InputMaybe<LanguageType>;
  /** Their relation to the spouse, if applicable */
  spouseRelation?: InputMaybe<Relation>;
  /** Returns the last 4 digits of the user's SSN */
  ssn?: InputMaybe<Scalars['String']['input']>;
  ssnAlternateName?: InputMaybe<NameInput>;
  taxReturnFilingStatusType?: InputMaybe<TaxReturnFilingStatusType>;
  /** #229 */
  whenBecomeADependent?: InputMaybe<Scalars['Date']['input']>;
  /** When member got immigration status */
  whenLawfulPresence?: InputMaybe<Scalars['Date']['input']>;
  /** #214, #219 */
  whenLostCoverage?: InputMaybe<Scalars['Date']['input']>;
  /** #225 */
  whenMarried?: InputMaybe<Scalars['Date']['input']>;
  /** #235 */
  whenReleasedFromIncarceration?: InputMaybe<Scalars['Date']['input']>;
  /** #223 */
  whenRelocated?: InputMaybe<Scalars['Date']['input']>;
  /** #10 */
  writtenLanguageType?: InputMaybe<LanguageType>;
};

export enum ApplicationOrigin {
  Catch = 'CATCH',
  Ebp = 'EBP',
  Import = 'IMPORT',
  LinkStrict = 'LINK_STRICT'
}

export enum ApplicationPeriodType {
  Oep = 'OEP',
  Sep = 'SEP'
}

export enum ApplicationPhase {
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO'
}

export enum ApplicationSource {
  Email = 'EMAIL',
  Fax = 'FAX',
  InPerson = 'IN_PERSON',
  Mail = 'MAIL',
  Phone = 'PHONE'
}

export type ApplicationStateExchangeFields = {
  __typename?: 'ApplicationStateExchangeFields';
  applicationSource?: Maybe<ApplicationSource>;
};

export type ApplicationStateExchangeFieldsInput = {
  applicationSource?: InputMaybe<ApplicationSource>;
};

export type ApplicationSummary = {
  __typename?: 'ApplicationSummary';
  applicationStatus: HealthApplicationStatus;
  coverageYearNumber: Scalars['Int']['output'];
  dmiIndicator: Scalars['Boolean']['output'];
  insuranceApplicationIdentifier: Scalars['String']['output'];
  pdmIndicator: Scalars['Boolean']['output'];
  sepEligibility: Scalars['Boolean']['output'];
  sepEnd?: Maybe<Scalars['Date']['output']>;
  sepStart?: Maybe<Scalars['Date']['output']>;
  sepType: SepType;
};

export type ApplicationsInput = {
  coverageYearNumber?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<HealthApplicationStatus>>;
};

/** ApproveGoalInput is used in the approveIncome mutation */
export type ApproveGoalInput = {
  /**
   * This corresponds to the IncomeTransactionGoalBreakdownID.
   * Clients should have this ID to reference the goal breakdown.
   * For example, a client might query incomeTransactions, receive back a list of
   * income transactions, which contain goal breakdowns, which have IDs.
   * These are the IDs to use here.
   */
  incomeTransactionGoalBreakdownID: Scalars['ID']['input'];
  /** If the allocation towards the individual goal is approved */
  isApproved: Scalars['Boolean']['input'];
};

/** ApproveIncomeInput is the input to the approveIncome mutation */
export type ApproveIncomeInput = {
  /** Individual goal approvals. These should always be passed, even if they aren't modified. */
  goalApprovals?: InputMaybe<Array<ApproveGoalInput>>;
  /**
   * Whether or not the entire transaction has been approved
   * Note that this should only be set to false if the *ENTIRE* income transaction
   * is going to be not be approved.
   * Otherwise, set the individual `isApproved` in the ApproveGoalInputs to be
   * false, and leave this flag set to true.
   */
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * isSkipped denotes that the Income Transaction is to be skipped, rather than
   * being designated as not income.
   *
   * Note that setting isSkipped to true takes precendence over the `isApproved`
   * flag: if `isSkipped` is True, the income transaction _will be skipped_.
   */
  isSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The type of income this paycheck represents
   * This *must* be populated in the instance of the `isApproved` field being true
   * - an error will be thrown otherwise.
   */
  paycheckType?: InputMaybe<PaycheckType>;
  /** Which income transaction to target */
  transactionID: Scalars['ID']['input'];
};

export enum AssistorType {
  AssistorTypeAgentBroker = 'ASSISTOR_TYPE_AGENT_BROKER',
  AssistorTypeCertifiedApplicationCounselor = 'ASSISTOR_TYPE_CERTIFIED_APPLICATION_COUNSELOR',
  AssistorTypeInPersonAssistantPersonnel = 'ASSISTOR_TYPE_IN_PERSON_ASSISTANT_PERSONNEL',
  AssistorTypeNavigator = 'ASSISTOR_TYPE_NAVIGATOR',
  AssistorTypeNoAssistance = 'ASSISTOR_TYPE_NO_ASSISTANCE'
}

export enum AsyncStatus {
  CompletedHasDmi = 'COMPLETED_HAS_DMI',
  CompletedNoDmi = 'COMPLETED_NO_DMI',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING'
}

export enum AuthorizationRole {
  Admin = 'ADMIN',
  Support = 'SUPPORT'
}

export enum AutomationType {
  Always = 'ALWAYS',
  Never = 'NEVER',
  Sometimes = 'SOMETIMES'
}

export type AutopilotRuleAddedEvent = Event & {
  __typename?: 'AutopilotRuleAddedEvent';
  automationType: AutomationType;
  /** The ID of the event */
  id: Scalars['ID']['output'];
  source?: Maybe<IncomeTransactionSource>;
  subtag?: Maybe<Scalars['String']['output']>;
  time: Scalars['Time']['output'];
  workType: WorkType;
};

export type AutopilotRulePausedEvent = Event & {
  __typename?: 'AutopilotRulePausedEvent';
  automationType: AutomationType;
  /** The ID of the event */
  id: Scalars['ID']['output'];
  source?: Maybe<IncomeTransactionSource>;
  subtag?: Maybe<Scalars['String']['output']>;
  time: Scalars['Time']['output'];
  workType: WorkType;
};

export type AutopilotRuleRemovedEvent = Event & {
  __typename?: 'AutopilotRuleRemovedEvent';
  automationType: AutomationType;
  /** The ID of the event */
  id: Scalars['ID']['output'];
  source?: Maybe<IncomeTransactionSource>;
  subtag?: Maybe<Scalars['String']['output']>;
  time: Scalars['Time']['output'];
  workType: WorkType;
};

export type AutopilotRuleResumedEvent = Event & {
  __typename?: 'AutopilotRuleResumedEvent';
  automationType: AutomationType;
  /** The ID of the event */
  id: Scalars['ID']['output'];
  source?: Maybe<IncomeTransactionSource>;
  subtag?: Maybe<Scalars['String']['output']>;
  time: Scalars['Time']['output'];
  workType: WorkType;
};

export type BankStatement = Statement & {
  __typename?: 'BankStatement';
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  totalPages: Scalars['Int']['output'];
};

/** BaseUser provides basic user information */
export type BaseUser = {
  __typename?: 'BaseUser';
  /** base64 string of the person avatar */
  avatarImage?: Maybe<Scalars['String']['output']>;
  /** The user's email address */
  email?: Maybe<Scalars['String']['output']>;
  /** The user's last name */
  familyName?: Maybe<Scalars['String']['output']>;
  /** The user's first name */
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The user's preferred name */
  nickname?: Maybe<Scalars['String']['output']>;
};

export type Beneficiary = {
  __typename?: 'Beneficiary';
  dob: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  relationship: BeneficiaryRelationship;
  sharePercentage: Scalars['Float']['output'];
  ssn: Scalars['String']['output'];
  suffix?: Maybe<BeneficiarySuffix>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BeneficiaryInput = {
  dob: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  relationship: BeneficiaryRelationship;
  sharePercentage: Scalars['Float']['input'];
  ssn: Scalars['String']['input'];
  suffix?: InputMaybe<BeneficiarySuffix>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum BeneficiaryRelationship {
  Other = 'OTHER',
  Spouse = 'SPOUSE'
}

export enum BeneficiarySuffix {
  Ii = 'II',
  Iii = 'III',
  Iv = 'IV',
  Jr = 'JR',
  Sr = 'SR'
}

export type Benefits = {
  __typename?: 'Benefits';
  costSharings: Array<CostSharing>;
  covered: Scalars['Boolean']['output'];
  explanation: Scalars['String']['output'];
  hasLimits: Scalars['Boolean']['output'];
  limitQuantity: Scalars['Int']['output'];
  limitUnit: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BlogMainImage = {
  __typename?: 'BlogMainImage';
  url: Scalars['String']['output'];
};

export type BlogPost = {
  __typename?: 'BlogPost';
  isArchived: Scalars['Boolean']['output'];
  isDraft: Scalars['Boolean']['output'];
  mainImage?: Maybe<BlogMainImage>;
  slug: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type BlogPosts = {
  __typename?: 'BlogPosts';
  posts: Array<BlogPost>;
  total: Scalars['Int']['output'];
};

/** DEPRECATED */
export type BlogReference = {
  __typename?: 'BlogReference';
  /** blogPosts gets our blog posts through the webflow API. Returns the latest 5 posts. */
  blogPosts: BlogPosts;
};

export type ChipEligibility = {
  __typename?: 'CHIPEligibility';
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export enum ChipWaitingPeriodStatus {
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  Temp = 'TEMP',
  Yes = 'YES'
}

export enum ChipWaitingPeriodStatusReason {
  /** 657 */
  ApplicantNotPrelimChipEligible = 'APPLICANT_NOT_PRELIM_CHIP_ELIGIBLE',
  /** 551 */
  ApplicationNotRequestingFa = 'APPLICATION_NOT_REQUESTING_FA',
  /** 670 */
  AptcInelgblDidNotAgreeToMdcaidChipLegalAttestations = 'APTC_INELGBL_DID_NOT_AGREE_TO_MDCAID_CHIP_LEGAL_ATTESTATIONS',
  /** 139 */
  ChipWaitingPeriodInEffect = 'CHIP_WAITING_PERIOD_IN_EFFECT',
  /** 652 */
  NotPrelimMedicaidOrPrelimChipEligible = 'NOT_PRELIM_MEDICAID_OR_PRELIM_CHIP_ELIGIBLE',
  /** 555 */
  NARuleDoesNotApply = 'N_A_RULE_DOES_NOT_APPLY',
  /** 999 */
  NARuleIndicatorIsY = 'N_A_RULE_INDICATOR_IS_Y'
}

export type Csr = {
  __typename?: 'CSR';
  change?: Maybe<EligibilityChange>;
  csrLevel?: Maybe<CsrLevel>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export enum CsrLevel {
  None = 'NONE',
  Silver_73Av = 'SILVER_73AV',
  Silver_87Av = 'SILVER_87AV',
  Silver_94Av = 'SILVER_94AV',
  TribeAbove_300Fpl = 'TRIBE_ABOVE_300_FPL',
  TribeBelow_300Fpl = 'TRIBE_BELOW_300_FPL'
}

/** CancelTaxPaymentInput is the input to the CancelTaxPayment mutation. */
export type CancelTaxPaymentInput = {
  /** The person id of the owner of the tax payment */
  personID: Scalars['ID']['input'];
  /** the ID of the tax payment. */
  taxPaymentID: Scalars['ID']['input'];
};

export enum Carrier {
  Aetna = 'AETNA',
  InnovationHealth = 'INNOVATION_HEALTH'
}

/** DEPRECATED */
export type CatchFeature = {
  __typename?: 'CatchFeature';
  chargesBillingAccount: Scalars['Boolean']['output'];
  fees: Array<CatchFee>;
  isLive: Scalars['Boolean']['output'];
  isPaidFeature: Scalars['Boolean']['output'];
  /** Controls how frontend displays item if user has a associated benefit. If it is set to False this means it is not shown unless the user has a the benefit. */
  isVisibleByDefault: Scalars['Boolean']['output'];
  type: CatchFeatureType;
};

export enum CatchFeatureType {
  CatchFeatureAutopilot = 'CATCH_FEATURE_AUTOPILOT',
  CatchFeatureMultipleBankLinks = 'CATCH_FEATURE_MULTIPLE_BANK_LINKS',
  CatchFeatureRetirement = 'CATCH_FEATURE_RETIREMENT',
  CatchFeatureTaxPayment = 'CATCH_FEATURE_TAX_PAYMENT',
  CatchFeatureVideoOnboarding = 'CATCH_FEATURE_VIDEO_ONBOARDING'
}

/** DEPRECATED */
export type CatchFee = {
  __typename?: 'CatchFee';
  /** Display text associated with the source. */
  description: Scalars['String']['output'];
  /** The amount of the fee */
  fee: Scalars['Dollars']['output'];
  /** The frequency of the fee */
  frequency: CatchFeeFrequency;
  /** This ID represents the CatchFee */
  id: Scalars['ID']['output'];
  /** The type of fee */
  type: CatchFeeTypes;
};

export enum CatchFeeFrequency {
  AnnualFee = 'ANNUAL_FEE',
  MonthlyFee = 'MONTHLY_FEE',
  SingleFee = 'SINGLE_FEE'
}

export type CatchFeePaymentEvent = Event & {
  __typename?: 'CatchFeePaymentEvent';
  /** The associated transfer */
  achTransfer?: Maybe<AchTransfer>;
  amount: Scalars['Dollars']['output'];
  feeType: CatchFeeTypes;
  /** The ID of CatchFeePayment */
  id: Scalars['ID']['output'];
  numAttempts: Scalars['Int']['output'];
  status: TransferEventStatus;
  time: Scalars['Time']['output'];
};

/** DEPRECATED */
export type CatchFeeSubscription = {
  __typename?: 'CatchFeeSubscription';
  /** Indicates when this subscription is set to be canceled due to a delinquent payment. Only exists if in delinquent status */
  delinquentWindowEndDate?: Maybe<Scalars['Date']['output']>;
  /** Indicates when this subscription is set to renew or end. Will reset if renewed */
  endDate?: Maybe<Scalars['Date']['output']>;
  featureType: CatchFeatureType;
  frequency: CatchFeeFrequency;
  /** Indicates whether a delinquent payment has been retried, only valid in a delinquent status */
  hasRetried: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Indicates if a subscription is still pending for any reason and thus not being charged yet - hasn't link bank, etc */
  isPendingActivation: Scalars['Boolean']['output'];
  /** The person who owns this subscription */
  person: User;
  /** Indicates when this subscription started. Will reset if stopped then started again */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** Indicates the status of this subscription */
  status: CatchSubscriptionStatus;
  type?: Maybe<CatchFeeTypes>;
};

export type CatchFeeSubscriptionsConnection = {
  __typename?: 'CatchFeeSubscriptionsConnection';
  edges: Array<CatchSubscription>;
  pageInfo: PageInfo;
};

export enum CatchFeeTypes {
  AutopilotFee = 'AUTOPILOT_FEE',
  MultipleBankLinksFee = 'MULTIPLE_BANK_LINKS_FEE',
  PremiumPaymentFee = 'PREMIUM_PAYMENT_FEE',
  RetirementFee = 'RETIREMENT_FEE',
  TaxPaymentFee = 'TAX_PAYMENT_FEE',
  VideoOnboardingFee = 'VIDEO_ONBOARDING_FEE'
}

export type CatchPaidFeature = {
  __typename?: 'CatchPaidFeature';
  chargesBillingAccount: Scalars['Boolean']['output'];
  fees: Array<CatchFee>;
  isLive: Scalars['Boolean']['output'];
  /** Controls how frontend displays item if user has a associated benefit. If it is set to False this means it is not shown unless the user has a the benefit. */
  isVisibleByDefault: Scalars['Boolean']['output'];
  type: CatchPaidFeatureType;
};

export enum CatchPaidFeatureType {
  CatchPaidFeatureAutopilot = 'CATCH_PAID_FEATURE_AUTOPILOT',
  CatchPaidFeatureMultipleBankLinks = 'CATCH_PAID_FEATURE_MULTIPLE_BANK_LINKS',
  CatchPaidFeatureRetirement = 'CATCH_PAID_FEATURE_RETIREMENT',
  CatchPaidFeatureTaxPayment = 'CATCH_PAID_FEATURE_TAX_PAYMENT',
  CatchPaidFeatureVideoOnboarding = 'CATCH_PAID_FEATURE_VIDEO_ONBOARDING'
}

/** DEPRECATED */
export type CatchSubscription = {
  __typename?: 'CatchSubscription';
  /** Indicates when this subscription is set to be canceled due to a delinquent payment. Only exists if in delinquent status */
  delinquentWindowEndDate?: Maybe<Scalars['Date']['output']>;
  /** Indicates when this subscription is set to renew or end. Will reset if renewed */
  endDate?: Maybe<Scalars['Date']['output']>;
  featureType: CatchFeatureType;
  frequency: CatchFeeFrequency;
  /** Indicates whether a delinquent payment has been retried, only valid in a delinquent status */
  hasRetried: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Indicates if a subscription is still pending for any reason and thus not being charged yet - hasn't link bank, etc */
  isPendingActivation: Scalars['Boolean']['output'];
  /** The person who owns this subscription */
  person: User;
  /** Indicates when this subscription started. Will reset if stopped then started again */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** Indicates the status of this subscription */
  status: CatchSubscriptionStatus;
  type?: Maybe<CatchFeeTypes>;
};

export enum CatchSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Delinquent = 'DELINQUENT',
  /** @deprecated Subscriptions v2, will be set to INACTIVE */
  Expiring = 'EXPIRING',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

export type CatchSubscriptionsConnection = {
  __typename?: 'CatchSubscriptionsConnection';
  edges: Array<CatchSubscription>;
  pageInfo: PageInfo;
};

export type CatchTask = {
  __typename?: 'CatchTask';
  assignee?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isAssignment: Scalars['Boolean']['output'];
  priority?: Maybe<TaskPriority>;
  type: TaskType;
};

/** Automate saving income using rules. */
export type CatchTransactionTag = {
  __typename?: 'CatchTransactionTag';
  id: Scalars['ID']['output'];
  /** Image that represents the source of the income. It is often the company's logo. */
  logo: Image;
  /** Describes the string that is used to identify transactions as income. */
  name: Scalars['String']['output'];
};

/** CatchTransactionTagConnection is a connection to a list of CatchTransactionTags */
export type CatchTransactionTagConnection = {
  __typename?: 'CatchTransactionTagConnection';
  edges: Array<CatchTransactionTag>;
  pageInfo: PageInfo;
};

/** The different types of challenges a bank might provided for setting up a banklink */
export enum ChallengeType {
  /** A list of choices for the user to select from */
  Choices = 'CHOICES',
  /** A challenge that has an image to display */
  Image = 'IMAGE',
  /** There are multiple images to display and the user should select one */
  ImageChoices = 'IMAGE_CHOICES',
  /** this is deprecated in the Quovo documentation, adding support as it's currently required in one of the workflows */
  Prerealtime = 'PREREALTIME',
  /** A question the user must answer */
  Questions = 'QUESTIONS',
  /** A challenge that has a certain time window in which is must be answered, or it will expire */
  Realtime = 'REALTIME'
}

export enum ChangeAliasError {
  /** another user already has this alias */
  ChangeAliasErrorAliasInUse = 'CHANGE_ALIAS_ERROR_ALIAS_IN_USE',
  /** alias invalid format - expects XXX-XXX-XXXX for phone */
  ChangeAliasErrorInvalidAlias = 'CHANGE_ALIAS_ERROR_INVALID_ALIAS',
  /** alias not provided or empty string */
  ChangeAliasErrorMissingAlias = 'CHANGE_ALIAS_ERROR_MISSING_ALIAS',
  /** user is trying to change their alias to the same thing */
  ChangeAliasErrorSameAlias = 'CHANGE_ALIAS_ERROR_SAME_ALIAS'
}

/** ChangeEmail sets up the MFA flow for a user to change their email */
export type ChangeEmailInput = {
  email: Scalars['String']['input'];
};

export type ChangeEmailResponse = {
  __typename?: 'ChangeEmailResponse';
  error?: Maybe<ChangeAliasError>;
  newEmail?: Maybe<Scalars['String']['output']>;
};

/** ChangeGoalBreakdownInput is used in the updateIncomeTransaction mutation */
export type ChangeGoalBreakdownInput = {
  dollarAmount?: InputMaybe<Scalars['Dollars']['input']>;
  /**
   * This corresponds to the IncomeTransactionGoalBreakdownID.
   * Clients should have this ID to reference the goal breakdown.
   * For example, a client might query incomeTransactions, receive back a list of
   * income transactions, which contain goal breakdowns, which have IDs.
   * These are the IDs to use here.
   *
   * If skipping, set the isSkipped flag to True. If any amount is passed in here
   * for whatever reason, it will be ignored.
   *
   * Otherwise, set it to False, and you must pass amount of the goal breakdown to
   * update to. Can either be a percentage or a dollar amount.
   * If both are passed in for whatever reason we'll use the Dollar amount.
   *
   * If there is no change being made, simply set isSkipped to False. The
   * percentage and dollar amount will stay the same.
   */
  incomeTransactionGoalBreakdownID: Scalars['ID']['input'];
  isSkipped: Scalars['Boolean']['input'];
  percentageAmount?: InputMaybe<Scalars['Float']['input']>;
};

/** ChangePhone sets up the MFA flow for a user to change their phone */
export type ChangePhoneInput = {
  /** Phone must be of input XXX-XXX-XXXX */
  phone: Scalars['String']['input'];
};

export type ChangePhoneResponse = {
  __typename?: 'ChangePhoneResponse';
  error?: Maybe<ChangeAliasError>;
  newPhone?: Maybe<Scalars['String']['output']>;
};

/** The input for the CheckIdentity mutation. */
export type CheckIdentityInput = {
  response: Array<IdResponse>;
};

/**
 * CheckIdentityResponse gives back the users Identity after the answers
 * have been submitted to Experian.
 */
export type CheckIdentityResponse = {
  __typename?: 'CheckIdentityResponse';
  identity: Identity;
};

export enum CitizenshipStatus {
  Delay = 'DELAY',
  Error = 'ERROR',
  Hold = 'HOLD',
  HubCallCompleted = 'HUB_CALL_COMPLETED',
  Inconsistent = 'INCONSISTENT',
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING',
  Temporary = 'TEMPORARY',
  Yes = 'YES'
}

export enum CitizenshipStatusReason {
  /** 685 */
  ApplicationPushedToStep_2ButHubCallFailed = 'APPLICATION_PUSHED_TO_STEP_2_BUT_HUB_CALL_FAILED',
  /** 684 */
  ApplicationRequiresStep_3 = 'APPLICATION_REQUIRES_STEP_3',
  /** 531 */
  AtstdNonCitizen = 'ATSTD_NON_CITIZEN',
  /** 398 */
  AtstdToSaveNonVerifiableStatus = 'ATSTD_TO_SAVE_NON_VERIFIABLE_STATUS',
  /** 177 */
  CitizenshipNotVerified = 'CITIZENSHIP_NOT_VERIFIED',
  /** 456 */
  DataSourceNotCalledDueToFailedIdProof = 'DATA_SOURCE_NOT_CALLED_DUE_TO_FAILED_ID_PROOF',
  /** 187 */
  DeathDataPresent = 'DEATH_DATA_PRESENT',
  /** 635 */
  DhsBirthdateMismatch = 'DHS_BIRTHDATE_MISMATCH',
  /** 189 */
  DhsDataNotMatchAttestation = 'DHS_DATA_NOT_MATCH_ATTESTATION',
  /** 636 */
  DhsDocumentNumberMismatch = 'DHS_DOCUMENT_NUMBER_MISMATCH',
  /** 395 */
  DidNotAttestToNaturalizedCitizenshipOrLp = 'DID_NOT_ATTEST_TO_NATURALIZED_CITIZENSHIP_OR_LP',
  /** 397 */
  DidNotProvideSsnWithCitizenshipAttestation = 'DID_NOT_PROVIDE_SSN_WITH_CITIZENSHIP_ATTESTATION',
  /** 432 */
  DmiResolvedByEswAdjudication = 'DMI_RESOLVED_BY_ESW_ADJUDICATION',
  /** 191 */
  EdsNotAvailable = 'EDS_NOT_AVAILABLE',
  /** 477 */
  EswExpiredAnotherDmiSoInelgble = 'ESW_EXPIRED_ANOTHER_DMI_SO_INELGBLE',
  /** 476 */
  EswExpiredDm = 'ESW_EXPIRED_DM',
  /** 465 */
  HubCallReturnedTransactionalError = 'HUB_CALL_RETURNED_TRANSACTIONAL_ERROR',
  /** 341 */
  HubDidNotRespond = 'HUB_DID_NOT_RESPOND',
  /** 560 */
  IndividualNotRequestingCoverage = 'INDIVIDUAL_NOT_REQUESTING_COVERAGE',
  /** 399 */
  NotEnoughInfoProvidedToVerifyElgblLpStatus = 'NOT_ENOUGH_INFO_PROVIDED_TO_VERIFY_ELGBL_LP_STATUS',
  /** 464 */
  NotEnoughInfoToVerifyNaturalizedCitizenship = 'NOT_ENOUGH_INFO_TO_VERIFY_NATURALIZED_CITIZENSHIP',
  /** 568 */
  NotVerifiedPendingPaperVerification = 'NOT_VERIFIED_PENDING_PAPER_VERIFICATION',
  /** 559 */
  NoCitizenshipAttestation = 'NO_CITIZENSHIP_ATTESTATION',
  /** 227 */
  NoEdsDataFound = 'NO_EDS_DATA_FOUND',
  /** 352 */
  NoSsnProvided = 'NO_SSN_PROVIDED',
  /** 999 */
  NA = 'N_A',
  /** 714 */
  NAQhpStoppedByOfflineProcess = 'N_A_QHP_STOPPED_BY_OFFLINE_PROCESS',
  /** 555 */
  NARuleDoesNotApply = 'N_A_RULE_DOES_NOT_APPLY',
  /** 999 */
  NARuleIndicatorIsY = 'N_A_RULE_INDICATOR_IS_Y',
  /** 634 */
  SsaDataMismatch = 'SSA_DATA_MISMATCH',
  /** 573 */
  SsaHubCallHeldCallCounter_3OrMore = 'SSA_HUB_CALL_HELD_CALL_COUNTER_3_OR_MORE',
  /** 288 */
  SsnNotVerified = 'SSN_NOT_VERIFIED',
  /** 400 */
  VerifiedStatusNotCitizenOrLawfullyPresentOrQualifiedNonCitizen = 'VERIFIED_STATUS_NOT_CITIZEN_OR_LAWFULLY_PRESENT_OR_QUALIFIED_NON_CITIZEN'
}

export enum ClosedReasonEnum {
  Affordability = 'AFFORDABILITY',
  Cobra = 'COBRA',
  EmployerCoverage = 'EMPLOYER_COVERAGE',
  IchraReferral = 'ICHRA_REFERRAL',
  IncompleteApplication = 'INCOMPLETE_APPLICATION',
  Medicaid = 'MEDICAID',
  MedicareReferral = 'MEDICARE_REFERRAL',
  NotEligibleOther = 'NOT_ELIGIBLE_OTHER',
  NotInterestedAfterIntake = 'NOT_INTERESTED_AFTER_INTAKE',
  NoResponseOrIntake = 'NO_RESPONSE_OR_INTAKE',
  NoSep = 'NO_SEP',
  Other = 'OTHER',
  OtherReferral = 'OTHER_REFERRAL',
  PeoReferral = 'PEO_REFERRAL'
}

/** Code is a referral or access code */
export type Code = {
  __typename?: 'Code';
  /**
   * the reward related to a valid code
   * This field will be not null if valid is true and null if valid is false.
   */
  reward?: Maybe<Reward>;
  /**
   * determines if the code is valid.
   * If it is, the reward field will not be null
   * If it is not, the reward field will be null
   */
  valid: Scalars['Boolean']['output'];
};

export enum CommissionStatus {
  BinderPaid = 'BINDER_PAID',
  CommissionEarned = 'COMMISSION_EARNED',
  Unknown = 'UNKNOWN'
}

export enum ConciergeType {
  Chat = 'CHAT',
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export enum ConfidenceLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/**
 * ConfirmIdentityResponse get the applicant's status in the ID Proof process.
 * If the applicant has to go though more steps to complete ID proofing, it will
 * return...
 * questions - if the user needs to answer questions from experian (status=QUESTIONS)
 * error - if the user needs to correct data (no status)
 * retryAfter - if the user had a timeout error in the id proof process, this (status=TIMEOUT)
 * date represents when the user can try to ID proof again
 * dshReferenceNumber - number the user must use when they call experian (status=PENDING_FARS)
 *
 * otherwise, status will be:
 * GOOD - The user completed ID proofing successfull
 * DENIED - The user identity was rejected
 * STUCK - The user cannot be ID proofed in our platform and will likely need to contact Catch support
 */
export type ConfirmIdentityResponse = {
  __typename?: 'ConfirmIdentityResponse';
  /** DSH Reference Number - the number user must provide to Experian */
  dshReferenceNumber?: Maybe<Scalars['String']['output']>;
  /** Data that must be fixed by user */
  error?: Maybe<IdProofErrorCode>;
  idStatus?: Maybe<IdentityStatus>;
  /** Questions the user must answer */
  questions?: Maybe<Array<VerificationQuestion>>;
  /** Date to retry to confirm the user's identity */
  retryAfter?: Maybe<Scalars['Time']['output']>;
  /**
   * Describes the applicants progress in ID Proofing
   * @deprecated Use ConfirmIdentityResponse.idStatus instead for status that maps directly to new standalone Identity
   */
  status?: Maybe<IdProofApplicationStatus>;
};

/**
 * ConfirmVerifiedOfflineResponse contains the most recent and current IDApplicationStatus
 * of the applicant, and is a response from the ConfirmVerifiedOffline mutation.
 */
export type ConfirmVerifiedOfflineResponse = {
  __typename?: 'ConfirmVerifiedOfflineResponse';
  idStatus: IdentityStatus;
  /** @deprecated Use ConfirmIdentityResponse.idStatus instead for status that maps directly to new standalone Identity */
  status: IdProofApplicationStatus;
};

export type ConsentRequest = {
  __typename?: 'ConsentRequest';
  agreedAt?: Maybe<Scalars['Time']['output']>;
  consentType: ConsentType;
  createdOn: Scalars['Time']['output'];
  expiresAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isAgreed: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  person: Person;
  sentAt?: Maybe<Scalars['Time']['output']>;
  status: ConsentStatus;
  token: Scalars['String']['output'];
};

export enum ConsentStatus {
  Agreed = 'AGREED',
  Expired = 'EXPIRED',
  Ready = 'READY'
}

export enum ConsentType {
  Broker = 'BROKER'
}

export enum ConsolidatedIssueStatus {
  /** The DMI requires action to fix. */
  ActionNeeded = 'ACTION_NEEDED',
  /** The DMI is complete - either for good or bad. */
  Complete = 'COMPLETE',
  /** The DMI is expired. */
  Expired = 'EXPIRED',
  /** The DMI is in the process of being acted on. */
  Processing = 'PROCESSING'
}

/** DEPRECATED */
export type Contact = {
  __typename?: 'Contact';
  /** base64 string of the person avatar */
  avatarImage?: Maybe<Scalars['String']['output']>;
  /** Date the person was created. If it doesn't have a created_on, it means that it's really old */
  createdOn?: Maybe<Scalars['Time']['output']>;
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName: Scalars['String']['output'];
  /** The full social security number */
  fullSSN?: Maybe<Scalars['String']['output']>;
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isTaxDependent: Scalars['Boolean']['output'];
  isTrustedContact: Scalars['Boolean']['output'];
  /** The Person's legal address */
  legalAddress?: Maybe<Address>;
  /** The Person's mailing address */
  mailingAddress?: Maybe<Address>;
  middleName?: Maybe<Scalars['String']['output']>;
  namePrefix?: Maybe<Scalars['String']['output']>;
  nameSuffix?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Relationship to the person who manages the Catch Account. */
  relation: Relation;
  /** The Person's biological sex. Used for things such as health care. */
  sex?: Maybe<Sex>;
  /** The last 4 digits of a person's social security number */
  ssn?: Maybe<Scalars['String']['output']>;
};

export type ContactDetails = {
  email?: InputMaybe<Scalars['String']['input']>;
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  relation: Relation;
};

export type ContactInput = {
  dob?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The Person's legal address */
  legalAddress?: InputMaybe<AddressInput>;
  /** The Person's mailing address */
  mailingAddress?: InputMaybe<AddressInput>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Relationship to the person who manages the Catch Account. A user will have SELF. */
  relation?: InputMaybe<Relation>;
  /** The Person's biological sex. Used for things such as health care. */
  sex?: InputMaybe<Sex>;
  /** The social security number */
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export enum ContactMethod {
  Email = 'EMAIL',
  EText = 'E_TEXT',
  Mail = 'MAIL'
}

export enum ContactType {
  RetirementTrustedContact = 'RETIREMENT_TRUSTED_CONTACT',
  TaxDependent = 'TAX_DEPENDENT'
}

export type ConversionStatus = {
  __typename?: 'ConversionStatus';
  closedReason?: Maybe<ClosedReasonEnum>;
  events: Array<ActivityEvent>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  lastUpdated: Scalars['Time']['output'];
  status: ConversionStatusEnum;
  type: ConversionStatusType;
  year: Scalars['Int']['output'];
};

export type ConversionStatusConnection = {
  __typename?: 'ConversionStatusConnection';
  edges: Array<ConversionStatusEdge>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConversionStatusEdge = {
  __typename?: 'ConversionStatusEdge';
  cursor: Scalars['String']['output'];
  node: ConversionStatus;
};

export enum ConversionStatusEnum {
  /** @deprecated No longer supported */
  AccountCreated = 'ACCOUNT_CREATED',
  AppEnrolled = 'APP_ENROLLED',
  AppStarted = 'APP_STARTED',
  AppSubmitted = 'APP_SUBMITTED',
  BrokerAdded = 'BROKER_ADDED',
  Canceled = 'CANCELED',
  /** @deprecated No longer supported */
  Closed = 'CLOSED',
  Effectuated = 'EFFECTUATED',
  ExplorerStarted = 'EXPLORER_STARTED',
  GracePeriodDelinquency = 'GRACE_PERIOD_DELINQUENCY',
  Handoff = 'HANDOFF',
  /** @deprecated No longer supported */
  IntakeCompleted = 'INTAKE_COMPLETED',
  /** @deprecated No longer supported */
  IntakeRequested = 'INTAKE_REQUESTED',
  /** @deprecated No longer supported */
  IntakeScheduled = 'INTAKE_SCHEDULED',
  /** @deprecated No longer supported */
  OeReady = 'OE_READY',
  PlansChosen = 'PLANS_CHOSEN',
  /** @deprecated No longer supported */
  PlansSent = 'PLANS_SENT',
  /** @deprecated No longer supported */
  PriorPlanYearRenewal = 'PRIOR_PLAN_YEAR_RENEWAL',
  StateDiy = 'STATE_DIY',
  Terminated = 'TERMINATED'
}

export type ConversionStatusFilters = {
  closedReason?: InputMaybe<Array<ClosedReasonEnum>>;
  status?: InputMaybe<Array<ConversionStatusEnum>>;
  type?: InputMaybe<Array<ConversionStatusType>>;
  year?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ConversionStatusInput = {
  closedReason?: InputMaybe<ClosedReasonEnum>;
  status: ConversionStatusEnum;
  type: ConversionStatusType;
  year: Scalars['Int']['input'];
};

export enum ConversionStatusType {
  Dental = 'DENTAL',
  Health = 'HEALTH',
  Vision = 'VISION'
}

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoordinatesInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CortexTransaction = {
  __typename?: 'CortexTransaction';
  /** the account ID for the account of this transaction */
  accountID: Scalars['ID']['output'];
  amount: Scalars['Dollars']['output'];
  balance: Scalars['Dollars']['output'];
  category: Scalars['String']['output'];
  completionDate?: Maybe<Scalars['Date']['output']>;
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  /**
   * the date the transaction is expected to settle
   * this will only exist if the transaction is in a pending or processing state
   */
  expectedDate?: Maybe<Scalars['Date']['output']>;
  expenseCategory: Scalars['String']['output'];
  fees: Scalars['Dollars']['output'];
  fxRate: Scalars['Float']['output'];
  /** the transaction's ID */
  id: Scalars['ID']['output'];
  incomeAmount: Scalars['Dollars']['output'];
  isCancel: Scalars['Boolean']['output'];
  isCash: Scalars['Boolean']['output'];
  isIncome: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  ticker?: Maybe<Scalars['String']['output']>;
  transactionType: Scalars['String']['output'];
};

export type CortexTransactionConnection = {
  __typename?: 'CortexTransactionConnection';
  /** edges will return a node of transaction */
  edges: Array<CortexTransaction>;
  /** Information for paginating this connection */
  pageInfo: PageInfo;
};

export type CortexTransfer = {
  __typename?: 'CortexTransfer';
  accountName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  achTransfer: AchTransfer;
  amount: Scalars['Dollars']['output'];
  /** ONLY available on income transaction withholding and single deposit transfers. PlaidAccount available balance recorded at the time of transfer. Will appear as 0 if unavailable. This is sometimes not supported by Plaid */
  availableBalance: Scalars['Dollars']['output'];
  completionDate?: Maybe<Scalars['Date']['output']>;
  createdOn: Scalars['Time']['output'];
  /** ONLY available on income transaction withholding and single deposit transfers. PlaidAccount current balance recorded at the time of transfer. Will appear as 0 if unavailable. */
  currentBalance: Scalars['Dollars']['output'];
  description: Scalars['String']['output'];
  /**
   * the date the transfer is expected to settle
   * this will only exist if the transfer is in a pending or processing state
   */
  expectedDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  incomeAmount: Scalars['Dollars']['output'];
  isPending: Scalars['Boolean']['output'];
  returnCode?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transactions: Array<CortexTransaction>;
  type: TransferType;
};

export type CortexTransferConnection = {
  __typename?: 'CortexTransferConnection';
  /** edges will return a node of transfer */
  edges: Array<CortexTransfer>;
  /** Information for paginating this connection */
  pageInfo: PageInfo;
};

export type CostSharing = {
  __typename?: 'CostSharing';
  coinsuranceOptions: Scalars['String']['output'];
  coinsuranceRate: Scalars['Float']['output'];
  copayAmount: Scalars['Float']['output'];
  copayOptions: Scalars['String']['output'];
  csr: Scalars['String']['output'];
  displayString: Scalars['String']['output'];
  networkTier: Scalars['String']['output'];
};

export type County = {
  __typename?: 'County';
  fips: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export enum CoverageEndedReason {
  CompanyStoppedOfferingInsurance = 'COMPANY_STOPPED_OFFERING_INSURANCE',
  CompanyStoppedOfferingInsuranceToDependents = 'COMPANY_STOPPED_OFFERING_INSURANCE_TO_DEPENDENTS',
  InsuranceTooExpensive = 'INSURANCE_TOO_EXPENSIVE',
  MedicalNeedsNotCovered = 'MEDICAL_NEEDS_NOT_COVERED',
  Other = 'OTHER',
  ParentNoLongerWorksForTheCompany = 'PARENT_NO_LONGER_WORKS_FOR_THE_COMPANY'
}

export enum CoveredStatus {
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
  Not = 'NOT'
}

export type CreateConsentRequestInput = {
  consentType: ConsentType;
  personID: Scalars['ID']['input'];
};

export type CreatePayeeByPolicyInput = {
  policyID: Scalars['ID']['input'];
};

export type CreatePresignedUrlInput = {
  /** The file name of the upload */
  fileName: Scalars['String']['input'];
  /** The type of the upload */
  fileType: Scalars['String']['input'];
};

/** CreateSampleIncomeTransactionInput is the input for the CreateSampleIncomeTransaction mutation */
export type CreateSampleIncomeTransactionInput = {
  accountID?: InputMaybe<Scalars['ID']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Must be greater than 10, otherwise transaction will not be created and gql will panic */
  amount?: InputMaybe<Scalars['Dollars']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isPotentialDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  transactionDate?: InputMaybe<Scalars['Time']['input']>;
  workType?: InputMaybe<WorkType>;
};

/**
 * CreateUserInput determines the fields necessary for creation of a user on our
 * platform. Generally this is a direct mapping to the fields we give to our
 * identity management provider.
 */
export type CreateUserInput = {};

export type CrosswalkPlan = {
  __typename?: 'CrosswalkPlan';
  HealthPlan: HealthPlan;
  Level: Scalars['Int']['output'];
  Reason: Scalars['Int']['output'];
  planID: Scalars['String']['output'];
};

export type CursorPageInfo = {
  __typename?: 'CursorPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type CursorPagination = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
};

export type CustomTask = Task & {
  __typename?: 'CustomTask';
  assignee?: Maybe<User>;
  catchTask: CatchTask;
  createdOn: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isAssignment: Scalars['Boolean']['output'];
  lastUpdated: Scalars['Time']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  personReference: PersonReference;
  priority?: Maybe<TaskPriority>;
  status: TaskStatus;
  type: TaskType;
  user: User;
};

/** Data Matching Issue */
export type Dmi = {
  __typename?: 'DMI';
  /** Edge back to the application tied to this SVI */
  application: HealthApplication;
  /** The ID of the dependent this DMI relates to. */
  dependentID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastReviewed?: Maybe<Scalars['Time']['output']>;
  /** The member relating to this DMI. */
  member: ApplicationMember;
  nonEscMecType: Array<DmiNonEscMecType>;
  resolutionStatus?: Maybe<ResolutionStatus>;
  resolveBy?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<ConsolidatedIssueStatus>;
  /**
   * StatusReasonCode will be a list of integers that corresponds to a given
   * reason code in the DMI database. There are around 160 of these codes - some
   * of these will need to be dealt with by the FE, others will likely leave us in
   * cases that we can't deal with.
   *
   * It also _appears_ to be possible that this will return multiple codes - will
   * need to understand how to deal with this situation, despite not seeing it in
   * testing envs.
   */
  statusCodes: Array<Scalars['Int']['output']>;
  subType?: Maybe<DmiSubType>;
  verificationType: DmiVerificationType;
};

export enum DmiDocumentType {
  ArrivalDepartureRecord = 'ARRIVAL_DEPARTURE_RECORD',
  ArrivalDepartureRecordInForeignPassport = 'ARRIVAL_DEPARTURE_RECORD_IN_FOREIGN_PASSPORT',
  AuthenticDocumentFromATribeDeclaringMembership = 'AUTHENTIC_DOCUMENT_FROM_A_TRIBE_DECLARING_MEMBERSHIP',
  BenefitOrIncomeStatement = 'BENEFIT_OR_INCOME_STATEMENT',
  CertificateOfCitizenship = 'CERTIFICATE_OF_CITIZENSHIP',
  CertificateOfDegreeOfIndianBlood = 'CERTIFICATE_OF_DEGREE_OF_INDIAN_BLOOD',
  CertificateOfIndianStatusCard = 'CERTIFICATE_OF_INDIAN_STATUS_CARD',
  CertificateOfNaturalization = 'CERTIFICATE_OF_NATURALIZATION',
  CourtOrder = 'COURT_ORDER',
  DivorceDecree = 'DIVORCE_DECREE',
  DocumentFromAFederallyRecognizedIndianTribe = 'DOCUMENT_FROM_A_FEDERALLY_RECOGNIZED_INDIAN_TRIBE',
  DocumentIssuedByBia = 'DOCUMENT_ISSUED_BY_BIA',
  DocumentShowingEmploymentProofOfResidence = 'DOCUMENT_SHOWING_EMPLOYMENT_PROOF_OF_RESIDENCE',
  DriverSLicense = 'DRIVER_S_LICENSE',
  EmploymentAuthorizationCard = 'EMPLOYMENT_AUTHORIZATION_CARD',
  Form_1040TaxReturn = 'FORM_1040_TAX_RETURN',
  FormI_872AmericanIndianCard = 'FORM_I_872_AMERICAN_INDIAN_CARD',
  LetterFromChip = 'LETTER_FROM_CHIP',
  LetterFromHealthInsurer = 'LETTER_FROM_HEALTH_INSURER',
  LetterFromMedicaid = 'LETTER_FROM_MEDICAID',
  LetterFromMedicare = 'LETTER_FROM_MEDICARE',
  LetterFromPeaceCorps = 'LETTER_FROM_PEACE_CORPS',
  LetterFromTheMarketplaceGrantingATribalExemption = 'LETTER_FROM_THE_MARKETPLACE_GRANTING_A_TRIBAL_EXEMPTION',
  LetterFromTricare = 'LETTER_FROM_TRICARE',
  LetterFromVa = 'LETTER_FROM_VA',
  MachineReadableImmigrantVisa = 'MACHINE_READABLE_IMMIGRANT_VISA',
  MilitaryDependentSIdentificationCard = 'MILITARY_DEPENDENT_S_IDENTIFICATION_CARD',
  NativeAmericanTribalDocument = 'NATIVE_AMERICAN_TRIBAL_DOCUMENT',
  OfficialReleasePapers = 'OFFICIAL_RELEASE_PAPERS',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  PayStubs = 'PAY_STUBS',
  PayStubDocumentation = 'PAY_STUB_DOCUMENTATION',
  PermanentResidentGreenCard = 'PERMANENT_RESIDENT_GREEN_CARD',
  ReentryPermit = 'REENTRY_PERMIT',
  RefugeeTravelDocument = 'REFUGEE_TRAVEL_DOCUMENT',
  SelfEmploymentDocumentation = 'SELF_EMPLOYMENT_DOCUMENTATION',
  SignedNotarizedAffidavit = 'SIGNED_NOTARIZED_AFFIDAVIT',
  SocialSecurityCard = 'SOCIAL_SECURITY_CARD',
  SocialSecurityStatements = 'SOCIAL_SECURITY_STATEMENTS',
  StatementOfHealthBenefits = 'STATEMENT_OF_HEALTH_BENEFITS',
  TaxFormS = 'TAX_FORM_S',
  TemporaryI_551StampOnPassportOrI_94I_94A = 'TEMPORARY_I_551_STAMP_ON_PASSPORT_OR_I_94_I_94A',
  TribalEnrollmentMembershipCard = 'TRIBAL_ENROLLMENT_MEMBERSHIP_CARD',
  UnemploymentBenefitsLetter = 'UNEMPLOYMENT_BENEFITS_LETTER',
  USAmericanIndianAlaskaNativeTribalEnrollmentOrShareholderDocumentation = 'U_S_AMERICAN_INDIAN_ALASKA_NATIVE_TRIBAL_ENROLLMENT_OR_SHAREHOLDER_DOCUMENTATION',
  USMilitaryCardOrDraftRecord = 'U_S_MILITARY_CARD_OR_DRAFT_RECORD',
  W2AndOr_1099S = 'W2_AND_OR_1099S'
}

export type DmiDocumentUpload = {
  __typename?: 'DMIDocumentUpload';
  /** date document was uploaded */
  createdOn: Scalars['Date']['output'];
  /** The ID of the image metadata */
  id: Scalars['ID']['output'];
  /** The DMI ID this document relates to */
  issueID: Scalars['ID']['output'];
  /** key/name of the object in s3 */
  key: Scalars['String']['output'];
  /** The type of document */
  type: DmiDocumentType;
  /**
   * The temporary URL from which the image can be accessed.
   * Gets the URL based on the application this DMI is related to.
   */
  url: Scalars['String']['output'];
};

export enum DmiNonEscMecType {
  Bhp = 'BHP',
  Chip = 'CHIP',
  Commercial = 'COMMERCIAL',
  CommunityHealth = 'COMMUNITY_HEALTH',
  EmployerSponsored = 'EMPLOYER_SPONSORED',
  Exchange = 'EXCHANGE',
  Medicaid = 'MEDICAID',
  Medicare = 'MEDICARE',
  Msp = 'MSP',
  None = 'NONE',
  PeaceCorps = 'PEACE_CORPS',
  PetHealth = 'PET_HEALTH',
  PolicyBridge = 'POLICY_BRIDGE',
  Private = 'PRIVATE',
  Qhp = 'QHP',
  StudentHealth = 'STUDENT_HEALTH',
  Tricare = 'TRICARE',
  VeteransHealthProgram = 'VETERANS_HEALTH_PROGRAM'
}

export enum DmiSubType {
  AnnualIncomeAptcCsrs = 'ANNUAL_INCOME_APTC_CSRS',
  CitizenshipBornMedicaid = 'CITIZENSHIP_BORN_MEDICAID',
  CitizenshipBornQhp = 'CITIZENSHIP_BORN_QHP',
  CurrentIncome = 'CURRENT_INCOME',
  DeathMedicaidChip = 'DEATH_MEDICAID_CHIP',
  DeathQhp = 'DEATH_QHP',
  EscChanges = 'ESC_CHANGES',
  EscMecHeld = 'ESC_MEC_HELD',
  EscMecOpm = 'ESC_MEC_OPM',
  EscMecPend = 'ESC_MEC_PEND',
  ImmigrationStatusCode_119MedicaidChip = 'IMMIGRATION_STATUS_CODE_119_MEDICAID_CHIP',
  ImmigrationStatusCode_119Qhp = 'IMMIGRATION_STATUS_CODE_119_QHP',
  ImmigrationStatusMedicaidNonSave = 'IMMIGRATION_STATUS_MEDICAID_NON_SAVE',
  ImmigrationStatusNaturalizedCitizenshipDataResubmitQhp = 'IMMIGRATION_STATUS_NATURALIZED_CITIZENSHIP_DATA_RESUBMIT_QHP',
  ImmigrationStatusNaturalizedCitizenshipStep_2MedicaidChip = 'IMMIGRATION_STATUS_NATURALIZED_CITIZENSHIP_STEP_2_MEDICAID_CHIP',
  ImmigrationStatusNaturalizedCitizenshipStep_2Qhp = 'IMMIGRATION_STATUS_NATURALIZED_CITIZENSHIP_STEP_2_QHP',
  ImmigrationStatusNonSave = 'IMMIGRATION_STATUS_NON_SAVE',
  ImmigrationStatusNotEnoughInfoForSaveVerificationMedicaidChip = 'IMMIGRATION_STATUS_NOT_ENOUGH_INFO_FOR_SAVE_VERIFICATION_MEDICAID_CHIP',
  ImmigrationStatusNotEnoughInfoForSaveVerificationQhp = 'IMMIGRATION_STATUS_NOT_ENOUGH_INFO_FOR_SAVE_VERIFICATION_QHP',
  ImmigrationStatusVictimsOfTrafficking = 'IMMIGRATION_STATUS_VICTIMS_OF_TRAFFICKING',
  ImmigrationStatusVictimsOfTraffickingMedicaidChip = 'IMMIGRATION_STATUS_VICTIMS_OF_TRAFFICKING_MEDICAID_CHIP',
  Incarceration = 'INCARCERATION',
  IndianStatus = 'INDIAN_STATUS',
  LawfulPresenceStatusDocumentExpiration = 'LAWFUL_PRESENCE_STATUS_DOCUMENT_EXPIRATION',
  LawfulPresenceStatusN = 'LAWFUL_PRESENCE_STATUS_N',
  NaturalizedCitizenshipN = 'NATURALIZED_CITIZENSHIP_N',
  NonEscMecMedicaidChip = 'NON_ESC_MEC_MEDICAID_CHIP',
  NonEscMecMedicare = 'NON_ESC_MEC_MEDICARE',
  NonEscMecPeaceCorps = 'NON_ESC_MEC_PEACE_CORPS',
  NonEscMecTricare = 'NON_ESC_MEC_TRICARE',
  NonEscMecVa = 'NON_ESC_MEC_VA',
  NotEnoughInformationForSaveNaturalizedCitizen = 'NOT_ENOUGH_INFORMATION_FOR_SAVE_NATURALIZED_CITIZEN',
  Residency = 'RESIDENCY',
  SsnMedicaidChip = 'SSN_MEDICAID_CHIP',
  SsnQhp = 'SSN_QHP'
}

export enum DmiVerificationType {
  AnnualIncome = 'ANNUAL_INCOME',
  Citizenship = 'CITIZENSHIP',
  Escmec = 'ESCMEC',
  Incarceration = 'INCARCERATION',
  MedicaidLawfulPresence = 'MEDICAID_LAWFUL_PRESENCE',
  Nonescmec = 'NONESCMEC',
  QhpLawfulPresence = 'QHP_LAWFUL_PRESENCE',
  Ssn = 'SSN',
  TribeMembership = 'TRIBE_MEMBERSHIP'
}

/**
 * DatePeriod designates a range of dates from the current date back to some
 * historical time, for the purpose of viewing entities in our system
 */
export enum DatePeriod {
  /** the default - no date range */
  Any = 'ANY',
  /** a custom range, specified in the query */
  Custom = 'CUSTOM',
  /** month to date */
  Mtd = 'MTD',
  /** quarter to date (the IRS's weird quarter system) */
  Qtd = 'QTD',
  /** year to date */
  Ytd = 'YTD'
}

export type Deductibles = {
  __typename?: 'Deductibles';
  amount: Scalars['Float']['output'];
  csr: Scalars['String']['output'];
  familyCost: Scalars['String']['output'];
  networkTier: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Deductions = {
  __typename?: 'Deductions';
  /** #175 */
  incomeAmount?: Maybe<Scalars['Dollars']['output']>;
  /** #175 */
  incomeFrequencyType?: Maybe<IncomeFrequencyType>;
  /** Should always be populated after upsert processing. If not populated, it is likely old data */
  incomeID?: Maybe<Scalars['Int']['output']>;
  /** #175 */
  incomeSourceType?: Maybe<IncomeSourceType>;
  /** #178 */
  otherDeductionDescription?: Maybe<Scalars['String']['output']>;
};

export type DeductionsInput = {
  /** #175 */
  incomeAmount?: InputMaybe<Scalars['Dollars']['input']>;
  /** #175 */
  incomeFrequencyType?: InputMaybe<IncomeFrequencyType>;
  /** If adding a new Deduction, do NOT add an ID. If modifying an existing ID, Please pass in an ID or data will be messed up */
  incomeID?: InputMaybe<Scalars['Int']['input']>;
  /** #175 */
  incomeSourceType?: InputMaybe<IncomeSourceType>;
  /** #178 */
  otherDeductionDescription?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultHealthPaymentScheduleInput = {
  policyID: Scalars['ID']['input'];
};

export type DeleteEnrollmentGroupsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteEnrollmentGroupsResponse = {
  __typename?: 'DeleteEnrollmentGroupsResponse';
  enrollmentGroups?: Maybe<Array<EnrollmentGroup>>;
  error?: Maybe<ErrorItem>;
};

export type DeleteHealthInsuranceInput = {
  /** The ID of Health Insurance Wallet item */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DentalEnrollmentEvent = Event & {
  __typename?: 'DentalEnrollmentEvent';
  enrollment?: Maybe<HealthInsuranceEnrollment>;
  /** The ID of the event */
  id: Scalars['ID']['output'];
  time: Scalars['Time']['output'];
  type: HealthEnrollmentEventType;
};

export type DentalWalletItem = WalletItem & {
  __typename?: 'DentalWalletItem';
  card: WalletCard;
  carrier?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<InsuranceSource>;
  vertical: WalletItemVertical;
};

export type DentalWalletItemInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InsuranceSource>;
};

export type DependentEligibilityEstimate = {
  __typename?: 'DependentEligibilityEstimate';
  advancePremiumTaxCredit: Scalars['Dollars']['output'];
  costSharingReductions?: Maybe<Scalars['String']['output']>;
  /** The dependent this estimate pertains to */
  dependentID: Scalars['ID']['output'];
  isMedicaidCHIP: Scalars['Boolean']['output'];
};

export enum DepositProductTier {
  Tier_0 = 'TIER_0',
  Tier_1 = 'TIER_1',
  Tier_2 = 'TIER_2',
  Tier_3 = 'TIER_3'
}

/** The device types we can currently send push notifications */
export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

/** When a user receives a dividend */
export type DividendReceivedEvent = Event & {
  __typename?: 'DividendReceivedEvent';
  amount: Scalars['Dollars']['output'];
  /** The ID of the event */
  id: Scalars['ID']['output'];
  time: Scalars['Time']['output'];
};

/**
 * DocFileType is the list of filetypes we support when uploading any type of
 * document to the EDE DSRS API.
 */
export enum DocFileType {
  Bmp = 'BMP',
  Gif = 'GIF',
  Heic = 'HEIC',
  Heif = 'HEIF',
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Pdf = 'PDF',
  Png = 'PNG',
  Tiff = 'TIFF'
}

export type DocsRequiredInput = {
  status?: InputMaybe<DocumentRequiredStatus>;
  statusList: Array<DocumentRequiredStatus>;
};

export type Document = {
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

export type DocumentGroup = {
  __typename?: 'DocumentGroup';
  statements: Array<AccountStatement>;
  taxDocuments: Array<TaxForm>;
};


export type DocumentGroupStatementsArgs = {
  input?: InputMaybe<DocumentInput>;
};


export type DocumentGroupTaxDocumentsArgs = {
  input?: InputMaybe<DocumentInput>;
};

export type DocumentInput = {
  endMonth?: InputMaybe<Scalars['Int']['input']>;
  endYear?: InputMaybe<Scalars['Int']['input']>;
  startMonth?: InputMaybe<Scalars['Int']['input']>;
  startYear?: InputMaybe<Scalars['Int']['input']>;
};

/** TODO: Maybe add base64 thumbnail and the document url itself? Idk */
export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  createdOn: Scalars['Date']['output'];
  documentType: DocumentType;
  ext: FileType;
  filePath?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** DocumentMetadataInput is the s3 object that is linked to the document in the App Upload bucket */
export type DocumentMetadataInput = {
  documentType: DocumentType;
  fileType: FileType;
  key: Scalars['String']['input'];
};

export type DocumentRequired = {
  __typename?: 'DocumentRequired';
  documentType: DocumentType;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  providerID?: Maybe<Scalars['String']['output']>;
  status: DocumentRequiredStatus;
  uploadedDocument?: Maybe<DocumentMetadata>;
};

export enum DocumentRequiredStatus {
  Approved = 'APPROVED',
  Invalid = 'INVALID',
  PendingReview = 'PENDING_REVIEW',
  Received = 'RECEIVED',
  Required = 'REQUIRED'
}

export enum DocumentType {
  Avatar = 'AVATAR',
  HealthDmi = 'HEALTH_DMI',
  HealthInsuranceBack = 'HEALTH_INSURANCE_BACK',
  HealthInsuranceFront = 'HEALTH_INSURANCE_FRONT',
  HealthSvi = 'HEALTH_SVI',
  Passport = 'PASSPORT',
  PhotoIdBack = 'PHOTO_ID_BACK',
  PhotoIdFront = 'PHOTO_ID_FRONT',
  ProofResidence = 'PROOF_RESIDENCE',
  Signature = 'SIGNATURE',
  SocialSecurityCard = 'SOCIAL_SECURITY_CARD',
  Statement = 'STATEMENT',
  Tax_1040Es = 'TAX_1040_ES',
  Tax_1095A = 'TAX_1095_A',
  Tax_1099R = 'TAX_1099_R',
  Tax_5498 = 'TAX_5498',
  TaxPaymentConfirmation = 'TAX_PAYMENT_CONFIRMATION',
  WalletCard = 'WALLET_CARD'
}

export type DocumentsRequiredResponse = {
  __typename?: 'DocumentsRequiredResponse';
  documentList: Array<DocumentRequired>;
  error?: Maybe<Scalars['String']['output']>;
};

export type Drug = {
  __typename?: 'Drug';
  isCovered: Scalars['Boolean']['output'];
  isGenericCovered: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rxcui: Scalars['String']['output'];
};

export type DrugInput = {
  name: Scalars['String']['input'];
  rxcui: Scalars['String']['input'];
};

/** EDD Questions represents a user's EDD Questions information */
export type EddQuestions = {
  __typename?: 'EDDQuestions';
  /** The user's net worth */
  netWorth?: Maybe<Scalars['Dollars']['output']>;
  /** The user's other annual income */
  otherIncome?: Maybe<Scalars['Dollars']['output']>;
  /** The user's primary annual income */
  primaryIncome?: Maybe<Scalars['Dollars']['output']>;
  /** The user's total annual income */
  totalIncome?: Maybe<Scalars['Dollars']['output']>;
};

/** EDDQuestionsInput is the input for the edd questions section of the updateUser mutation */
export type EddQuestionsInput = {
  /** Amount of the initial deposit */
  initialDepositAmount?: InputMaybe<Scalars['Dollars']['input']>;
  /** Financial Institution for the initial deposit */
  initialDepositInstitution?: InputMaybe<Scalars['String']['input']>;
  /** The user's net worth */
  netWorth?: InputMaybe<Scalars['Dollars']['input']>;
  /** The user's other annual income */
  otherIncome?: InputMaybe<Scalars['Dollars']['input']>;
  /** The user's primary annual income */
  primaryIncome?: InputMaybe<Scalars['Dollars']['input']>;
  /** The user's total annual income */
  totalIncome?: InputMaybe<Scalars['Dollars']['input']>;
};

export enum EdeApplicationOrigin {
  AdvancedResolution = 'ADVANCED_RESOLUTION',
  AgentBroker = 'AGENT_BROKER',
  AppealSystem = 'APPEAL_SYSTEM',
  AutoReEnrollment = 'AUTO_RE_ENROLLMENT',
  CallCenterWorker = 'CALL_CENTER_WORKER',
  DirectEnrollment = 'DIRECT_ENROLLMENT',
  EligibilitySupportDesktopWorker = 'ELIGIBILITY_SUPPORT_DESKTOP_WORKER',
  FfmOnline = 'FFM_ONLINE',
  InboundAccountTransfer = 'INBOUND_ACCOUNT_TRANSFER',
  PaperApplication = 'PAPER_APPLICATION',
  Unknown = 'UNKNOWN'
}

/** EDEValidationError is the structure for a validation error returned by CMS */
export type EdeValidationError = {
  __typename?: 'EDEValidationError';
  applicationMemberID?: Maybe<Scalars['ID']['output']>;
  code?: Maybe<EdeValidationErrorCode>;
  path?: Maybe<Scalars['String']['output']>;
};

export enum EdeValidationErrorCode {
  /** The field in the path cannot be empty */
  ErrCannotBeEmpty = 'ERR_CANNOT_BE_EMPTY',
  /** The field in the path cannot be false */
  ErrCannotBeFalse = 'ERR_CANNOT_BE_FALSE',
  /** The field in the path cannot be null */
  ErrCannotBeNull = 'ERR_CANNOT_BE_NULL',
  /** The field contains invalid coverage year */
  ErrInvalidCoverageYear = 'ERR_INVALID_COVERAGE_YEAR',
  /** The income is invalid and user must fix income to resolve inconsistencies */
  ErrInvalidIncomeNotVariable = 'ERR_INVALID_INCOME_NOT_VARIABLE',
  /** The value is too long */
  ErrMaxLengthExceeded = 'ERR_MAX_LENGTH_EXCEEDED',
  /** The value is too short */
  ErrMinLengthNotReached = 'ERR_MIN_LENGTH_NOT_REACHED',
  /** The value is not numeric */
  ErrNotNumeric = 'ERR_NOT_NUMERIC',
  /** This validation error was not handled */
  ErrUnknown = 'ERR_UNKNOWN'
}

export type EdeValidationErrorItem = ErrorItem & {
  __typename?: 'EDEValidationErrorItem';
  /** A code that describes the error */
  code: ErrorCode;
  /** The field found in the type that is the cause of the error */
  field?: Maybe<Scalars['String']['output']>;
  memberID?: Maybe<Scalars['ID']['output']>;
  /** A message that is human-readable and describes the error in greater detail */
  message?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  /** Explains why the field is incorrect */
  providerCode: EdeValidationErrorCode;
};

export enum EligibilityChange {
  Change = 'CHANGE',
  Gain = 'GAIN',
  Loss = 'LOSS',
  None = 'NONE',
  NoChange = 'NO_CHANGE'
}

export type EligibilitySummary = {
  __typename?: 'EligibilitySummary';
  /** The Cost Sharing Reduction Level which describes if the user qualifies plans with discounts in deductibles, copayments, and coinsurance. */
  csrLevel: CsrLevel;
  /** Bool that indicates if someone has CHIP eligibility */
  isChip: Scalars['Boolean']['output'];
  /** Bool that indicates if someone has medicaid eligibility */
  isMedicaid: Scalars['Boolean']['output'];
  /** The Advance Premium Tax Credit which describes the aid a person may recieve from the government" */
  totalAptc: Scalars['Dollars']['output'];
};

/** EmailNotificationSettings represents the notifications the user wants to be emailed about */
export type EmailNotificationSettings = {
  __typename?: 'EmailNotificationSettings';
  /** Announcements for new Catch features, e.g. Family Leave or Autopilot */
  featureAnnouncements: Scalars['Boolean']['output'];
  /** Linked Account notifications flag */
  linkedAccountStatus: Scalars['Boolean']['output'];
  /** Updates regarding the user's active benefits */
  myBenefits: Scalars['Boolean']['output'];
  /** Income Transaction notifications */
  planTransactionNotification: Scalars['Boolean']['output'];
  /** Updates regarding benefits either recommended for the user */
  recommendedBenefits: Scalars['Boolean']['output'];
};

export enum EmployeeSelfOnlyOfferFrequencyType {
  Annually = 'ANNUALLY',
  BiWeekly = 'BI_WEEKLY',
  Monthly = 'MONTHLY',
  Prorated = 'PRORATED',
  Quarterly = 'QUARTERLY',
  SemiMonthly = 'SEMI_MONTHLY',
  Weekly = 'WEEKLY'
}

/** The user's employment information */
export type Employment = {
  __typename?: 'Employment';
  /** The user's employer's address */
  address?: Maybe<Address>;
  /** The user's employer's name */
  employerName?: Maybe<Scalars['String']['output']>;
  /** The employment length */
  employmentLength?: Maybe<Scalars['Int']['output']>;
  /** The user's occupation */
  occupation?: Maybe<Scalars['String']['output']>;
  /** The user's position */
  position?: Maybe<Scalars['String']['output']>;
  /** The user's employment status defined in enum.gql */
  status?: Maybe<EmploymentStatus>;
};

/** EmploymentInput is used to input employment information */
export type EmploymentInput = {
  /** The employer's address */
  address?: InputMaybe<AddressInput>;
  /** The user's employer's name */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** How long in years the user has worked for this company */
  employmentLength?: InputMaybe<Scalars['Int']['input']>;
  /** The user's occupation */
  occupation?: InputMaybe<Scalars['String']['input']>;
  /** The user's position at the company */
  position?: InputMaybe<Scalars['String']['input']>;
  /** The user's employment status */
  status?: InputMaybe<EmploymentStatus>;
};

/** EmploymentStatus represents the different types of employment statuses the user can have */
export enum EmploymentStatus {
  /** The user is employed */
  Employed = 'EMPLOYED',
  /** The user is retired */
  Retired = 'RETIRED',
  /** The user is self employed */
  SelfEmployed = 'SELF_EMPLOYED',
  /** The user is a student */
  Student = 'STUDENT',
  /** The user is unemployed */
  Unemployed = 'UNEMPLOYED',
  /** We don't know */
  UnknownEmploymentStatus = 'UNKNOWN_EMPLOYMENT_STATUS'
}

export enum EnrollmentAction {
  ActionDmi = 'ACTION_DMI',
  ActionPayment = 'ACTION_PAYMENT',
  ActionSvi = 'ACTION_SVI'
}

export type EnrollmentGroup = {
  __typename?: 'EnrollmentGroup';
  /** Application related to this enrollment group */
  application: HealthApplication;
  /** Current Applied APTC, assigned after APTC calculations */
  appliedAPTCAmount?: Maybe<Scalars['Dollars']['output']>;
  /** calculated Applied CSR level of this enrollment group */
  appliedCSRLevel: CsrLevel;
  /** Earliest effective date calculated for slasher */
  earliestEffectiveDate?: Maybe<Scalars['Date']['output']>;
  /** The premium of the selected plan eligible for APTC */
  ehbPremium?: Maybe<Scalars['Dollars']['output']>;
  /** Provides a summary of eligibility results for this enrollment group */
  eligibility: EligibilitySummary;
  /** Health, Dental, etc */
  enrollmentType: InsuranceEnrollmentType;
  /** The unique ID for the app member in our system */
  id: Scalars['ID']['output'];
  /** Indicator if the premium effective has been modified by APTC calculations */
  isPremiumAdjusted: Scalars['Boolean']['output'];
  /** Members on this enrollment group */
  members: Array<ApplicationMember>;
  /** The premium of the pediatric dental portion, used for APTC calculation */
  pediatricEHBPremium?: Maybe<Scalars['Dollars']['output']>;
  /** Returns health plan details from Marketplace (live query) based on the selectedProviderPlanID and the members on this enrollment group */
  plan?: Maybe<HealthPlan>;
  /** The premium of the selected plan */
  planPremium?: Maybe<Scalars['Dollars']['output']>;
  /** The effective premium of the selected plan */
  planPremiumEffective?: Maybe<Scalars['Dollars']['output']>;
  /** Queries available plans from the marketplace for members under this enrollment group */
  plans: HealthPlans;
  /** Premium Slasher comparison showing previous Plan's APTC */
  previousAppliedAPTCAmount?: Maybe<Scalars['Dollars']['output']>;
  /** The metal level of the selected plan */
  selectedMetalLevel?: Maybe<MetalLevel>;
  /** The plan issuer ID of the selected plan */
  selectedPlanIssuerID?: Maybe<Scalars['String']['output']>;
  /** The provider plan ID of the selected plan */
  selectedProviderPlanID?: Maybe<Scalars['String']['output']>;
  /** Queries plans from the marketplace sorted with current health preferences for members under this enrollment group */
  sortedPlans: SortedHealthPlansResponse;
};

export type EnrollmentGroupInput = {
  /** Application ID of the app related to this enrollment group */
  applicationID?: InputMaybe<Scalars['ID']['input']>;
  /** The premium of the selected plan eligible for APTC */
  ehbPremium?: InputMaybe<Scalars['Dollars']['input']>;
  enrollmentType?: InputMaybe<InsuranceEnrollmentType>;
  /**
   * If provided, ID will target an enrollment group for updating
   *
   * Otherwise, the enrollment group will be treated as a NEW enrollment group.
   *
   * The Application ID may not be upserted if the enrollment group already exists
   * as to not break existing data.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Member ids on this enrollment group to add */
  memberIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The effective premium of the pediatric dental portion, used for APTC calculation */
  pediatricEHBPremium?: InputMaybe<Scalars['Dollars']['input']>;
  /** The premium of the selected plan */
  planPremium?: InputMaybe<Scalars['Dollars']['input']>;
  /** The effective premium of the selected plan */
  planPremiumEffective?: InputMaybe<Scalars['Dollars']['input']>;
  /** Remove members from an enrollment group */
  removeMemberIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The metal level of the selected plan */
  selectedMetalLevel?: InputMaybe<MetalLevel>;
  /** The plan issuer ID of the selected plan */
  selectedPlanIssuerID?: InputMaybe<Scalars['String']['input']>;
  /** The provider plan ID of the selected plan */
  selectedProviderPlanID?: InputMaybe<Scalars['String']['input']>;
};

/**
 * EnsureHealthApplicationResponse contains the current application for healthcare,
 * and contains a validation error if there is one. This is a response from the
 * EnsureHealthApplication mutation.
 */
export type EnsureHealthApplicationResponse = {
  __typename?: 'EnsureHealthApplicationResponse';
  /** The current health application */
  currApplication: HealthApplication;
  error?: Maybe<ErrorItem>;
  /** Any errors that arose from the Ensure mutation */
  errors?: Maybe<Array<EdeValidationError>>;
  fromFunction?: Maybe<Scalars['String']['output']>;
  responseResultType: ResponseResultType;
  /** Raw JSONified error list from SUCCESS_WITH_ERROR. Will only exist if SUCCESS_WITH_ERROR resulted from the Ensure call */
  successWithError?: Maybe<Scalars['JSON']['output']>;
};

/** Generic Catch Errors with details */
export type Error = ErrorItem & {
  __typename?: 'Error';
  /** A code that describes the error */
  code: ErrorCode;
  /** The field found in the type that is the cause of the error */
  field?: Maybe<Scalars['String']['output']>;
  /** A message that is human-readable and describes the error in greater detail */
  message?: Maybe<Scalars['String']['output']>;
};

export enum ErrorCode {
  /** Unable to prefill data */
  DataPrefillFailure = 'DATA_PREFILL_FAILURE',
  /** Image uploaded to the platform cannot be converted and stored. Retry upload */
  ImageConversionFailure = 'IMAGE_CONVERSION_FAILURE',
  /** The inputs proved by the user are invalid and should retry with correct inputs */
  InvalidArgument = 'INVALID_ARGUMENT',
  /** An item was not found in Mongo. Check request or check for bad data. */
  NotFound = 'NOT_FOUND',
  /** We want to do something but the provider explicitly says the thing we are trying to do is not supported. */
  NotSupported = 'NOT_SUPPORTED',
  /** Total provider failure. Services may be down or there is a severe unexpected error from the provider. */
  ProviderFailure = 'PROVIDER_FAILURE',
  /** We did something wrong and this displeased the provider. We likely do not handle this error. */
  ProviderInternal = 'PROVIDER_INTERNAL',
  /** We do not have permissions to do things and thats not good. */
  ProviderNotAuth = 'PROVIDER_NOT_AUTH',
  /** Must be a new error but we should handle it. You should never see an error with this code. */
  UnknownError = 'UNKNOWN_ERROR'
}

/** Error is an abstract type. Use this if you want the ability for your error to be returned with other errors */
export type ErrorItem = {
  /** A code that describes the error */
  code: ErrorCode;
  /** The field found in the type that is the cause of the error */
  field?: Maybe<Scalars['String']['output']>;
  /** A message that is human-readable and describes the error in greater detail */
  message?: Maybe<Scalars['String']['output']>;
};

/** Income represents information about a user's income */
export type EstimatedIncome = {
  __typename?: 'EstimatedIncome';
  estimated1099Income?: Maybe<Scalars['Dollars']['output']>;
  /** computed based on 1099/W2 income and work type */
  estimatedGrossIncome?: Maybe<Scalars['Dollars']['output']>;
  estimatedW2Income?: Maybe<Scalars['Dollars']['output']>;
  id: Scalars['ID']['output'];
  spouseIncome?: Maybe<Scalars['Dollars']['output']>;
};

export enum Ethnicity {
  Cuban = 'CUBAN',
  Hispanic = 'HISPANIC',
  Mexican = 'MEXICAN',
  NotHispanic = 'NOT_HISPANIC',
  Other = 'OTHER',
  PuertoRican = 'PUERTO_RICAN'
}

/** An event is something that occurs for a user at a given time. */
export type Event = {
  /** When the event was created. */
  time: Scalars['Time']['output'];
};

/**  The different activity event types in our platform */
export enum EventType {
  /** admin events */
  Admin = 'ADMIN',
  /** Autopilot Rule events */
  AutopilotRule = 'AUTOPILOT_RULE',
  /** Catch fee payments */
  CatchFeePayment = 'CATCH_FEE_PAYMENT',
  /** Dividend received event */
  Dividend = 'DIVIDEND',
  /** Fee event */
  Fee = 'FEE',
  /** Goal activity */
  GoalActivity = 'GOAL_ACTIVITY',
  /** health application events */
  HealthApplication = 'HEALTH_APPLICATION',
  /** health enrollment events */
  HealthEnrollment = 'HEALTH_ENROLLMENT',
  /** payment event */
  Payment = 'PAYMENT',
  /** Rollover event */
  Rollover = 'ROLLOVER',
  /** Statement Event */
  Statement = 'STATEMENT',
  /** Transfer event */
  Transfer = 'TRANSFER'
}

export type ExchangeEligibility = {
  __typename?: 'ExchangeEligibility';
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type ExistingApplicationInfo = {
  __typename?: 'ExistingApplicationInfo';
  applicationIdentifier?: Maybe<Scalars['String']['output']>;
  applicationStatus?: Maybe<ExistingApplicationStatus>;
  applicationVersion?: Maybe<Scalars['Int']['output']>;
  coverageYearNumber?: Maybe<Scalars['Int']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  hasExistingPersonTrackingNumbersTiedToApplication?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  matchesWithAnotherUser?: Maybe<Scalars['Boolean']['output']>;
  policyInfo?: Maybe<Scalars['JSON']['output']>;
  providerLastUpdatedDate?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/**
 * Details about an existing application that's available for import
 *
 * In theory, all the fields here should be populated and valid, but, it's EDE.
 */
export type ExistingApplicationInformation = {
  __typename?: 'ExistingApplicationInformation';
  /** the field is true if the user has an ede app already in the catch system that is tied to the unique app identifier */
  IsEdeApplication: Scalars['Boolean']['output'];
  /** The identifier of the application, used for importing into our system */
  applicationIdentifier: Scalars['ID']['output'];
  applicationStatus: ExistingApplicationStatus;
  applicationVersion: Scalars['Int']['output'];
  coverageYearNumber: Scalars['Int']['output'];
  /** The user's family name, as reported by EDE. */
  familyName: Scalars['String']['output'];
  /** The user's given name, as reported by EDE. */
  givenName: Scalars['String']['output'];
  hasExistingPersonTrackingNumbersTiedToApplication: Scalars['Boolean']['output'];
  /** Field is true if this app is a prior year application based on the UserHealthInfo */
  isPriorYear: Scalars['Boolean']['output'];
  lastUpdated: Scalars['Date']['output'];
  state: Scalars['String']['output'];
};

export enum ExistingApplicationStatus {
  CompleteEnrolled = 'COMPLETE_ENROLLED',
  CompleteLimitedPlanAvailability = 'COMPLETE_LIMITED_PLAN_AVAILABILITY',
  CompleteNoQhpEligibility = 'COMPLETE_NO_QHP_ELIGIBILITY',
  InProgress = 'IN_PROGRESS',
  SubmittedEnrollmentPending = 'SUBMITTED_ENROLLMENT_PENDING',
  SubmittedEnrollmentTermCancel = 'SUBMITTED_ENROLLMENT_TERM_CANCEL',
  SubmittedNoEnrollment = 'SUBMITTED_NO_ENROLLMENT'
}

export type ExistingApplicationsResponse = {
  __typename?: 'ExistingApplicationsResponse';
  /** An indicator that is only populated when calling edeApplicationSearch - if data is populated on the person enough to id proof - will be True */
  canIDProof?: Maybe<Scalars['Boolean']['output']>;
  /** This will be NULL if we never made the search before or EMPTY ARRAY if we have searched before with no results */
  existingApplications?: Maybe<Array<ExistingApplicationInfo>>;
  hasActivePolicy: Scalars['Boolean']['output'];
  hasPreviousActivePolicy: Scalars['Boolean']['output'];
  hasSubmittedApplication: Scalars['Boolean']['output'];
  /** An indicator that is only populated when calling importAllExistingApplications. Will be NULL if no existing apps found */
  idProofOk?: Maybe<Scalars['Boolean']['output']>;
  /** If NOTHING went wrong during importAllExistingApplications this will exist and be True */
  importOk?: Maybe<Scalars['Boolean']['output']>;
};

export enum ExperianResult {
  /** Experian verified */
  Acc = 'ACC',
  /** call experian - frozen credit file */
  Rf1 = 'RF1',
  /** call experian - wrong answer to question */
  Rf2 = 'RF2',
  /** limit exceeded */
  Rf3 = 'RF3',
  /** couldn't generate questions for this person - dead, never had credit, lives under a rock, etc */
  Rf4 = 'RF4'
}

export type ExpertSetupTask = Task & {
  __typename?: 'ExpertSetupTask';
  assignee?: Maybe<User>;
  catchTask: CatchTask;
  createdOn: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isAssignment: Scalars['Boolean']['output'];
  lastUpdated: Scalars['Time']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  personReference: PersonReference;
  priority?: Maybe<TaskPriority>;
  status: TaskStatus;
  type: TaskType;
  user: User;
};

/** The user's external health source */
export enum ExternalHealthSource {
  Employer = 'EMPLOYER',
  Getinsured = 'GETINSURED',
  HealthcareGov = 'HEALTHCARE_GOV',
  Healthsherpa = 'HEALTHSHERPA',
  Medicaid = 'MEDICAID',
  Medicare = 'MEDICARE',
  NotCovered = 'NOT_COVERED',
  Other = 'OTHER',
  Spouse = 'SPOUSE',
  StateExchange = 'STATE_EXCHANGE',
  StrideHealth = 'STRIDE_HEALTH'
}

export type Facet = {
  __typename?: 'Facet';
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type FacetGroup = {
  __typename?: 'FacetGroup';
  facets: Array<Facet>;
  name: Scalars['String']['output'];
};

export type Feature = {
  __typename?: 'Feature';
  catchFeature: CatchFeature;
  feePaymentEvents: FeePaymentEventsConnection;
  isVisible: Scalars['Boolean']['output'];
  status: FeatureStatus;
  subscription?: Maybe<CatchSubscription>;
  type: CatchFeatureType;
};


export type FeatureFeePaymentEventsArgs = {
  pagination: Pagination;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  hasAccessToFintech: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export enum FeatureStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Delinquent = 'DELINQUENT',
  Expiring = 'EXPIRING',
  Inactive = 'INACTIVE'
}

/** When a user pays a fee from their retirement account */
export type FeePaidEvent = Event & {
  __typename?: 'FeePaidEvent';
  amount: Scalars['Dollars']['output'];
  /** The ID of the event */
  id: Scalars['ID']['output'];
  time: Scalars['Time']['output'];
};

/**
 * FeePaymentEventsConnection is a connection to a list of CatchFeePaymentEvents ordered by time
 * occurred with the most recent first.
 */
export type FeePaymentEventsConnection = {
  __typename?: 'FeePaymentEventsConnection';
  edges: Array<CatchFeePaymentEvent>;
  pageInfo: PageInfo;
};

export enum FileType {
  Heic = 'HEIC',
  Heif = 'HEIF',
  Jpeg = 'JPEG',
  Pdf = 'PDF',
  Png = 'PNG'
}

/** The user's tax filing status */
export enum FilingStatus {
  /** Head of household */
  Head = 'HEAD',
  /** Married */
  Married = 'MARRIED',
  /** Married separately */
  MarriedSeparately = 'MARRIED_SEPARATELY',
  /** Single */
  Single = 'SINGLE'
}

export enum FinancialPreferenceType {
  Balanced = 'BALANCED',
  LowDeductible = 'LOW_DEDUCTIBLE',
  LowPremium = 'LOW_PREMIUM'
}

export enum FiveYearBarStatus {
  Hold = 'HOLD',
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  Yes = 'YES'
}

export enum FiveYearBarStatusReason {
  /** 569 */
  ApplicantAtstdCitizen = 'APPLICANT_ATSTD_CITIZEN',
  /** 398 */
  AtstdToSaveNonVerifiableStatus = 'ATSTD_TO_SAVE_NON_VERIFIABLE_STATUS',
  /** 626 */
  AtstdVeteran = 'ATSTD_VETERAN',
  /** 456 */
  DataSourceNotCalledDueToFailedIdProof = 'DATA_SOURCE_NOT_CALLED_DUE_TO_FAILED_ID_PROOF',
  /** 395 */
  DidNotAttestToNaturalizedCitizenshipOrLp = 'DID_NOT_ATTEST_TO_NATURALIZED_CITIZENSHIP_OR_LP',
  /** 191 */
  EdsNotAvailable = 'EDS_NOT_AVAILABLE',
  /** 608 */
  ElgblUnderChipra = 'ELGBL_UNDER_CHIPRA',
  /** 627 */
  FiveYearBarDoesNotApply = 'FIVE_YEAR_BAR_DOES_NOT_APPLY',
  /** 630 */
  FiveYearBarInconsistentWithAtstdGrantDate = 'FIVE_YEAR_BAR_INCONSISTENT_WITH_ATSTD_GRANT_DATE',
  /** 143 */
  FiveYearBarInEffect = 'FIVE_YEAR_BAR_IN_EFFECT',
  /** 473 */
  FiveYearBarIsPending = 'FIVE_YEAR_BAR_IS_PENDING',
  /** 629 */
  FiveYearBarNotMetWithAtstdGrantDate = 'FIVE_YEAR_BAR_NOT_MET_WITH_ATSTD_GRANT_DATE',
  /** 465 */
  HubCallReturnedTransactionalError = 'HUB_CALL_RETURNED_TRANSACTIONAL_ERROR',
  /** 606 */
  HubCallSuccessfulNoDataFound = 'HUB_CALL_SUCCESSFUL_NO_DATA_FOUND',
  /** 605 */
  HubIndicatesNotLpvOrQnc = 'HUB_INDICATES_NOT_LPV_OR_QNC',
  /** 610 */
  HubQncIndicatorIsN = 'HUB_QNC_INDICATOR_IS_N',
  /** 609 */
  HubQncIndicatorIsPending = 'HUB_QNC_INDICATOR_IS_PENDING',
  /** 607 */
  NotAtstdImmigrantOrCitizen = 'NOT_ATSTD_IMMIGRANT_OR_CITIZEN',
  /** 399 */
  NotEnoughInfoProvidedToVerifyElgblLpStatus = 'NOT_ENOUGH_INFO_PROVIDED_TO_VERIFY_ELGBL_LP_STATUS',
  /** 631 */
  NotMdcaidOrChipIncomeElgbl = 'NOT_MDCAID_OR_CHIP_INCOME_ELGBL',
  /** 628 */
  NoAtstdGrantDateAndNotAvailableFromHub = 'NO_ATSTD_GRANT_DATE_AND_NOT_AVAILABLE_FROM_HUB',
  /** 555 */
  NARuleDoesNotApply = 'N_A_RULE_DOES_NOT_APPLY',
  /** 999 */
  NARuleIndicatorIsY = 'N_A_RULE_INDICATOR_IS_Y',
  /** 150 */
  SaveVerificationPending = 'SAVE_VERIFICATION_PENDING',
  /** 611 */
  SubjectTo_7YearLimitRule = 'SUBJECT_TO_7_YEAR_LIMIT_RULE'
}

export enum Gender {
  DifferentTerm = 'DIFFERENT_TERM',
  DontKnow = 'DONT_KNOW',
  Female = 'FEMALE',
  Male = 'MALE',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER',
  TransgenderFemale = 'TRANSGENDER_FEMALE',
  TransgenderMale = 'TRANSGENDER_MALE'
}

export type GenerateRecommendationsInput = {
  updateCheckupTimestamp?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * GeneratedPhysicalDocument is a document generated by the healthcare API.
 * In the future, the actual document content will be retrievable via ID.
 */
export type GeneratedPhysicalDocument = {
  __typename?: 'GeneratedPhysicalDocument';
  /** date of the document */
  documentCreationDate?: Maybe<Scalars['Time']['output']>;
  /** Pass this into the `getGeneratedDocumentURL` mutation */
  dsrsIdentifier: Scalars['String']['output'];
  /** The ID of the GeneratedPhysicalDocument */
  id: Scalars['ID']['output'];
  /** The name of the document */
  name: Scalars['String']['output'];
};

/** DEPRECATED: Used for deprecated calls for backwards compatibility */
export type GetAnyCatchFeeSubscriptionInput = {
  id: Scalars['ID']['input'];
};

export type GetAnyCatchSubscriptionInput = {
  id: Scalars['ID']['input'];
};

export type GetCatchFeatureInput = {
  __typename?: 'GetCatchFeatureInput';
  type: CatchFeatureType;
};

export type GetCatchFeeInput = {
  /** This ID represents the CatchFee */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The type of fee */
  type?: InputMaybe<CatchFeeTypes>;
};

/** DEPRECATED: Used for deprecated calls for backwards compatibility */
export type GetCatchFeeSubscriptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CatchFeeTypes>;
};

export type GetCatchPaidFeatureInput = {
  __typename?: 'GetCatchPaidFeatureInput';
  type: CatchPaidFeatureType;
};

export type GetCatchSubscriptionInput = {
  featureType?: InputMaybe<CatchFeatureType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CatchFeeTypes>;
};

export type GetCatchTasksInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TaskType>;
};

export type GetGeneratedDocumentUrlInput = {
  dsrsIdentifier: Scalars['String']['input'];
};

export type GetHealthPlanDetailsInput = {
  applicationID?: InputMaybe<Scalars['ID']['input']>;
  enrollmentGroupID?: InputMaybe<Scalars['ID']['input']>;
  explorerID?: InputMaybe<Scalars['ID']['input']>;
  planID?: InputMaybe<Scalars['String']['input']>;
};

export type GetTasksInput = {
  id: Scalars['ID']['input'];
};

export type HraOffer = {
  __typename?: 'HRAOffer';
  employeeSelfOnlyOfferAmount?: Maybe<Scalars['Dollars']['output']>;
  employeeSelfOnlyOfferFrequencyType?: Maybe<EmployeeSelfOnlyOfferFrequencyType>;
  /** Used to determine when the ICHRA offer will end and if the ICHRA offer if relevant to eligibility */
  endDate?: Maybe<Scalars['Date']['output']>;
  hraType?: Maybe<HraType>;
  /**
   * This indicator will be true when a consumer is attestting to being offered a new ICHRA,
   * but is also currently enrolled in an ICHRA that is offered by the same employer offering the new ICHRA
   */
  isEnrolledInOfferFromSameEmployer?: Maybe<Scalars['Boolean']['output']>;
  /**
   * This indicator will be true when a consumer is attesting to being offered a new HRA,
   * the consumer is also currently enrolled in an HRA that is offered by the same employer
   * offering the new HRA, and the HRA the consumer is currently enrolled in will end
   * on or after the day that the new HRA offer will begin.
   */
  isEnrolledInOfferFromSameEmployerUntilStartDate?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the primary member employer by the employer offering the HRA is within the member's tax household */
  isPrimaryInsuredMemberNotInTaxHh?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Used to determine SEP eligibility and SEP window (this field only impacts a
   * consumer's SEP eligibility)
   */
  noticeDate?: Maybe<Scalars['Date']['output']>;
  /** ApplicationMember.applicationMemberID of the applicant employed by the employer offering the HRA */
  primaryInsuredMemberIdentifier?: Maybe<Scalars['String']['output']>;
  /**
   * Used to determine SEP eligibility and Effective Date, and also used to
   * determine a consumer's ICHRA affordability. ICHRA affordability
   * determinations have downstream impacts on APTC eligibility.
   */
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type HraOfferInput = {
  employeeSelfOnlyOfferAmount?: InputMaybe<Scalars['Dollars']['input']>;
  employeeSelfOnlyOfferFrequencyType?: InputMaybe<EmployeeSelfOnlyOfferFrequencyType>;
  /** Used to determine when the ICHRA offer will end and if the ICHRA offer if relevant to eligibility */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  hraType?: InputMaybe<HraType>;
  /**
   * This indicator will be true when a consumer is attestting to being offered a new ICHRA,
   * but is also currently enrolled in an ICHRA that is offered by the same employer offering the new ICHRA
   */
  isEnrolledInOfferFromSameEmployer?: InputMaybe<Trinary>;
  /**
   * This indicator will be true when a consumer is attesting to being offered a new HRA,
   * the consumer is also currently enrolled in an HRA that is offered by the same employer
   * offering the new HRA, and the HRA the consumer is currently enrolled in will end
   * on or after the day that the new HRA offer will begin.
   */
  isEnrolledInOfferFromSameEmployerUntilStartDate?: InputMaybe<Trinary>;
  /** Indicates if the primary member employer by the employer offering the HRA is within the member's tax household */
  isPrimaryInsuredMemberNotInTaxHh?: InputMaybe<Trinary>;
  /**
   * Used to determine SEP eligibility and SEP window (this field only impacts a
   * consumer's SEP eligibility)
   */
  noticeDate?: InputMaybe<Scalars['Date']['input']>;
  /** ApplicationMember.applicationMemberID of the applicant employed by the employer offering the HRA */
  primaryInsuredMemberIdentifier?: InputMaybe<Scalars['String']['input']>;
  /**
   * Used to determine SEP eligibility and Effective Date, and also used to
   * determine a consumer's ICHRA affordability. ICHRA affordability
   * determinations have downstream impacts on APTC eligibility.
   */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export enum HraType {
  Ichra = 'ICHRA',
  Qsehra = 'QSEHRA'
}

export type Health = {
  __typename?: 'Health';
  /** Returns the user's health application, if started. */
  application?: Maybe<HealthApplication>;
  /**
   * Returns the health application by ID from EDE, including eligibility details
   * if any.
   */
  applicationSummary: ApplicationSummary;
  /** Returns applications by filter results with coverageYear and list of statuses */
  applications: Array<HealthApplication>;
  /** Get an enrollment group by ID */
  enrollmentGroup: EnrollmentGroup;
  /** List enrollment groups by application ID. You may also use application.enrollmentGroups */
  enrollmentGroups: Array<EnrollmentGroup>;
  /** Retrieves health explorer data for user to play around with marketplace */
  healthExplorerData?: Maybe<HealthExplorerData>;
  /** Retrieves a health explorer dependent by id */
  healthExplorerDependent: HealthExplorerDependent;
  /** Retrieves a list of health explorer dependents under this user */
  healthExplorerDependents: Array<HealthExplorerDependent>;
  /** The health preference on this user, if it exists */
  healthPreference?: Maybe<HealthPreference>;
  /**
   * Retrieves a household eligibility estimate.
   *
   * Note that this uses the already saved dependent and place information.
   *
   * If the server encounters an error when getting the estimate, this field will be null.
   */
  householdEligibilityEstimate?: Maybe<Array<DependentEligibilityEstimate>>;
  /** Gets an application member by ID */
  member: ApplicationMember;
  /** Retrieves a list of health policies, if they exist. Otherwise returns null. */
  policies?: Maybe<Array<HealthPolicy>>;
  /** Retrieves a health policy by ID */
  policy: HealthPolicy;
  /**
   * Retrieves the user's previous applications, for use with the
   * `importExistingApplication` mutation.
   *
   * Will match the applications based on the
   * coverageYear the applicant is seeking, and the coverageState that the member
   * is seeking coverage for. If there are any matches, returns any existing
   * applications.
   *
   * If there is no match, it is quite likely that the user needs to create a new
   * application instead of updating an existing one.
   *
   * Be sure to also check for existing applications using `health.applications`
   * query.
   *
   * Please note: If supplying an input, must supply both coverage year + coverage state.
   * Otherwise, this query uses the latest health insurance enrollment and the corresponding application to check for a state/cov year match. If
   * those are not found or those fields are not found, and the input is bad, this query will fail.
   *
   * Certain errors, like the lack of a date of birth, will result in the payload being null.
   *
   * If nothing returns, check the error item in the response for any details.
   * @deprecated Use health.previousApplicationsNew to retrieve error item of this query if nothing returns
   */
  previousApplications?: Maybe<Array<ExistingApplicationInformation>>;
};


export type HealthApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type HealthApplicationSummaryArgs = {
  id: Scalars['ID']['input'];
};


export type HealthApplicationsArgs = {
  input?: InputMaybe<ApplicationsInput>;
};


export type HealthEnrollmentGroupArgs = {
  id: Scalars['ID']['input'];
};


export type HealthEnrollmentGroupsArgs = {
  appID: Scalars['ID']['input'];
};


export type HealthHealthExplorerDependentArgs = {
  id: Scalars['ID']['input'];
};


export type HealthMemberArgs = {
  id: Scalars['ID']['input'];
};


export type HealthPoliciesArgs = {
  input?: InputMaybe<PoliciesInput>;
};


export type HealthPolicyArgs = {
  id: Scalars['ID']['input'];
};


export type HealthPreviousApplicationsArgs = {
  input?: InputMaybe<PreviousApplicationsInput>;
};

/** HealthApplication represents an application for healthcare. */
export type HealthApplication = HealthInsuranceApplication & {
  __typename?: 'HealthApplication';
  /** Get all members. */
  allMembers: Array<ApplicationMember>;
  /** Get the primary applicant (aka, the Catch user) */
  applicant?: Maybe<ApplicationMember>;
  /** Application Assistors on this application that the user has added. */
  applicationAssistors: Array<ProfessionalAssistor>;
  /** Purpose of the application */
  applicationContext?: Maybe<ApplicationContext>;
  /** Origin of this application - Catch or imported */
  applicationOrigin: ApplicationOrigin;
  /** upserted (not calculated) application phase on creation. Note that this may not be present or be accurate on imported applications */
  applicationPhase?: Maybe<ApplicationPhase>;
  applicationStateExchangeFields?: Maybe<ApplicationStateExchangeFields>;
  /** This field indicates the EDE version of the application as returned from EDE */
  applicationVersionNum?: Maybe<Scalars['Int']['output']>;
  /**
   * This is the applied CSR level for this application and its members.
   * Defaults to CSR_NONE. Automatically updates when the Plan is upserted to the
   * HealthApplication. Specifically checks that selectedMetalLevel was upserted.
   */
  appliedCSRLevel: CsrLevel;
  aptcAgreement?: Maybe<Scalars['Boolean']['output']>;
  aptcHouseholdAmount?: Maybe<Scalars['Dollars']['output']>;
  aptcHouseholdRemaining?: Maybe<Scalars['Dollars']['output']>;
  aptcHouseholdToApply?: Maybe<Scalars['Dollars']['output']>;
  /** Signature text */
  aptcSignature?: Maybe<Scalars['String']['output']>;
  /** S8 */
  areAllSameAddress?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S14
   * @deprecated Phase 2 question
   */
  areApplicationsCitizens?: Maybe<Scalars['Boolean']['output']>;
  /** P2 #14 - are all dependents your children/stepchildren, single, and under 26 */
  areDependentsChildOrStepchildSingleUnder26?: Maybe<Scalars['Boolean']['output']>;
  /** S26 */
  areDependentsLivingWithParentNotOnTaxReturn?: Maybe<Scalars['Boolean']['output']>;
  /** Async submission status */
  asyncStatus?: Maybe<AsyncStatus>;
  /** Get members of this application who are CHIP Eligible */
  chipEligibleMembers: Array<ApplicationMember>;
  countyfips?: Maybe<Scalars['String']['output']>;
  coverageState?: Maybe<Scalars['String']['output']>;
  coverageYearNumber?: Maybe<Scalars['Int']['output']>;
  /** date application was created */
  createdOn: Scalars['Date']['output'];
  /** Application Creation Origin as specified by EDE */
  creationOriginType: EdeApplicationOrigin;
  dmiDocumentUploads?: Maybe<Array<DmiDocumentUpload>>;
  dmiNotices?: Maybe<Array<GeneratedPhysicalDocument>>;
  /** Data Matching Issues */
  dmis?: Maybe<Array<Dmi>>;
  /**
   * This field contains the data for the EDN document for this application
   * @deprecated Use app.ednDocuments instead, CMS CR
   */
  ednDocument?: Maybe<GeneratedPhysicalDocument>;
  /** This field contains a list of EDN documents for this application sorted by most recent first */
  ednDocuments: Array<GeneratedPhysicalDocument>;
  /**
   * Provides a summary of eligibility results for the application
   * If householdIncomeOverride is specified, get a new estimate for the application but
   * using the provided income.
   */
  eligibility: EligibilitySummary;
  /** When eligibility was last fetched */
  eligibilityLastFetched?: Maybe<Scalars['Time']['output']>;
  /**
   * Pass in an ID For the specific enrollment. Otherwise, just returns the first one.
   * @deprecated Use `application.policies` to get the policy instead
   */
  enrollment: HealthInsuranceEnrollment;
  /** Returns a list of enrollment groups on this application. Note that this is strictly for the enrollment payload and does not reflect actual enrollment. */
  enrollmentGroups: Array<EnrollmentGroup>;
  /** @deprecated Use `application.policies` to get the policy instead */
  enrollments: Array<HealthInsuranceEnrollment>;
  /** Get members of this application who are Exchange Eligible */
  exchangeEligibleMembers: Array<ApplicationMember>;
  handoffUrl: Scalars['String']['output'];
  /** Indicates whether ALL members (requesting coverage) on this application are medicaid or chip eligible */
  hasAllMedicaidChipEligibleMembers: Scalars['Boolean']['output'];
  /** Indicates whether this application has ANY medicaid or chip eligible members */
  hasAnyMedicaidChipEligibleMembers: Scalars['Boolean']['output'];
  /** Indicates whether eligibility has changed since the last eligibility call for all members requesting coverage. Note that if eligibility has not been called before this will return FALSE */
  hasEligibilityChanged: Scalars['Boolean']['output'];
  /** Indicates whether we have permissions to access this application or not */
  hasSubmittedPermissions: Scalars['Boolean']['output'];
  /** True if the applicant or the spouse has unemployment income */
  hasUnemploymentIncome: Scalars['Boolean']['output'];
  /** S4 */
  householdIncome: Scalars['Int']['output'];
  /** The Catch UUID, used for upserting an existing application */
  id: Scalars['ID']['output'];
  /** Get members of this application who are IEP Eligible */
  iepEligibleMembers: Array<ApplicationMember>;
  /** Documented, NOT attested, amount to determine income discrepancy */
  incomeExplanationDocumentedAmount?: Maybe<Scalars['Dollars']['output']>;
  incomeExplanationRequiredIndicator: Scalars['Boolean']['output'];
  /** Income discrepancy after update application, before submit */
  incomeExplanationRequiredReason?: Maybe<IncomeExplanationReason>;
  insuranceApplicationIdentifier?: Maybe<Scalars['String']['output']>;
  /** 248 */
  isAbsentParentAgreement?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S11
   * @deprecated Phase 2 question
   */
  isAnyoneFullTimeStudent1822?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S16
   * @deprecated Phase 2 question
   */
  isApplicationNameSameAsSsn?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S15
   * @deprecated Phase 2 question
   */
  isCanProvideSsn?: Maybe<Scalars['Boolean']['output']>;
  /** 254 */
  isChangeInformationAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** S22 */
  isClaimingAllDependentsOnTax?: Maybe<Scalars['Boolean']['output']>;
  /** S20 */
  isCoveredThroughJobOrCobra?: Maybe<Scalars['Boolean']['output']>;
  /** This field indicates if this application is deleted in our system */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** S23 */
  isDependentSingleChild25OrYounger?: Maybe<Scalars['Boolean']['output']>;
  /** This field indicates whether this application has gone through fetchEligibility yet */
  isEligibilityDetermined: Scalars['Boolean']['output'];
  /**
   * S21
   * @deprecated Phase 2 question
   */
  isFormerFosterCareAndUnder25?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S18
   * @deprecated Phase 2 question
   */
  isIncarcerated?: Maybe<Scalars['Boolean']['output']>;
  /** S19 */
  isIndianOrAlaskan?: Maybe<Scalars['Boolean']['output']>;
  /** 247 */
  isMedicaidRequirementAgreement?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S17
   * @deprecated Phase 2 question
   */
  isNaturalizedOrDerivedCitizenship?: Maybe<Scalars['Boolean']['output']>;
  /** Not in UI */
  isNonIncarcerationAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** S27 */
  isOfferedIchra?: Maybe<Scalars['Boolean']['output']>;
  /** 256 */
  isPenaltyOfPerjuryAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** S9 */
  isPlanningToFileTax?: Maybe<Scalars['Boolean']['output']>;
  /** Data was prefilled by the health enrollment agent */
  isPrefill: Scalars['Boolean']['output'];
  /**
   * S12
   * @deprecated Phase 2 question
   */
  isPregnantOrHadChildLast60Days?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Privacy Screen Checkbox
   * @deprecated Use viewer.health.healthPrivacy
   */
  isPrivacyAuthorizeAgree?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Privacy Screen Checkbox
   * @deprecated Use viewer.health.healthPrivacy
   */
  isPrivacyDataUseAgree?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Privacy Screen Checkbox
   * @deprecated Use viewer.health.healthPrivacy
   */
  isPrivacyTruthfulAgree?: Maybe<Scalars['Boolean']['output']>;
  /** 252 */
  isRenewalAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** S5, S6 */
  isRequestingFinancialAssistance?: Maybe<Scalars['Boolean']['output']>;
  isResidesInApplicationState?: Maybe<Scalars['Boolean']['output']>;
  /** S10 */
  isResponsibleForChildNotOnTaxReturn?: Maybe<Scalars['Boolean']['output']>;
  /** 252 */
  isReuseTaxDataPermission?: Maybe<Scalars['Boolean']['output']>;
  /** S3 */
  isSelfCoverage?: Maybe<Scalars['Boolean']['output']>;
  /** S3 */
  isSpouseCoverage?: Maybe<Scalars['Boolean']['output']>;
  /** A true value indicates the user has started the actual application process */
  isStartedApplication: Scalars['Boolean']['output'];
  /**
   * S25
   * @deprecated Phase 2 question
   */
  isStepchildOrGrandchild?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the tax household anchor attested that the tax household reconciled to premium tax credits on last year's tax return */
  isTaxCreditReconciled?: Maybe<Scalars['Boolean']['output']>;
  /** 255 */
  isTerminateCoverageOtherMecFoundAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** The date and time the data in the application was last updated */
  lastUpdated: Scalars['Time']['output'];
  /** The last URL route we want to bring the user back to if in progress */
  lastUsedRoute?: Maybe<Scalars['String']['output']>;
  /** The date and time the data in the application was last updated by a user */
  lastUserUpdate?: Maybe<Scalars['Time']['output']>;
  /** S1 */
  maritalStatus?: Maybe<MaritalStatus>;
  /** Get members of this application who are Medicaid Eligible */
  medicaidEligibleMembers: Array<ApplicationMember>;
  /**
   * Get members who are not the Catch user, and who are either a tax dependent or
   * are requesting coverage.
   */
  members: Array<ApplicationMember>;
  /** Get members of this application who are NOT Medicaid Eligible */
  nonMedicaidEligibleMembers: Array<ApplicationMember>;
  /** S3 */
  numDependentsRequestCoverage: Scalars['Int']['output'];
  /** S2 */
  numTaxDependents: Scalars['Int']['output'];
  /** Source of data. Exists only if the data was prefilled */
  parent?: Maybe<HealthApplication>;
  pathway?: Maybe<HealthPathwayType>;
  /**
   * The partner who will recieve this application
   * @deprecated Use pathway for auto determined instead
   */
  pathwayType: HealthPathway;
  /** Returns health plan details from Marketplace (live query) based on the selectedProviderPlanID and the members on the enrollment of this application */
  plan?: Maybe<HealthPlan>;
  /** The premium of the selected plan */
  planPremium?: Maybe<Scalars['Dollars']['output']>;
  /** The effective premium of the selected plan */
  planPremiumEffective?: Maybe<Scalars['Dollars']['output']>;
  /** Returns a list of policies associated with this application */
  policies: Array<HealthPolicy>;
  /** Indicates our computed effective date */
  policyEffectiveDate?: Maybe<Scalars['Date']['output']>;
  previousAptcHouseholdAmount?: Maybe<Scalars['Dollars']['output']>;
  processStatus?: Maybe<Scalars['String']['output']>;
  /** 253 */
  renewEligibilityYearQuantity?: Maybe<Scalars['Int']['output']>;
  /** Screening questions - note that this is backwards compatible, same values as other fields */
  screening?: Maybe<HealthScreeningQuestions>;
  /** computed application phase based on screening questions only */
  screeningPhase?: Maybe<ApplicationPhase>;
  /** The metal level of the selected plan */
  selectedMetalLevel?: Maybe<MetalLevel>;
  /** The provider plan ID of the selected plan - HIOS ID (14 digit code) */
  selectedPlanID?: Maybe<Scalars['ID']['output']>;
  /** The plan issuer ID of the selected plan */
  selectedPlanIssuerID?: Maybe<Scalars['String']['output']>;
  /**
   * The provider plan ID of the selected plan
   * @deprecated Use `selectedPlanID` instead
   */
  selectedProviderPlanID?: Maybe<Scalars['String']['output']>;
  /** Get members of this application who are SEP Eligible */
  sepEligibleMembers: Array<ApplicationMember>;
  /** Indicates whether eligibility should be refetched */
  shouldRefetchEligibility: Scalars['Boolean']['output'];
  /** 258 */
  signatureDate?: Maybe<Scalars['Date']['output']>;
  /** 258 */
  signatureText?: Maybe<Scalars['String']['output']>;
  /** 258 */
  signatureType?: Maybe<SignatureType>;
  /** @deprecated Use app.stateReferenceData.stateCHIPWaitingPeriod */
  stateCHIPWaitingPeriod?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use app.stateReferenceData.deprivationRequirementRetained */
  stateDeprivationRequirementRetained: Scalars['Boolean']['output'];
  /**
   * The app is in state that allows EDE to determine CHIP eligibility. The field is False if the state has their own CHIP agency that determines CHIP eligibility.
   * @deprecated Use `app.stateReferenceData.stateDeterminesChipEligibility` instead
   */
  stateDeterminesChipEligibility: Scalars['Boolean']['output'];
  /**
   * The app is in state that allows EDE to determine Medicaid eligibility
   * @deprecated Use `app.stateReferenceData.stateDeterminesMedicaidEligibility` instead
   */
  stateDeterminesMedicaidEligibility: Scalars['Boolean']['output'];
  stateReferenceData: StateReferenceData;
  /** This field shows the current status of this application */
  status: HealthApplicationStatus;
  /** Application Submission Origin as specified by EDE - type of application on submission */
  submissionOriginType: EdeApplicationOrigin;
  sviDocumentUploads?: Maybe<Array<SviDocumentUpload>>;
  sviNotices?: Maybe<Array<GeneratedPhysicalDocument>>;
  /** Special Enrollment Period Verification Issues */
  svis?: Maybe<Array<Svi>>;
  /** 1095-A Tax Forms for APTC. This query contains all historical tax forms for an application */
  taxForms?: Maybe<Array<GeneratedPhysicalDocument>>;
  /** Stringified JSON of format {str: bool}, e.g. {'249': true, '192': false, ...} */
  uiQuestionsToDisplay?: Maybe<Scalars['JSON']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


/** HealthApplication represents an application for healthcare. */
export type HealthApplicationEligibilityArgs = {
  householdIncomeOverride?: InputMaybe<Scalars['Dollars']['input']>;
};


/** HealthApplication represents an application for healthcare. */
export type HealthApplicationEnrollmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type HealthApplicationEvent = Event & {
  __typename?: 'HealthApplicationEvent';
  enrollment?: Maybe<HealthInsuranceEnrollment>;
  /** The ID of the event */
  id: Scalars['ID']['output'];
  time: Scalars['Time']['output'];
  type: HealthApplicationEventType;
};

export enum HealthApplicationEventType {
  ApplicationDeleted = 'APPLICATION_DELETED',
  ApplicationStarted = 'APPLICATION_STARTED',
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  PlanSelected = 'PLAN_SELECTED'
}

export enum HealthApplicationStatus {
  /** the app was cancelled due to a canceled pending plan selection */
  Canceled = 'CANCELED',
  /** ede says this application was deleted */
  Deleted = 'DELETED',
  /** data for health app saved on catch, but not submitted to ede */
  Draft = 'DRAFT',
  /** app was submitted for enrollment successfully */
  Enrolled = 'ENROLLED',
  /** app was submitted for enrollment but something went wrong */
  EnrollmentStuck = 'ENROLLMENT_STUCK',
  /**
   * the app is currently being used for exploring plans before a real application
   * @deprecated Deprecated for standalone explorer
   */
  Explorer = 'EXPLORER',
  /** created but not submitted */
  InProgress = 'IN_PROGRESS',
  PendingEnrollment = 'PENDING_ENROLLMENT',
  /** the app is in a temporary renewal status to be merged using `importPreviousApplication` */
  Renewal = 'RENEWAL',
  /** health application was submitted */
  Submitted = 'SUBMITTED'
}

export type HealthEnrollmentEvent = Event & {
  __typename?: 'HealthEnrollmentEvent';
  enrollment?: Maybe<HealthInsuranceEnrollment>;
  /** The ID of the event */
  id: Scalars['ID']['output'];
  time: Scalars['Time']['output'];
  type: HealthEnrollmentEventType;
};

export enum HealthEnrollmentEventType {
  ChangeReported = 'CHANGE_REPORTED',
  CoverageCanceled = 'COVERAGE_CANCELED',
  CoverageEnded = 'COVERAGE_ENDED',
  CoverageEnrolled = 'COVERAGE_ENROLLED',
  CoverageStarted = 'COVERAGE_STARTED',
  PlanLinked = 'PLAN_LINKED'
}

export type HealthEnrollmentTask = Task & {
  __typename?: 'HealthEnrollmentTask';
  assignee?: Maybe<User>;
  catchTask: CatchTask;
  createdOn: Scalars['Time']['output'];
  enrollment?: Maybe<HealthInsuranceEnrollment>;
  id: Scalars['ID']['output'];
  isAssignment: Scalars['Boolean']['output'];
  lastUpdated: Scalars['Time']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  personReference: PersonReference;
  priority?: Maybe<TaskPriority>;
  status: TaskStatus;
  type: TaskType;
  user: User;
};

export type HealthErrorItem = ErrorItem & {
  __typename?: 'HealthErrorItem';
  /** A code that describes the error */
  code: ErrorCode;
  /** The field found in the type that is the cause of the error */
  field?: Maybe<Scalars['String']['output']>;
  memberID?: Maybe<Scalars['ID']['output']>;
  /** A message that is human-readable and describes the error in greater detail */
  message?: Maybe<Scalars['String']['output']>;
  /** Explains why the field is incorrect */
  providerCode: HealthValidationErrorCode;
};

export enum HealthExitStage {
  Decent = 'DECENT',
  HealthcareGov = 'HEALTHCARE_GOV',
  Healthsherpa = 'HEALTHSHERPA',
  Medicaid = 'MEDICAID',
  Medicare = 'MEDICARE',
  StateExchange = 'STATE_EXCHANGE',
  Unknown = 'UNKNOWN'
}

export type HealthExplorerData = {
  __typename?: 'HealthExplorerData';
  /** Indicates if we can properly create an enrollment off of this explorer data */
  canCreateEnrollment: Scalars['Boolean']['output'];
  countyfips: Scalars['String']['output'];
  coverageYear: Scalars['Int']['output'];
  /** Query the Marketplace for available dental plans with the data in the explorer */
  dentalPlans: SortedHealthPlansResponse;
  dependents: Array<HealthExplorerDependent>;
  email?: Maybe<Scalars['String']['output']>;
  /** Formatted handoff url */
  handoffUrl?: Maybe<Scalars['String']['output']>;
  /** Query the Marketplace for plan details w/ the providerPlanID. Will return `nil` if providerPlanID or planID input is empty */
  healthPlanDetails?: Maybe<HealthPlan>;
  /** Query the Marketplace for available plans w/ this data */
  healthPlans: SortedHealthPlansResponse;
  healthPreference: HealthPreference;
  id: Scalars['ID']['output'];
  income?: Maybe<Scalars['Dollars']['output']>;
  isSEP: Scalars['Boolean']['output'];
  /** Query the Marketplace for eligibility results */
  marketplaceEligibility: Array<MarketplaceEligibility>;
  pathway?: Maybe<HealthPathwayType>;
  /** @deprecated This was previously upserted and now is deduced using pathway */
  pathwayType?: Maybe<HealthPathway>;
  /** List of possible coverage years for the state - will fallback if no state in data */
  possibleCoverageYears: Array<Scalars['Int']['output']>;
  providerPlanID?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};


export type HealthExplorerDataHealthPlanDetailsArgs = {
  planID?: InputMaybe<Scalars['String']['input']>;
};

/** Zipcode, Countyfips, State, coverageYear is REQUIRED when upserting for the first time */
export type HealthExplorerDataInput = {
  countyfips?: InputMaybe<Scalars['String']['input']>;
  coverageYear?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  income?: InputMaybe<Scalars['Dollars']['input']>;
  isSEP?: InputMaybe<Scalars['Boolean']['input']>;
  providerPlanID?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type HealthExplorerDependent = {
  __typename?: 'HealthExplorerDependent';
  age: Scalars['Int']['output'];
  aptcEligible: Scalars['Boolean']['output'];
  hasMec: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isApplying: Scalars['Boolean']['output'];
  isParent: Scalars['Boolean']['output'];
  isPregnant: Scalars['Boolean']['output'];
  isSmoker: Scalars['Boolean']['output'];
  relation: Relation;
  sex?: Maybe<Sex>;
};

/** AGE and RELATION are REQUIRED on creation */
export type HealthExplorerDependentInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  aptcEligible?: InputMaybe<Scalars['Boolean']['input']>;
  hasMec?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isApplying?: InputMaybe<Scalars['Boolean']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  isPregnant?: InputMaybe<Scalars['Boolean']['input']>;
  isSmoker?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<Relation>;
  sex?: InputMaybe<Sex>;
};

export type HealthHandoffInput = {
  /** Where the user exited the flow */
  exitStage: HealthExitStage;
};

export type HealthInformation = {
  __typename?: 'HealthInformation';
  /** The user's county fips code **NOTE: FIELD DEPRECATED, USE `ApplicationMember.HomeAddress.countyFips` (main applicant) INSTEAD** */
  countyfips?: Maybe<Scalars['String']['output']>;
  /** the coverage year number the user is looking for - **NOTE: For Reporting changes, use `HealthApplication.coverageYearNumber`. For importing an application from EDE, populate this field** */
  coverageYearNumber?: Maybe<Scalars['Int']['output']>;
  /** If the user enrolled for health insurance */
  didEnroll: Trinary;
  /** Where the user exited the flow */
  exitStage?: Maybe<HealthExitStage>;
  /** The selected plan, if the ID exists */
  providerPlan?: Maybe<HealthPlan>;
  /** The ID of the selected plan */
  providerPlanID?: Maybe<Scalars['ID']['output']>;
  /** the 2-letter state code - **NOTE: For Reporting changes, use `HealthApplication.coverageState`. For importing an application from EDE, populate this field** */
  state?: Maybe<Scalars['String']['output']>;
  /** The total income in the user's household **NOTE: FIELD DEPRECATED, USE `HealthApplication.householdIncome` INSTEAD** */
  totalHouseholdIncome?: Maybe<Scalars['Dollars']['output']>;
  /** The total people in the user's household **NOTE: FIELD UNUSED** */
  totalPeopleHousehold?: Maybe<Scalars['Int']['output']>;
  /** The user's zipcode **NOTE: FIELD DEPRECATED, USE `ApplicationMember.HomeAddress.Zip` (main applicant) INSTEAD** */
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type HealthInformationInput = {
  /** The user's county fips code */
  countyfips?: InputMaybe<Scalars['String']['input']>;
  /** the coverage year number the user is looking for - NOTE: Used in determining new/existing application to grab. Important */
  coverageYearNumber?: InputMaybe<Scalars['Int']['input']>;
  /** If the user enrolled for health insurance */
  didEnroll?: InputMaybe<Trinary>;
  /** Where the user exited the flow */
  exitStage?: InputMaybe<HealthExitStage>;
  /** The ID of the selected plan */
  providerPlanID?: InputMaybe<Scalars['ID']['input']>;
  /** the 2-letter state code - NOTE: Used in determining new/existing application to grab. Important */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The total income in the user's household */
  totalHouseholdIncome?: InputMaybe<Scalars['Dollars']['input']>;
  /** The total people in the user's household */
  totalPeopleHousehold?: InputMaybe<Scalars['Int']['input']>;
  /** The user's zipcode */
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type HealthInsurance = {
  __typename?: 'HealthInsurance';
  aptcAmount?: Maybe<Scalars['Dollars']['output']>;
  /** Info on the user's health insurance card, if it's been uploaded */
  card?: Maybe<HealthInsuranceCard>;
  carrier?: Maybe<Scalars['String']['output']>;
  /** A list of IDs for the dependents that are enrolled in the plan */
  enrolledDependentIDs?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  insuranceSource?: Maybe<InsuranceSource>;
  /** User notes */
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyStatus?: Maybe<PolicyStatus>;
  premium?: Maybe<Scalars['Dollars']['output']>;
  premiumEffective?: Maybe<Scalars['Dollars']['output']>;
  providerPlanID?: Maybe<Scalars['ID']['output']>;
};

/** The abstract type that represents a health insurance application */
export type HealthInsuranceApplication = {
  /** plan state */
  coverageState?: Maybe<Scalars['String']['output']>;
  coverageYearNumber?: Maybe<Scalars['Int']['output']>;
  /** household income */
  householdIncome: Scalars['Int']['output'];
  /** The Catch UUID */
  id: Scalars['ID']['output'];
  /** The date and time the data in the application was last updated */
  lastUpdated: Scalars['Time']['output'];
  /** The last URL route we want to bring the user back to if in progress */
  lastUsedRoute?: Maybe<Scalars['String']['output']>;
  /** The date and time the data in the application was last updated by a user */
  lastUserUpdate?: Maybe<Scalars['Time']['output']>;
  /** tax household size */
  numTaxDependents: Scalars['Int']['output'];
  pathway?: Maybe<HealthPathwayType>;
  /**
   * The partner who will recieve this application
   * @deprecated Use pathway for auto determined instead
   */
  pathwayType: HealthPathway;
  /** HIOS ID (14 digit code) */
  selectedPlanID?: Maybe<Scalars['ID']['output']>;
  signatureDate?: Maybe<Scalars['Date']['output']>;
  signatureText?: Maybe<Scalars['String']['output']>;
  /** This field shows the current status of this application */
  status: HealthApplicationStatus;
};

export type HealthInsuranceCard = {
  __typename?: 'HealthInsuranceCard';
  /** The back of the card, if it has been uploaded */
  back?: Maybe<HealthInsuranceCardSide>;
  /** The front of the card, if it has been uploaded */
  front?: Maybe<HealthInsuranceCardSide>;
  /** The ID of Health Insurance Wallet item */
  id: Scalars['ID']['output'];
};

export type HealthInsuranceCardSide = {
  __typename?: 'HealthInsuranceCardSide';
  /** The ID of the image card */
  id: Scalars['ID']['output'];
  /** The temporary URL from which the image can be accessed */
  url: Scalars['String']['output'];
};

export type HealthInsuranceEnrollment = InsuranceEnrollment & {
  __typename?: 'HealthInsuranceEnrollment';
  /** actions that the user needs to take to resolve this enrollment. Upsertable to clear it */
  actionsNeeded: Array<EnrollmentAction>;
  /** @deprecated Use `healthApplication` instead */
  application?: Maybe<HealthApplication>;
  applicationID?: Maybe<Scalars['ID']['output']>;
  baseMembers?: Maybe<Array<Maybe<Member>>>;
  /**
   * Queries for the crosswalk plan (next year's equivalent to this year's plan). Note that it might not exist for enrollments with no policies
   * @deprecated Not used
   */
  crosswalkPlan?: Maybe<CrosswalkPlan>;
  enrollmentType: InsuranceEnrollmentType;
  /** A flag to indicate whether this enrollment has an associated dental plan */
  hasAssociatedDentalPlan: Scalars['Boolean']['output'];
  /** An application that holds data that shows what the user selected to enroll and data relevent for the enrollment's pathwayType */
  healthApplication?: Maybe<HealthInsuranceApplication>;
  /** The Catch UUID */
  id: Scalars['ID']['output'];
  /** indicates whether this enrollment is open enrollment */
  isOpenEnrollment: Scalars['Boolean']['output'];
  isOptOutRenewal: Scalars['Boolean']['output'];
  members: Array<ApplicationMember>;
  /** The provider for this health insurance enrollment */
  pathwayType: HealthPathway;
  /** @deprecated Not used */
  person?: Maybe<User>;
  /** Queries a plan from the marketplace by provider plan ID (input) for members under this enrollment */
  plan: HealthPlan;
  /** Queries available plans from the marketplace for members under this enrollment */
  plans: HealthPlans;
  /** The policy tied to the application */
  policy?: Maybe<HealthPolicy>;
  policyID?: Maybe<Scalars['ID']['output']>;
  sortedPlans: SortedHealthPlansResponse;
  /** A process started by a user to get insurance health, dental. The outcome of this process is an insurance policy. */
  status: HealthInsuranceEnrollmentStatus;
  /** @deprecated Use HealthEnrollment.task (flattened) */
  task?: Maybe<Task>;
  /** The coverage year */
  year?: Maybe<Scalars['Int']['output']>;
};


export type HealthInsuranceEnrollmentPlanArgs = {
  id: Scalars['ID']['input'];
};

export type HealthInsuranceEnrollmentInput = {
  /** The ID of the insurance application the user fills out to get health or dental insurance */
  applicationID?: InputMaybe<Scalars['ID']['input']>;
  /** The Catch UUID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Soft deletes an enrollment. Only works for admin users. */
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the policy tied to the application */
  policyID?: InputMaybe<Scalars['ID']['input']>;
  /** The actions to manually remove. By removing, the batch jobs to update actions will not update for 5 days. */
  removeActionsNeeded?: InputMaybe<Array<EnrollmentAction>>;
  /** A process started by a user to get insurance health, dental. The outcome of this process is an insurance policy. */
  status?: InputMaybe<HealthInsuranceEnrollmentStatus>;
  /** The coverage year */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export enum HealthInsuranceEnrollmentStatus {
  /** The user can use the policy. */
  Active = 'ACTIVE',
  /**
   * The user hasn't started the real application yet, just exploring
   * @deprecated Deprecated for standalone explorer
   */
  Explorer = 'EXPLORER',
  /** The opposite of active. Represents canceled, terminated, expired. */
  Inactive = 'INACTIVE',
  /** The user has started the process to apply for health insurance through the open enrollment period */
  InitialOep = 'INITIAL_OEP',
  /** The user has started the process to apply for health insurance through special enrollment. */
  InitialSep = 'INITIAL_SEP',
  /** The user either needs to submit docs to resolve an SVI, or make a binding payment. Check actionsNeeded */
  Pending = 'PENDING',
  /** The user has completed an insurance pathway through Health Sherpa and the backend must import the policy. */
  PendingImport = 'PENDING_IMPORT',
  /** This enrollment is all set, pending start date */
  PendingStartDate = 'PENDING_START_DATE',
  /** The user needs to wait till support is done with this. */
  PendingSupportTask = 'PENDING_SUPPORT_TASK',
  /** The platform has prefilled data for the user to begin to apply for health insurance. This enrollment was not initiated by the user. Note there can only be one PREFILL enrollment at any given time. */
  Prefill = 'PREFILL'
}

/** Deprecated type: Admin only `HealthEnrollmentsConnection` to replace this; edges are `HealthEnrollment` */
export type HealthInsuranceEnrollmentsConnection = {
  __typename?: 'HealthInsuranceEnrollmentsConnection';
  edges: Array<HealthInsuranceEnrollment>;
  pageInfo: PageInfo;
};

export type HealthInsuranceInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  /** If ID is provided, this will be treated as an update. Otherwise, the data will be created */
  id?: InputMaybe<Scalars['ID']['input']>;
  insuranceSource?: InputMaybe<InsuranceSource>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum HealthPathway {
  California = 'CALIFORNIA',
  /** Enhanced Direct Enrollment, available in all ffmStates */
  Ede = 'EDE',
  /** Legacy plans obtained in OE 2019 */
  HealthSherpa = 'HEALTH_SHERPA',
  /** Oscar */
  Oscar = 'OSCAR',
  /** State exchange */
  StateExchange = 'STATE_EXCHANGE'
}

export enum HealthPathwayType {
  Ffm = 'FFM',
  Sbm = 'SBM'
}

export type HealthPlan = {
  __typename?: 'HealthPlan';
  aptcEligiblePremium: Scalars['Float']['output'];
  benefits: Array<Benefits>;
  benefitsURL: Scalars['String']['output'];
  brochureURL: Scalars['String']['output'];
  certification: Scalars['String']['output'];
  deductibles: Array<Deductibles>;
  diseaseManagementPrograms: Array<Scalars['String']['output']>;
  ehbPremium: Scalars['Float']['output'];
  formularyURL: Scalars['String']['output'];
  guaranteedRate: Scalars['Boolean']['output'];
  hasDental: Scalars['Boolean']['output'];
  hasNationalNetwork: Scalars['Boolean']['output'];
  hasVision: Scalars['Boolean']['output'];
  hsaEligible: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insuranceMarket: Scalars['String']['output'];
  isIneligible: Scalars['Boolean']['output'];
  isStandard: Scalars['Boolean']['output'];
  issuer: Issuer;
  market: Scalars['String']['output'];
  maxAgeChild: Scalars['Int']['output'];
  metalLevel: Scalars['String']['output'];
  moops: Array<Moops>;
  name: Scalars['String']['output'];
  networkURL: Scalars['String']['output'];
  oopc: Scalars['Float']['output'];
  pediatricEHBPremium: Scalars['Float']['output'];
  premium: Scalars['Float']['output'];
  premiumWithCredit: Scalars['Float']['output'];
  productDivision: Scalars['String']['output'];
  qualityRating: QualityRating;
  sbcs: Sbcs;
  simpleChoice: Scalars['Boolean']['output'];
  specialistReferralRequired: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  suppression: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type HealthPlanInput = {
  /** health insurance enrollment input for plan detail calculation for members */
  healthInsuranceEnrollmentID: Scalars['ID']['input'];
  /** the ID of the plan */
  id: Scalars['ID']['input'];
};

export enum HealthPlanType {
  /** insurance plans (exclusive provider organizations) */
  Epo = 'EPO',
  /** health maintenance organizations */
  Hmo = 'HMO',
  /** point-of-service plan */
  Pos = 'POS',
  /** preferred provider organizations */
  Ppo = 'PPO'
}

export type HealthPlans = {
  __typename?: 'HealthPlans';
  facetGroups: Array<FacetGroup>;
  plans: Array<HealthPlan>;
  rateArea: RateArea;
  total: Scalars['Int']['output'];
};

export type HealthPolicy = InsurancePolicy & {
  __typename?: 'HealthPolicy';
  /** Defined assistor's national producer number */
  agentID?: Maybe<Scalars['String']['output']>;
  /** The application associated with this policy */
  application?: Maybe<HealthApplication>;
  aptcAmount?: Maybe<Scalars['Dollars']['output']>;
  /** Info on the user's health insurance card, if it's been uploaded */
  card?: Maybe<HealthInsuranceCard>;
  carrier: Scalars['String']['output'];
  commissionStatus?: Maybe<CommissionStatus>;
  coverageState?: Maybe<Scalars['String']['output']>;
  coverageYear?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  /** A list of IDs for the dependents that are enrolled in the plan */
  enrolledDependentIDs?: Maybe<Array<Scalars['ID']['output']>>;
  /** A list of dependents that are enrolled in the plan */
  enrolledDependents?: Maybe<Array<Member>>;
  /**
   * The enrollment ID tied to this policy
   * @deprecated No longer supported
   */
  enrollmentID?: Maybe<Scalars['ID']['output']>;
  /** The exchangeAssignedPolicyIdentifier, seems to exist for non-effectuated AND effectuated policies */
  exchangePolicyNumber?: Maybe<Scalars['String']['output']>;
  /** The `exchangeAssignedSubscriberIdentifier`, or `insuredMemberIdentifier` for the main subscriber, this is Health Exchange assigned */
  exchangeSubscriberID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceSource?: Maybe<InsuranceSource>;
  /**
   * Return `true` if policy is on an ARP application
   * @deprecated No longer supported
   */
  isCatchARP: Scalars['Boolean']['output'];
  /** This field indicates if this policy is deleted in our system */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** The user must log into either Health Sherpa or Decent and upload documents. Can be set for EDE DMIs and DVIs */
  isPendingDocUpload: Scalars['Boolean']['output'];
  lastPaidCommission?: Maybe<Scalars['Date']['output']>;
  /** User notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Tells you if a person should or should not make payments to the policy. */
  paymentStatus?: Maybe<PolicyPaymentStatus>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName: Scalars['String']['output'];
  /** The issuerAssignedPolicyIdentifier, seems to not exist for non-effectuated policies */
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyStatus?: Maybe<PolicyStatus>;
  premium?: Maybe<Scalars['Dollars']['output']>;
  premiumEffective?: Maybe<Scalars['Dollars']['output']>;
  /** The type of policy this is - should be DENTAL/HEALTH */
  productType?: Maybe<PlanType>;
  providerPlan?: Maybe<HealthPlan>;
  providerPlanID?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  /** The `issuerAssignedSubscriberIdentifier` or `issuerInsuredMemberIdentifier` for the main subscriber */
  subscriberID?: Maybe<Scalars['String']['output']>;
};

export type HealthPreference = {
  __typename?: 'HealthPreference';
  drugsWanted?: Maybe<Array<Drug>>;
  financialPreference?: Maybe<FinancialPreferenceType>;
  healthExplorerData?: Maybe<HealthExplorerData>;
  ownerID: Scalars['ID']['output'];
  plannedUsage?: Maybe<HealthSortWeightType>;
  providersWanted?: Maybe<Array<HealthProvider>>;
};

export type HealthPreferenceInput = {
  drugsWanted?: InputMaybe<Array<DrugInput>>;
  financialPreference?: InputMaybe<FinancialPreferenceType>;
  plannedUsage?: InputMaybe<HealthSortWeightType>;
  providersWanted?: InputMaybe<Array<HealthProviderInput>>;
};

export type HealthPrivacy = {
  __typename?: 'HealthPrivacy';
  id: Scalars['ID']['output'];
  /** Privacy Screen Checkbox */
  isPrivacyAuthorizeAgree?: Maybe<Scalars['Boolean']['output']>;
  /** Privacy Screen Checkbox */
  isPrivacyDataUseAgree?: Maybe<Scalars['Boolean']['output']>;
  /** Privacy Screen Checkbox */
  isPrivacyTruthfulAgree?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthPrivacyInput = {
  /** Privacy Screen Checkbox */
  isPrivacyAuthorizeAgree?: InputMaybe<Trinary>;
  /** Privacy Screen Checkbox */
  isPrivacyDataUseAgree?: InputMaybe<Trinary>;
  /** Privacy Screen Checkbox */
  isPrivacyTruthfulAgree?: InputMaybe<Trinary>;
};

export type HealthProvider = {
  __typename?: 'HealthProvider';
  isCovered: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  npi: Scalars['String']['output'];
};

export type HealthProviderInput = {
  name: Scalars['String']['input'];
  npi: Scalars['String']['input'];
};

export type HealthReference = {
  __typename?: 'HealthReference';
  /** ffmStates is the list of states supported by the Federally Faciliated Marketplace (FFM), and State-Partnership Marketplaces (SPM). */
  ffmStates: Array<State>;
  /**
   * Returns open enrollment dates for the current year.
   *
   * For example, if a query is made to this endpoint during the year 2019, the
   * values retrieved will be the dates for the open enrollment period that
   * occurred in 2019.
   */
  openEnrollmentDates: OpenEnrollmentDates;
  /**
   * The different pathways to healthcare that are supported in a given zipcode, from our platform.
   *
   * Note that because this query takes in a ZipCode, and zipcodes can span
   * multiple states, if the zipcode passed as an argument spans multiple states,
   * if at least one of the states supports EDE, the EDE pathway will be added to
   * the response.
   *
   * The same applies for Oscar states.
   *
   * It would then be the responsibility of the caller to determine if the user's state is in the list of ffmStates or oscarStates.
   */
  supportedPathways?: Maybe<Array<HealthPathway>>;
};


export type HealthReferenceSupportedPathwaysArgs = {
  zipcode: Scalars['ZipCode']['input'];
};

export type HealthScreeningQuestions = {
  __typename?: 'HealthScreeningQuestions';
  /** S8 */
  areAllSameAddress?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S14
   * @deprecated Phase 2 question
   */
  areApplicationsCitizens?: Maybe<Scalars['Boolean']['output']>;
  /** P2 #14 - are all dependents your children/stepchildren, single, and under 26 */
  areDependentsChildOrStepchildSingleUnder26?: Maybe<Scalars['Boolean']['output']>;
  /** S26 */
  areDependentsLivingWithParentNotOnTaxReturn?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S11
   * @deprecated Phase 2 question
   */
  isAnyoneFullTimeStudent1822?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S16
   * @deprecated Phase 2 question
   */
  isApplicationNameSameAsSsn?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S15
   * @deprecated Phase 2 question
   */
  isCanProvideSsn?: Maybe<Scalars['Boolean']['output']>;
  /** S22 */
  isClaimingAllDependentsOnTax?: Maybe<Scalars['Boolean']['output']>;
  /** S20 */
  isCoveredThroughJobOrCobra?: Maybe<Scalars['Boolean']['output']>;
  /** S23 */
  isDependentSingleChild25OrYounger?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S21
   * @deprecated Phase 2 question
   */
  isFormerFosterCareAndUnder25?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S18
   * @deprecated Phase 2 question
   */
  isIncarcerated?: Maybe<Scalars['Boolean']['output']>;
  /** S19 */
  isIndianOrAlaskan?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S17
   * @deprecated Phase 2 question
   */
  isNaturalizedOrDerivedCitizenship?: Maybe<Scalars['Boolean']['output']>;
  /** S27 */
  isOfferedIchra?: Maybe<Scalars['Boolean']['output']>;
  /** S9 */
  isPlanningToFileTax?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S12
   * @deprecated Phase 2 question
   */
  isPregnantOrHadChildLast60Days?: Maybe<Scalars['Boolean']['output']>;
  /** S5, S6 */
  isRequestingFinancialAssistance?: Maybe<Scalars['Boolean']['output']>;
  /** S10 */
  isResponsibleForChildNotOnTaxReturn?: Maybe<Scalars['Boolean']['output']>;
  /**
   * S25
   * @deprecated Phase 2 question
   */
  isStepchildOrGrandchild?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthScreeningQuestionsInput = {
  /** S8 */
  areAllSameAddress?: InputMaybe<Trinary>;
  /** P2 #14 - are all dependents your children/stepchildren, single, and under 26 */
  areDependentsChildOrStepchildSingleUnder26?: InputMaybe<Trinary>;
  /** S26 */
  areDependentsLivingWithParentNotOnTaxReturn?: InputMaybe<Trinary>;
  /** S22 */
  isClaimingAllDependentsOnTax?: InputMaybe<Trinary>;
  /** S20 */
  isCoveredThroughJobOrCobra?: InputMaybe<Trinary>;
  /** S23 */
  isDependentSingleChild25OrYounger?: InputMaybe<Trinary>;
  /** S19 */
  isIndianOrAlaskan?: InputMaybe<Trinary>;
  /** S27 */
  isOfferedIchra?: InputMaybe<Trinary>;
  /** S9 */
  isPlanningToFileTax?: InputMaybe<Trinary>;
  /** S5, S6 */
  isRequestingFinancialAssistance?: InputMaybe<Trinary>;
  /** S10 */
  isResponsibleForChildNotOnTaxReturn?: InputMaybe<Trinary>;
};

export enum HealthSortWeightType {
  RecHigh = 'REC_HIGH',
  RecLow = 'REC_LOW',
  RecMedium = 'REC_MEDIUM'
}

export type HealthTwo = {
  __typename?: 'HealthTwo';
  /** Returns the user's health application, if started. */
  application?: Maybe<HealthApplication>;
  /**
   * Returns the health application by ID from EDE, including eligibility details
   * if any.
   */
  applicationSummary: ApplicationSummary;
  /** Returns applications by filter results with coverageYear and list of statuses */
  applications: Array<HealthApplication>;
  /** Get an enrollment group by ID */
  enrollmentGroup: EnrollmentGroup;
  /** List enrollment groups by application ID. You may also use application.enrollmentGroups */
  enrollmentGroups: Array<EnrollmentGroup>;
  /** Retrieves health explorer data for user to play around with marketplace */
  healthExplorerData?: Maybe<HealthExplorerData>;
  /** Retrieves a health explorer dependent by id */
  healthExplorerDependent: HealthExplorerDependent;
  /** Retrieves a list of health explorer dependents under this user */
  healthExplorerDependents: Array<HealthExplorerDependent>;
  /** The health preference on this user, if it exists */
  healthPreference?: Maybe<HealthPreference>;
  /**
   * Retrieves a household eligibility estimate.
   *
   * Note that this uses the already saved dependent and place information.
   *
   * If the server encounters an error when getting the estimate, this field will be null.
   */
  householdEligibilityEstimate?: Maybe<Array<DependentEligibilityEstimate>>;
  /** Gets an application member by ID */
  member: ApplicationMember;
  /** Retrieves a list of health policies, if they exist. Otherwise returns null. */
  policies?: Maybe<Array<HealthPolicy>>;
  /** Retrieves a health policy by ID */
  policy: HealthPolicy;
  /**
   * Retrieves the user's previous applications, for use with the
   * `importExistingApplication` mutation.
   *
   * Will match the applications based on the
   * coverageYear the applicant is seeking, and the coverageState that the member
   * is seeking coverage for. If there are any matches, returns any existing
   * applications.
   *
   * If there is no match, it is quite likely that the user needs to create a new
   * application instead of updating an existing one.
   *
   * Be sure to also check for existing applications using `health.applications`
   * query.
   *
   * Please note: If supplying an input, must supply both coverage year + coverage state.
   * Otherwise, this query uses the latest health insurance enrollment and the corresponding application to check for a state/cov year match. If
   * those are not found or those fields are not found, and the input is bad, this query will fail.
   *
   * Certain errors, like the lack of a date of birth, will result in the payload being null.
   *
   * If nothing returns, check the error item in the response for any details.
   */
  previousApplications: PreviousApplicationsResponse;
};


export type HealthTwoApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type HealthTwoApplicationSummaryArgs = {
  id: Scalars['ID']['input'];
};


export type HealthTwoApplicationsArgs = {
  input?: InputMaybe<ApplicationsInput>;
};


export type HealthTwoEnrollmentGroupArgs = {
  id: Scalars['ID']['input'];
};


export type HealthTwoEnrollmentGroupsArgs = {
  appID: Scalars['ID']['input'];
};


export type HealthTwoHealthExplorerDependentArgs = {
  id: Scalars['ID']['input'];
};


export type HealthTwoMemberArgs = {
  id: Scalars['ID']['input'];
};


export type HealthTwoPoliciesArgs = {
  input?: InputMaybe<PoliciesInput>;
};


export type HealthTwoPolicyArgs = {
  id: Scalars['ID']['input'];
};


export type HealthTwoPreviousApplicationsArgs = {
  input?: InputMaybe<PreviousApplicationsInput>;
};

export enum HealthValidationErrorCode {
  /** you cant edit applications once they have been submitted (application.status = SUBMITTED */
  ApplicationLocked = 'APPLICATION_LOCKED',
  /** You are not permitted to set the status to anything other that SUBMITTED or IN PROGRESS. Status has been reverted to IN PROGRESS */
  ApplicationStatusNotPermitted = 'APPLICATION_STATUS_NOT_PERMITTED',
  /** This provider does not support the coverage state you tried to save to this application */
  CoverageStateNotSupported = 'COVERAGE_STATE_NOT_SUPPORTED',
  /** computed effective date is in the past, likely need to refetch eligibility */
  EffectiveDateInPast = 'EFFECTIVE_DATE_IN_PAST',
  /** the main applicant of this app is missing data */
  IncompleteApplicant = 'INCOMPLETE_APPLICANT',
  /** the application cannot be submitted as complete because it is missing fields */
  IncompleteApplication = 'INCOMPLETE_APPLICATION',
  /** missing child data */
  IncompleteChildData = 'INCOMPLETE_CHILD_DATA',
  /** missing fields for SEP */
  IncompleteSep = 'INCOMPLETE_SEP',
  /** missing spouse data */
  IncompleteSpouseData = 'INCOMPLETE_SPOUSE_DATA',
  /** tried to submit OEP application after deadline. try to resubmit as SEP */
  OepApplicationExpired = 'OEP_APPLICATION_EXPIRED',
  /** two+ members on the application appear to be the same person */
  PossibleDuplicateMember = 'POSSIBLE_DUPLICATE_MEMBER',
  /** unclear how two members are related */
  UnableToParseRelation = 'UNABLE_TO_PARSE_RELATION'
}

export type HealthWalletItem = WalletItem & {
  __typename?: 'HealthWalletItem';
  card: WalletCard;
  carrier?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<InsuranceSource>;
  vertical: WalletItemVertical;
};

export type HealthWalletItemInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InsuranceSource>;
};

export type HouseholdInput = {
  hasMarriedCouple: Scalars['Boolean']['input'];
  healthDependents: Array<MarketplaceHealthDependent>;
  income: Scalars['Dollars']['input'];
};

export type IdChoice = {
  __typename?: 'IDChoice';
  key: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type IdProofApplication = {
  __typename?: 'IDProofApplication';
  finalDecisionCode?: Maybe<IdProofResult>;
  /** If (finalDecisionCode not ID_STATUS_GOOD or ID_STATUS_DENIED) and hasExpired, then prompt user to redo ID Proof */
  hasExpired: Scalars['Boolean']['output'];
  idProofTransactionID?: Maybe<Scalars['String']['output']>;
  sessionIdentification?: Maybe<Scalars['String']['output']>;
};

export enum IdProofApplicationStatus {
  /** Denied/blocked by Experian, don't ID Proof again */
  Denied = 'DENIED',
  /** Good and ID proofed, don't ID Proof again */
  Good = 'GOOD',
  /** Waiting for user to call Experian HD and call `ConfirmVerifiedOffline` */
  PendingFars = 'PENDING_FARS',
  /** Needs to answer RIDP verification questions */
  Questions = 'QUESTIONS',
  /** Unresolvable error; probably prompt user to contact us */
  Stuck = 'STUCK',
  /** Timed out, wait for time out period to expire before attempting to ID Proof again */
  Timeout = 'TIMEOUT'
}

export enum IdProofErrorCode {
  /** Submit with dob */
  Dob = 'DOB',
  /** Invalid street address */
  InvalidStreetAddress = 'INVALID_STREET_ADDRESS',
  /** Submit with last name */
  LastName = 'LAST_NAME',
  /** Submit with Middle Name */
  MiddleName = 'MIDDLE_NAME',
  /** Submit with previous address  */
  RetryPriorAddress = 'RETRY_PRIOR_ADDRESS',
  /** Schema Error */
  SchemaError = 'SCHEMA_ERROR',
  /** Submit with SSN */
  Ssn = 'SSN',
  /** Must submit application with suffix */
  Suffix = 'SUFFIX'
}

export enum IdProofResult {
  /** Success */
  Acc = 'ACC',
  /** Call Experian - frozen credit file */
  Rf1 = 'RF1',
  /** Call Experian - wrong answer to questions */
  Rf2 = 'RF2',
  /** Limit exceeded */
  Rf3 = 'RF3',
  /** Dead or not enough credit info */
  Rf4 = 'RF4'
}

export type IdQuestion = {
  __typename?: 'IDQuestion';
  choices: Array<IdChoice>;
  key: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type IdResponse = {
  answerKey: Scalars['String']['input'];
  questionKey: Scalars['String']['input'];
};

export enum IdentificationDocumentType {
  HealthDmi = 'HEALTH_DMI',
  HealthInsuranceBack = 'HEALTH_INSURANCE_BACK',
  HealthInsuranceFront = 'HEALTH_INSURANCE_FRONT',
  HealthSvi = 'HEALTH_SVI',
  Photoid = 'PHOTOID',
  ProofResidence = 'PROOF_RESIDENCE',
  Signature = 'SIGNATURE'
}

export type Identity = {
  __typename?: 'Identity';
  confirmationID?: Maybe<Scalars['String']['output']>;
  docsRequired: Array<DocumentRequired>;
  finalDecisionCode?: Maybe<ExperianResult>;
  id: Scalars['ID']['output'];
  /** @deprecated Use `confirmationID` instead. */
  idProofIdentifier?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `transactionID` instead. */
  idProofTransactionID?: Maybe<Scalars['String']['output']>;
  identityAttempts: Scalars['Int']['output'];
  /** A snapshot of the user info sent in to verify identity */
  identitySnapshot?: Maybe<IdentitySnapshot>;
  isTransactionIDExpired: Scalars['Boolean']['output'];
  providerType: IdentityProvider;
  questions: Array<IdQuestion>;
  quizAttempts: Scalars['Int']['output'];
  /** Only relevant for LOCKED_OUT status */
  retryAfter?: Maybe<Scalars['Time']['output']>;
  sessionID?: Maybe<Scalars['String']['output']>;
  status: IdentityStatus;
  transactionID?: Maybe<Scalars['String']['output']>;
};


export type IdentityDocsRequiredArgs = {
  input?: InputMaybe<DocsRequiredInput>;
};

export enum IdentityProvider {
  Bond = 'BOND',
  Catch = 'CATCH',
  Cms = 'CMS',
  Folio = 'FOLIO',
  Unit = 'UNIT'
}

export type IdentitySnapshot = {
  __typename?: 'IdentitySnapshot';
  address?: Maybe<Address>;
  dob?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Name>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ssn: Scalars['String']['output'];
};

export enum IdentityStatus {
  Denied = 'DENIED',
  Initial = 'INITIAL',
  LockedOut = 'LOCKED_OUT',
  NeedsDocs = 'NEEDS_DOCS',
  NeedsQuiz = 'NEEDS_QUIZ',
  PendingManualReview = 'PENDING_MANUAL_REVIEW',
  PendingOfflineVerification = 'PENDING_OFFLINE_VERIFICATION',
  PendingProvider = 'PENDING_PROVIDER',
  ServerIssue = 'SERVER_ISSUE',
  Stuck = 'STUCK',
  Unknown = 'UNKNOWN',
  Verified = 'VERIFIED'
}

/** Images uploaded to Catch are represented by this type. */
export type Image = {
  __typename?: 'Image';
  /** URL to the S3 object */
  url?: Maybe<Scalars['String']['output']>;
};

/** ImageFiletype is the list of filetypes we support when submitting identification images */
export enum ImageFiletype {
  Heic = 'HEIC',
  Heif = 'HEIF',
  Jpeg = 'JPEG',
  Pdf = 'PDF',
  Png = 'PNG'
}

export enum Importance {
  Consider = 'CONSIDER',
  Important = 'IMPORTANT',
  Vital = 'VITAL'
}

export enum IncarcerationStatusReason {
  /** 531 */
  AtstdNonCitizen = 'ATSTD_NON_CITIZEN',
  /** 456 */
  DataSourceNotCalledDueToFailedIdProof = 'DATA_SOURCE_NOT_CALLED_DUE_TO_FAILED_ID_PROOF',
  /** 432 */
  DmiResolvedByEswAdjudication = 'DMI_RESOLVED_BY_ESW_ADJUDICATION',
  /** 191 */
  EdsNotAvailable = 'EDS_NOT_AVAILABLE',
  /** 477 */
  EswExpiredAnotherDmiSoInelgble = 'ESW_EXPIRED_ANOTHER_DMI_SO_INELGBLE',
  /** 476 */
  EswExpiredDmi = 'ESW_EXPIRED_DMI',
  /** 546 */
  HubCallHeldDueToSsn = 'HUB_CALL_HELD_DUE_TO_SSN',
  /** 341 */
  HubDidNotRespond = 'HUB_DID_NOT_RESPOND',
  /** 651 */
  HubNotCalledEsdResolvedWithinLast_2Years = 'HUB_NOT_CALLED_ESD_RESOLVED_WITHIN_LAST_2_YEARS',
  /** 101 */
  LpRequirementsNotMet = 'LP_REQUIREMENTS_NOT_MET',
  /** 1 */
  NotCompatibleWithIdsDataSource = 'NOT_COMPATIBLE_WITH_IDS_DATA_SOURCE',
  /** 102 */
  NoSsaDataFoundLegacy = 'NO_SSA_DATA_FOUND_LEGACY',
  /** 230 */
  NoSsaDataFoundResultBasedOnAttestation = 'NO_SSA_DATA_FOUND_RESULT_BASED_ON_ATTESTATION',
  /** 999 */
  NA = 'N_A',
  /** 714 */
  NAQhpStoppedByOfflineProcess = 'N_A_QHP_STOPPED_BY_OFFLINE_PROCESS',
  /** 555 */
  NARuleDoesNotApply = 'N_A_RULE_DOES_NOT_APPLY',
  /** 100 */
  OnlySsaDataAvailableButNotCompatible = 'ONLY_SSA_DATA_AVAILABLE_BUT_NOT_COMPATIBLE',
  /** 573 */
  SsaHubCallHeldCallCounter_3OrMore = 'SSA_HUB_CALL_HELD_CALL_COUNTER_3_OR_MORE',
  /** 650 */
  SsaIndicatesApplicantIncarcerated = 'SSA_INDICATES_APPLICANT_INCARCERATED'
}

export enum IncarcerationType {
  Incarcerated = 'INCARCERATED',
  NotIncarcerated = 'NOT_INCARCERATED',
  PendingDisposition = 'PENDING_DISPOSITION'
}

/** IncomeAction is the current status of an IncomeTransaction */
export enum IncomeAction {
  /** The user has approved this section or entire income transaction */
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  /** This income will auto process after a delay */
  Delayed = 'DELAYED',
  /** The income transaction has been moved in our system and is waiting to be settled */
  Executed = 'EXECUTED',
  /** This income transaction has expired */
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  /** We have historical data that a user skipped it might be income or not income */
  HistorySkipped = 'HISTORY_SKIPPED',
  /** The user marked this income transaction as NOT income */
  NotIncome = 'NOT_INCOME',
  /** The income transaction has been settled */
  Settled = 'SETTLED',
  /** The user has elected to skip this section or entire income transaction */
  Skipped = 'SKIPPED',
  /** Waiting on user action */
  UserPending = 'USER_PENDING'
}

export type IncomeAutomationRule = {
  __typename?: 'IncomeAutomationRule';
  /** Defines how we will automate saving the income transaction. */
  automationType: AutomationType;
  /** Rules defined by the user to automate saving income once it has been acted in the UI. */
  id: Scalars['ID']['output'];
  /** Auto income transactions from this rule */
  incomeTransactionsPaged: IncomeTransactionConnection;
  /** Indicates if this rule is active or not */
  isActive: Scalars['Boolean']['output'];
  /** Defines the tag that will identify the source of income. */
  source: IncomeTransactionSource;
  /** Defines if the income rules is tied to a worktype */
  workType?: Maybe<WorkType>;
};


export type IncomeAutomationRuleIncomeTransactionsPagedArgs = {
  incomeAction?: InputMaybe<Array<IncomeAction>>;
  pagination: Pagination;
  paycheckType?: InputMaybe<PaycheckType>;
  period?: InputMaybe<DatePeriod>;
};

export type IncomeAutomationRuleInput = {
  /** Defines how we will automate saving the income transaction. */
  automationType: AutomationType;
  /** If catchTransactionTagID is passed in, then we'll create a rule if one doesn't exist */
  catchTransactionTagID?: InputMaybe<Scalars['ID']['input']>;
  /** Defines the ID of the IncomeSource that will identify the source of income. */
  incomeSourceID?: InputMaybe<Scalars['ID']['input']>;
  /** Indicate if this rule should be active or not */
  isActive?: InputMaybe<Trinary>;
  /** Indicates whether new rule should automatically trigger subscription activation */
  userHandlesActivation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if the income rules is tied to a worktype */
  workType?: InputMaybe<WorkType>;
};

export enum IncomeExplanationReason {
  /** The income in the month is higher than the usual amount */
  HigherThanSource = 'HIGHER_THAN_SOURCE',
  /** The income in the month is lower than the usual amount */
  LowerThanSource = 'LOWER_THAN_SOURCE',
  /** No external income data available */
  NoExternalIncomeDataAvailable = 'NO_EXTERNAL_INCOME_DATA_AVAILABLE',
  /** The reason is unknown */
  Unknown = 'UNKNOWN'
}

export enum IncomeFrequencyType {
  Annually = 'ANNUALLY',
  BiWeekly = 'BI_WEEKLY',
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Quarterly = 'QUARTERLY',
  SemiMonthly = 'SEMI_MONTHLY',
  Weekly = 'WEEKLY'
}

export type IncomePreferences = {
  __typename?: 'IncomePreferences';
  /** Flag indicating the user wants a delay before auto processing any income */
  isDelayAutoIncome: Scalars['Boolean']['output'];
};

export type IncomePreferencesInput = {
  /** Flag indicating the user wants a delay before auto processing any income */
  isDelayAutoIncome: Scalars['Boolean']['input'];
};

export type IncomeSource = {
  __typename?: 'IncomeSource';
  /** #156 */
  averageWeeklyWorkDays?: Maybe<Scalars['Int']['output']>;
  /** #209 */
  averageWeeklyWorkHours?: Maybe<Scalars['Int']['output']>;
  /** Should only be populated if type is SCHOLARSHIP */
  educationExpenses?: Maybe<Scalars['Dollars']['output']>;
  /** #209 */
  employerAddress?: Maybe<Address>;
  /** #209 */
  employerIdentificationNumber?: Maybe<Scalars['String']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  /** #209 */
  employerPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** #165 */
  expirationDate?: Maybe<Scalars['Date']['output']>;
  /** #154 */
  incomeAmount?: Maybe<Scalars['Dollars']['output']>;
  /** #165 */
  incomeDescription?: Maybe<Scalars['String']['output']>;
  incomeDifferenceReason?: Maybe<JobIncomeDifferenceReason>;
  /** #154 */
  incomeFrequencyType?: Maybe<IncomeFrequencyType>;
  /** Should always be populated after upsert processing. If not populated, it is likely old data. Will always be > 0 */
  incomeID?: Maybe<Scalars['Int']['output']>;
  incomeStateExchangeFields?: Maybe<IncomeStateExchangeFields>;
  isEstimatedForAptc?: Maybe<Scalars['Boolean']['output']>;
  jobIncomeExplanationRequired: Scalars['Boolean']['output'];
  otherDeductionDescription?: Maybe<Scalars['String']['output']>;
  otherIncomeDescription?: Maybe<Scalars['String']['output']>;
  /** If incomeDifferenceReason is OTHER, this field should exist. */
  otherIncomeDifferenceReason?: Maybe<Scalars['String']['output']>;
  /** #159 */
  selfEmploymentIncomeDescription?: Maybe<Scalars['String']['output']>;
  tribalIncomeAmount?: Maybe<Scalars['Dollars']['output']>;
  /** #154, #175, #175 */
  type?: Maybe<IncomeSourceType>;
};

export type IncomeSourceInput = {
  /** #156 */
  averageWeeklyWorkDays?: InputMaybe<Scalars['Int']['input']>;
  /** #209 */
  averageWeeklyWorkHours?: InputMaybe<Scalars['Int']['input']>;
  /** REQUIRED to be populated if type is SCHOLARSHIP using the Education Expenses field */
  educationExpenses?: InputMaybe<Scalars['Dollars']['input']>;
  /** #209 */
  employerAddress?: InputMaybe<AddressInput>;
  /** #209 */
  employerIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** #209 */
  employerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** #165 */
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  /** #154 */
  incomeAmount?: InputMaybe<Scalars['Dollars']['input']>;
  /** #165 */
  incomeDescription?: InputMaybe<Scalars['String']['input']>;
  incomeDifferenceReason?: InputMaybe<JobIncomeDifferenceReason>;
  /** #154 */
  incomeFrequencyType?: InputMaybe<IncomeFrequencyType>;
  /** If adding a new Income Source, do NOT add an ID. If modifying an existing ID, Please pass in an ID or data will be messed up */
  incomeID?: InputMaybe<Scalars['Int']['input']>;
  incomeStateExchangeFields?: InputMaybe<IncomeStateExchangeFieldsInput>;
  isEstimatedForAptc?: InputMaybe<Trinary>;
  otherDeductionDescription?: InputMaybe<Scalars['String']['input']>;
  otherIncomeDescription?: InputMaybe<Scalars['String']['input']>;
  /** If incomeDifferenceReason is OTHER, this field should be filled out. */
  otherIncomeDifferenceReason?: InputMaybe<Scalars['String']['input']>;
  /** #159 */
  selfEmploymentIncomeDescription?: InputMaybe<Scalars['String']['input']>;
  tribalIncomeAmount?: InputMaybe<Scalars['Dollars']['input']>;
  /** #154, #175, #175 */
  type?: InputMaybe<IncomeSourceType>;
};

export enum IncomeSourceType {
  AlimonyPayment = 'ALIMONY_PAYMENT',
  AlimonyReceived = 'ALIMONY_RECEIVED',
  CanceledDebt = 'CANCELED_DEBT',
  CapitalGains = 'CAPITAL_GAINS',
  CashSupport = 'CASH_SUPPORT',
  CourtAwards = 'COURT_AWARDS',
  FarmingOrFishingIncome = 'FARMING_OR_FISHING_INCOME',
  InvestmentIncome = 'INVESTMENT_INCOME',
  Job = 'JOB',
  JuryDutyPay = 'JURY_DUTY_PAY',
  OtherDeduction = 'OTHER_DEDUCTION',
  OtherIncome = 'OTHER_INCOME',
  Pension = 'PENSION',
  PrizesAwardsGamblingWinnings = 'PRIZES_AWARDS_GAMBLING_WINNINGS',
  RentalOrRoyaltyIncome = 'RENTAL_OR_ROYALTY_INCOME',
  Retirement = 'RETIREMENT',
  Scholarship = 'SCHOLARSHIP',
  SelfEmployment = 'SELF_EMPLOYMENT',
  SocialSecurityBenefit = 'SOCIAL_SECURITY_BENEFIT',
  StudentLoanInterest = 'STUDENT_LOAN_INTEREST',
  Unemployment = 'UNEMPLOYMENT'
}

export type IncomeSourcesInput = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  period?: InputMaybe<DatePeriod>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type IncomeStateExchangeFields = {
  __typename?: 'IncomeStateExchangeFields';
  dateIncomeBegan?: Maybe<Scalars['Date']['output']>;
  dateIncomeEnded?: Maybe<Scalars['Date']['output']>;
  dateLastGotIncome?: Maybe<Scalars['Date']['output']>;
  incomeName?: Maybe<Scalars['String']['output']>;
  isExpectedToEndIn4Months?: Maybe<Scalars['Boolean']['output']>;
  isPaidBeforeJan1?: Maybe<Scalars['Boolean']['output']>;
  isPresentlyEmployed?: Maybe<Scalars['Boolean']['output']>;
};

export type IncomeStateExchangeFieldsInput = {
  dateIncomeBegan?: InputMaybe<Scalars['Date']['input']>;
  dateIncomeEnded?: InputMaybe<Scalars['Date']['input']>;
  dateLastGotIncome?: InputMaybe<Scalars['Date']['input']>;
  incomeName?: InputMaybe<Scalars['String']['input']>;
  isExpectedToEndIn4Months?: InputMaybe<Trinary>;
  isPaidBeforeJan1?: InputMaybe<Trinary>;
  isPresentlyEmployed?: InputMaybe<Trinary>;
};

/** IncomeTransaction represents a transaction that we believe to be income. */
export type IncomeTransaction = {
  __typename?: 'IncomeTransaction';
  /** the time when the user acted on the income transaction (approved or disapproved) */
  actedOn?: Maybe<Scalars['Time']['output']>;
  /** The amount of the transaction */
  amount: Scalars['Dollars']['output'];
  /** autoDelayBatchTime is the time this income will be automatically processed */
  autoDelayBatchTime?: Maybe<Scalars['Time']['output']>;
  /** The name of the bank account for the transaction */
  bankName: Scalars['String']['output'];
  /** The date the transaction occurred */
  date: Scalars['Date']['output'];
  /**
   * Description of the tx if untagged, tag text of the tx if tagged
   * @deprecated Use `IncomeTransactionSource.name` instead.
   */
  description: Scalars['String']['output'];
  /** An expenses amount that is deducted from the income_amount before calculations  */
  expenses: Scalars['Dollars']['output'];
  /** The ID of this transaction */
  id: Scalars['ID']['output'];
  /** This transfer was processed via autopilot */
  isAutopilot: Scalars['Boolean']['output'];
  /** Indicates whether this transaction could be a potential duplicate. Autopilot does not act on an Income Transaction if this is True. */
  isPotentialDuplicate: Scalars['Boolean']['output'];
  /** Raw Bank Description of the transaction */
  memo: Scalars['String']['output'];
  /**
   * The paycheckType designated for this income transaction
   * Only exists if the incomeTransaction has been approved by a user.
   */
  paycheckType?: Maybe<PaycheckType>;
  /** If it is a potential duplicate, then this is the id of the transaction that is the possible dup */
  potentialDuplicate?: Maybe<IncomeTransaction>;
  /** holds information on the source of the income */
  source?: Maybe<IncomeTransactionSource>;
  /** The action being taken on the transaction as a whole */
  status: IncomeAction;
  /** DEPRECATED - Use source detail in the income source. Subsource of this transaction if it exists. */
  subtag?: Maybe<Scalars['String']['output']>;
  /** TransactionUpdateType is a type that indicates how the IncomeTransaction was detected in the platform. */
  transactionUpdateType?: Maybe<TransactionUpdateType>;
  /**
   * The actual transfer associated with this incomeTransaction - should
   * only return something if executed/settled
   */
  transfer?: Maybe<CortexTransfer>;
  /** The total amount of income */
  transferAmount: Scalars['Dollars']['output'];
};

/**
 * IncomeTransactionConnection is a connection to a list of incomeTransaction,
 * ordered by date with the most recent first.
 */
export type IncomeTransactionConnection = {
  __typename?: 'IncomeTransactionConnection';
  edges: Array<IncomeTransaction>;
  pageInfo: PageInfo;
};

export type IncomeTransactionSource = {
  __typename?: 'IncomeTransactionSource';
  /** DEPRECATED - Use incomeAutomationRule */
  IncomeAutomationRule?: Maybe<IncomeAutomationRule>;
  /** True if parent rule or can stand as its own as a rule. False if it is a child source, i.e. rich tagged source. */
  canBeRule: Scalars['Boolean']['output'];
  /** Keeps track of how many income transactions we have seen from this source */
  count: Scalars['Int']['output'];
  /** Note that this keeps track of subtags of sources, but not regular subtags */
  currentStreak: Scalars['Int']['output'];
  /** This ID represents the IncomeSource */
  id: Scalars['ID']['output'];
  /** Income automation rule associated with this source. It is nil if the user does not have an income automation rule for this source. Does not pass up NOT_FOUND errors. */
  incomeAutomationRule?: Maybe<IncomeAutomationRule>;
  /** income transactions associated with this source */
  incomeTransactionsPaged: IncomeTransactionConnection;
  /** ID of the incomeSource that should be used when making rules. This is needed because rich tag income sources are `children` and rules are made at the parent level. */
  ruleID: Scalars['ID']['output'];
  /** The extra descriptive detail to display for this income source. Will either be the main tag or the subtag depending on subtag_is_source or not */
  sourceDetail?: Maybe<Scalars['String']['output']>;
  /** Main tag and logo associated with this source */
  taggedSource: CatchTransactionTag;
  /** Display text associated with the source. */
  text: Scalars['String']['output'];
};


export type IncomeTransactionSourceIncomeTransactionsPagedArgs = {
  incomeAction?: InputMaybe<Array<IncomeAction>>;
  onlyAuto?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: Pagination;
  paycheckType?: InputMaybe<PaycheckType>;
  period?: InputMaybe<DatePeriod>;
};

export type InitialEnrollmentEligibility = {
  __typename?: 'InitialEnrollmentEligibility';
  earliestQhpEffective?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  latestQhpEffective?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export enum InsuranceCardSide {
  Back = 'BACK',
  Front = 'FRONT'
}

/** The abstract type that represents an insurance enrollment */
export type InsuranceEnrollment = {
  enrollmentType: InsuranceEnrollmentType;
};

export type InsuranceEnrollmentInput = {
  HealthInsuranceEnrollmentStatus?: InputMaybe<Array<HealthInsuranceEnrollmentStatus>>;
  enrollmentType?: InputMaybe<InsuranceEnrollmentType>;
};

export enum InsuranceEnrollmentType {
  DentalInsurance = 'DENTAL_INSURANCE',
  HealthInsurance = 'HEALTH_INSURANCE'
}

export enum InsuranceMarketType {
  Marketplace = 'MARKETPLACE',
  Medicare = 'MEDICARE',
  None = 'NONE',
  OtherFullBenefit = 'OTHER_FULL_BENEFIT',
  OtherLimitedBenefit = 'OTHER_LIMITED_BENEFIT',
  PeaceCorps = 'PEACE_CORPS',
  StateChip = 'STATE_CHIP',
  StateMedicaid = 'STATE_MEDICAID',
  Tricare = 'TRICARE',
  Va = 'VA'
}

/** The abstract type that represents an insurance policy */
export type InsurancePolicy = {
  id: Scalars['ID']['output'];
};

export enum InsuranceSource {
  /** The user has insurance through their employer */
  Employer = 'EMPLOYER',
  /** The user has insurance through medicaid */
  Medicaid = 'MEDICAID',
  /** The user has insurance through medicare */
  Medicare = 'MEDICARE',
  /** The user has their own insurance from an unlisted source */
  Other = 'OTHER',
  /** The user has insurance through their parent */
  Parent = 'PARENT',
  /** The user got their insurance through Catch Decent */
  SelfDecent = 'SELF_DECENT',
  /** The user has insurance from the health.gov exchange */
  SelfExchange = 'SELF_EXCHANGE',
  /** The user got their insurance through Catch Healthsherpa */
  SelfHealthsherpa = 'SELF_HEALTHSHERPA',
  /** The user got their insurance through Catch's Oscar product */
  SelfOscar = 'SELF_OSCAR',
  /** The user obtained insurance from our platform (Catch) */
  SelfPlatform = 'SELF_PLATFORM',
  /** The user has insurance through their spouse */
  Spouse = 'SPOUSE',
  /**
   * The user has insurance through a veteran's plan
   *
   * https://www.healthcare.gov/veterans/
   */
  Veterans = 'VETERANS'
}

export type IsAliasMatchAndVerifiedResult = {
  __typename?: 'IsAliasMatchAndVerifiedResult';
  emailMatchAndVerified: Scalars['Boolean']['output'];
  phoneMatchAndVerified: Scalars['Boolean']['output'];
};

export type Issuer = {
  __typename?: 'Issuer';
  eligibleDependents: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  individualURL: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shopURL: Scalars['String']['output'];
  state: Scalars['String']['output'];
  tollFree: Scalars['String']['output'];
  tty: Scalars['String']['output'];
};

export enum JobIncomeDifferenceReason {
  ChangeJobs = 'CHANGE_JOBS',
  DecreaseHours = 'DECREASE_HOURS',
  Other = 'OTHER',
  StopWorking = 'STOP_WORKING',
  WageCut = 'WAGE_CUT'
}

export type KycInfo = {
  __typename?: 'KYCInfo';
  /** if KYCStatus is review, this list will be populated. Otherwise, it will be nil. */
  needed?: Maybe<Array<KycNeeded>>;
  /** Which bank provider this KYC is associated with */
  savingsProviderType: SavingsProviderType;
  status?: Maybe<KycStatus>;
};

/** These represent the different KYC fields a user might need to open an account. */
export enum KycNeeded {
  /** User needs a legal address */
  KycAddress = 'KYC_ADDRESS',
  /** User needs a date of birth */
  KycDob = 'KYC_DOB',
  /** Needs to answer the BBVA EDD questions */
  KycEddQuestions = 'KYC_EDD_QUESTIONS',
  /** User needs to provide identifying document fields */
  KycIdFields = 'KYC_ID_FIELDS',
  /** User needs to provide an identifying document scan */
  KycIdScan = 'KYC_ID_SCAN',
  /** KBA KYC questions */
  KycKba = 'KYC_KBA',
  /**
   * "mismatch indicates that our bank partner has an existing consumer record
   * that contains the submitted SSN, but that one or more of the submitted values
   * for name, dob, or citizenship_status do not match the information contained
   * in that record."
   */
  KycMismatch = 'KYC_MISMATCH',
  /** User needs a name */
  KycName = 'KYC_NAME',
  /** Office of Foreign Access Control */
  KycOfac = 'KYC_OFAC',
  /** Needs to submit passport */
  KycPrimaryDoc = 'KYC_PRIMARY_DOC',
  /** Needs to submit secondary document */
  KycSecondaryDoc = 'KYC_SECONDARY_DOC',
  /** User needs a social security number */
  KycSsn = 'KYC_SSN',
  /** this status is used internally and should not be encountered by clients */
  UncategorizedKyc = 'UNCATEGORIZED_KYC'
}

/** Determines the KYC status of the user */
export enum KycStatus {
  /** KYC is denied for the user */
  KycDenied = 'KYC_DENIED',
  /** KYC is completed or not needed for the user */
  KycGood = 'KYC_GOOD',
  /** Initial state - user has not made an actual KYC request yet */
  KycInitial = 'KYC_INITIAL',
  /** The user is in the process of being reviewed - no action is needed */
  KycPending = 'KYC_PENDING',
  /** The user needs documents reviewed */
  KycReview = 'KYC_REVIEW'
}

export enum LanguageType {
  Arabic = 'ARABIC',
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  FrenchCreole = 'FRENCH_CREOLE',
  German = 'GERMAN',
  Gujarati = 'GUJARATI',
  Hindi = 'HINDI',
  Korean = 'KOREAN',
  Other = 'OTHER',
  Polish = 'POLISH',
  Portuguese = 'PORTUGUESE',
  Russian = 'RUSSIAN',
  Spanish = 'SPANISH',
  Tagalog = 'TAGALOG',
  Urdu = 'URDU',
  Vietnamese = 'VIETNAMESE'
}

/** LatestApprovedPaycheck represents the latest approved income transaction and bank account name for the latest paycheck container */
export type LatestApprovedPaycheck = {
  __typename?: 'LatestApprovedPaycheck';
  /** The bank account name of the aggregation account associated with the income transaction */
  bankAccountName?: Maybe<Scalars['String']['output']>;
  /** The IncomeTransaction associated with the latest approved paycheck */
  incomeTransaction?: Maybe<IncomeTransaction>;
};

export enum LawfulPresenceDocumentType {
  ArrivalDepartureRecordInForeignPassportI_94 = 'ARRIVAL_DEPARTURE_RECORD_IN_FOREIGN_PASSPORT_I_94',
  ArrivalDepartureRecordInUnexpiredForeignPassportI_94 = 'ARRIVAL_DEPARTURE_RECORD_IN_UNEXPIRED_FOREIGN_PASSPORT_I_94',
  CertificateOfCitizenship = 'CERTIFICATE_OF_CITIZENSHIP',
  CertificateOfEligibilityForExchangeVisitorStatusDs_2019 = 'CERTIFICATE_OF_ELIGIBILITY_FOR_EXCHANGE_VISITOR_STATUS_DS_2019',
  CertificateOfEligibilityForNonimmigrantStudentStatusI_20 = 'CERTIFICATE_OF_ELIGIBILITY_FOR_NONIMMIGRANT_STUDENT_STATUS_I_20',
  CertificateOfNaturalization = 'CERTIFICATE_OF_NATURALIZATION',
  EmploymentAuthorizationCardI_766 = 'EMPLOYMENT_AUTHORIZATION_CARD_I_766',
  ForeignPassport = 'FOREIGN_PASSPORT',
  MachineReadableImmigrantVisaWithTemporaryI_551Language = 'MACHINE_READABLE_IMMIGRANT_VISA_WITH_TEMPORARY_I_551_LANGUAGE',
  NoticeOfActionI_797 = 'NOTICE_OF_ACTION_I_797',
  Other = 'OTHER',
  PermanentResidentCardI_551 = 'PERMANENT_RESIDENT_CARD_I_551',
  ReentryPermit = 'REENTRY_PERMIT',
  RefugeeTravelDocument = 'REFUGEE_TRAVEL_DOCUMENT',
  TemporaryI_551StampOnPassportOrI_94I_94A = 'TEMPORARY_I_551_STAMP_ON_PASSPORT_OR_I_94_I_94A'
}

export type LawfulPresenceDocumentation = {
  __typename?: 'LawfulPresenceDocumentation';
  alienNumber?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  citizenshipNumber?: Maybe<Scalars['String']['output']>;
  documentAlternativeName?: Maybe<Name>;
  documentExpirationDate?: Maybe<Scalars['Date']['output']>;
  documentType: LawfulPresenceDocumentType;
  employmentAuthorizationCategoryIdentifier?: Maybe<Scalars['String']['output']>;
  i94Number?: Maybe<Scalars['String']['output']>;
  isNoIdentifiersProvided?: Maybe<Scalars['Boolean']['output']>;
  naturalizationCertificateNumber?: Maybe<Scalars['String']['output']>;
  otherDocumentTypeText?: Maybe<Scalars['String']['output']>;
  passportIssuingCountry?: Maybe<Scalars['String']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  sevisID?: Maybe<Scalars['String']['output']>;
};

export type LawfulPresenceDocumentationInput = {
  alienNumber?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  citizenshipNumber?: InputMaybe<Scalars['String']['input']>;
  documentAlternativeName?: InputMaybe<NameInput>;
  documentExpirationDate?: InputMaybe<Scalars['Date']['input']>;
  documentType?: InputMaybe<LawfulPresenceDocumentType>;
  employmentAuthorizationCategoryIdentifier?: InputMaybe<Scalars['String']['input']>;
  i94Number?: InputMaybe<Scalars['String']['input']>;
  isNoIdentifiersProvided?: InputMaybe<Trinary>;
  naturalizationCertificateNumber?: InputMaybe<Scalars['String']['input']>;
  otherDocumentTypeText?: InputMaybe<Scalars['String']['input']>;
  passportIssuingCountry?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  sevisID?: InputMaybe<Scalars['String']['input']>;
};

export enum LawfulPresenceStatus {
  Delay = 'DELAY',
  Error = 'ERROR',
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING',
  Yes = 'YES'
}

export enum LifeInsuranceAnswers {
  /** the user doesn't have life insurance */
  No = 'NO',
  /** the user doesn't know if they have life insurance */
  Unknown = 'UNKNOWN',
  /** the user has life insurance */
  Yes = 'YES'
}

export type LifeWalletItem = WalletItem & {
  __typename?: 'LifeWalletItem';
  carrier?: Maybe<Scalars['String']['output']>;
  coverageAmount?: Maybe<Scalars['Dollars']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<InsuranceSource>;
  vertical: WalletItemVertical;
};

export type LifeWalletItemInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  coverageAmount?: InputMaybe<Scalars['Dollars']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InsuranceSource>;
};

/** DEPRECATED: Used for deprecated calls for backwards compatibility */
export type ListAllCatchFeeSubscriptionsInput = {
  pagination: Pagination;
  statuses?: InputMaybe<Array<CatchSubscriptionStatus>>;
  types?: InputMaybe<Array<CatchFeeTypes>>;
};

export type ListAllCatchSubscriptionsInput = {
  featureTypes?: InputMaybe<Array<CatchFeatureType>>;
  pagination: Pagination;
  statuses?: InputMaybe<Array<CatchSubscriptionStatus>>;
  types?: InputMaybe<Array<CatchFeeTypes>>;
};

export type ListApplicationsInput = {
  /** If specified, filters the applications by coverageState */
  coverageState?: InputMaybe<Scalars['String']['input']>;
  /** If specified, filters the applications by coverageYear */
  coverageYear?: InputMaybe<Scalars['Int']['input']>;
};

/** DEPRECATED: Used for deprecated calls for backwards compatibility */
export type ListCatchFeeSubscriptionsInput = {
  types?: InputMaybe<Array<CatchFeeTypes>>;
};

export type ListCatchSubscriptionsInput = {
  featureTypes?: InputMaybe<Array<CatchFeatureType>>;
  types?: InputMaybe<Array<CatchFeeTypes>>;
};

export type ListTasksInput = {
  assignee?: InputMaybe<Scalars['ID']['input']>;
  healthApplicationStatuses?: InputMaybe<Array<HealthApplicationStatus>>;
  healthInsuranceEnrollmentStatuses?: InputMaybe<Array<HealthInsuranceEnrollmentStatus>>;
  healthPolicyStatuses?: InputMaybe<Array<PolicyStatus>>;
  isAssignment?: InputMaybe<Trinary>;
  pagination: Pagination;
  priorities?: InputMaybe<Array<TaskPriority>>;
  /** If nothing is provided, defaults to descending creation date */
  sort?: InputMaybe<TaskSort>;
  statuses?: InputMaybe<Array<TaskStatus>>;
  types?: InputMaybe<Array<TaskType>>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export enum Location {
  AdditionalCoverage = 'ADDITIONAL_COVERAGE',
  None = 'NONE',
  YourCoverage = 'YOUR_COVERAGE'
}

export type LoginHistory = {
  __typename?: 'LoginHistory';
  deviceType?: Maybe<Scalars['String']['output']>;
  loginTimeStamp: Scalars['Time']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export enum MaritalStatus {
  /** The dependent is married. */
  Married = 'MARRIED',
  /** The dependent is single. */
  Single = 'SINGLE',
  /** UNKNOWN should only be used for an input, to reset a value to nil */
  Unknown = 'UNKNOWN'
}

/** This is the raw data returned from the marketplace eligibility endpoint */
export type MarketplaceEligibility = {
  __typename?: 'MarketplaceEligibility';
  aptc: Scalars['Dollars']['output'];
  csr: Scalars['String']['output'];
  hardshipExemption: Scalars['Boolean']['output'];
  isMedicaidChip: Scalars['Boolean']['output'];
};

export type MarketplaceHealthDependent = {
  APTCEligible: Scalars['Boolean']['input'];
  age: Scalars['Int']['input'];
  hasMec: Scalars['Boolean']['input'];
  isApplying: Scalars['Boolean']['input'];
  isParent: Scalars['Boolean']['input'];
  isPregnant: Scalars['Boolean']['input'];
  isSmoker: Scalars['Boolean']['input'];
  relation: Scalars['String']['input'];
};

export type MedicaidEligibility = {
  __typename?: 'MedicaidEligibility';
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type Member = {
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  /** The Catch UUID */
  id: Scalars['ID']['output'];
  isSmoker?: Maybe<Scalars['Boolean']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  /** Relation */
  relation?: Maybe<Relation>;
  sex?: Maybe<Sex>;
  ssn?: Maybe<Scalars['String']['output']>;
};

export type MemberStateExchangeFields = {
  __typename?: 'MemberStateExchangeFields';
  isClaimedAsTaxDependent?: Maybe<Scalars['Boolean']['output']>;
  isMedicaidPartAEligible?: Maybe<Scalars['Boolean']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  isPrimaryTaxFiler?: Maybe<Scalars['Boolean']['output']>;
  isRequiredToFileTaxes?: Maybe<Scalars['Boolean']['output']>;
};

export type MemberStateExchangeFieldsInput = {
  isClaimedAsTaxDependent?: InputMaybe<Trinary>;
  isMedicaidPartAEligible?: InputMaybe<Trinary>;
  isPrimaryTaxFiler?: InputMaybe<Trinary>;
  isRequiredToFileTaxes?: InputMaybe<Trinary>;
};

export enum MetalLevel {
  /** From BRONZE to CATASTROPHIC apply to Health plans */
  Bronze = 'BRONZE',
  Catastrophic = 'CATASTROPHIC',
  Gold = 'GOLD',
  High = 'HIGH',
  /** Note: LOW and HIGH only apply to Dental plans */
  Low = 'LOW',
  Platinum = 'PLATINUM',
  Silver = 'SILVER'
}

/**
 * If there is no MetalLevelOption in the then that just
 * means the member is eligible for all metal levels
 */
export type MetalLevelOption = {
  __typename?: 'MetalLevelOption';
  allowedMetalLevels?: Maybe<Array<Scalars['String']['output']>>;
  currentMetalLevel?: Maybe<Scalars['String']['output']>;
  currentPlanOnlyIndicator: Scalars['Boolean']['output'];
};

export type MonthlyIncome = {
  __typename?: 'MonthlyIncome';
  month: Scalars['Int']['output'];
  totalIncome: Scalars['Dollars']['output'];
};

export type Moops = {
  __typename?: 'Moops';
  amount: Scalars['Float']['output'];
  csr: Scalars['String']['output'];
  familyCost: Scalars['String']['output'];
  networkTier: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** List of possible mutations for public */
export type Mutation = {
  __typename?: 'Mutation';
  deletePublicHealthExplorerDependents: Array<PublicHealthExplorerDependent>;
  /** Given a consent request token, allows public users to resend the consent email */
  resendConsentRequest: PublicConsentRequest;
  /** Given a consent request token, allows public users to agree to a consent */
  signConsentRequest: PublicConsentRequest;
  upsertPublicHealthExplorerData: PublicHealthExplorerData;
  upsertPublicHealthExplorerDependents: Array<PublicHealthExplorerDependent>;
};


/** List of possible mutations for public */
export type MutationDeletePublicHealthExplorerDependentsArgs = {
  ids: Array<Scalars['ID']['input']>;
  publicDataID: Scalars['ID']['input'];
};


/** List of possible mutations for public */
export type MutationResendConsentRequestArgs = {
  input: ResendConsentRequestInput;
};


/** List of possible mutations for public */
export type MutationSignConsentRequestArgs = {
  input: SignConsentRequestInput;
};


/** List of possible mutations for public */
export type MutationUpsertPublicHealthExplorerDataArgs = {
  input: PublicHealthExplorerDataInput;
};


/** List of possible mutations for public */
export type MutationUpsertPublicHealthExplorerDependentsArgs = {
  input: UpsertPublicHealthExplorerDependentsInput;
};

/** Name represents a name */
export type Name = {
  __typename?: 'Name';
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

/** The fields required for creating a Name */
export type NameInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
};

/** NameSuffix is the list of possible name suffixes */
export enum NameSuffix {
  Ii = 'II',
  Iii = 'III',
  Iv = 'IV',
  Jr = 'JR',
  Sr = 'SR',
  V = 'V'
}

export enum NonMemberVeteranRelationshipType {
  DeceasedParentStepParent = 'DECEASED_PARENT_STEP_PARENT',
  DeceasedSpouse = 'DECEASED_SPOUSE',
  ParentStepParent = 'PARENT_STEP_PARENT',
  Spouse = 'SPOUSE'
}

/** NotificationSettings represents a user's Notification Settings */
export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  /** Email Notification Settings */
  email: EmailNotificationSettings;
  /** Push Notification Settings */
  push: PushNotificationSettings;
  /** returns the user's push tokens */
  pushTokens?: Maybe<Array<PushToken>>;
  /** Text Notification Settings */
  text: TextNotificationSettings;
};

export type Nudge = {
  __typename?: 'Nudge';
  /** Is this nudge dismissed for this user or not */
  isDismissed: Scalars['Boolean']['output'];
  /** The last time any change happened on this Nudge. */
  lastUpdated?: Maybe<Scalars['Time']['output']>;
  /** The nudge identifier of the nudge */
  nudgeIdentifier: Scalars['String']['output'];
};

export type NudgeInput = {
  /** Boolean to represent whether this nudge is dismissed or not for this user. */
  isDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The nudge identifier of the nudge to be created or updated. Must provide this field. */
  nudgeIdentifier: Scalars['String']['input'];
};

/** Set of possible occupations. These should map to the Unit values */
export enum Occupation {
  ArchitectOrEngineer = 'ARCHITECT_OR_ENGINEER',
  BusinessAnalystAccountantOrFinancialAdvisor = 'BUSINESS_ANALYST_ACCOUNTANT_OR_FINANCIAL_ADVISOR',
  CommunityAndSocialServicesWorker = 'COMMUNITY_AND_SOCIAL_SERVICES_WORKER',
  ConstructionMechanicOrMaintenanceWorker = 'CONSTRUCTION_MECHANIC_OR_MAINTENANCE_WORKER',
  Doctor = 'DOCTOR',
  Educator = 'EDUCATOR',
  EntertainmentSportsArtsOrMedia = 'ENTERTAINMENT_SPORTS_ARTS_OR_MEDIA',
  ExecutiveOrManager = 'EXECUTIVE_OR_MANAGER',
  FarmerFishermanForester = 'FARMER_FISHERMAN_FORESTER',
  FoodServiceWorker = 'FOOD_SERVICE_WORKER',
  GigWorker = 'GIG_WORKER',
  HospitalityOfficeOrAdministrativeSupportWorker = 'HOSPITALITY_OFFICE_OR_ADMINISTRATIVE_SUPPORT_WORKER',
  HouseholdManager = 'HOUSEHOLD_MANAGER',
  JanitorHousekeeperLandscaper = 'JANITOR_HOUSEKEEPER_LANDSCAPER',
  Lawyer = 'LAWYER',
  ManufacturingOrProductionWorker = 'MANUFACTURING_OR_PRODUCTION_WORKER',
  MilitaryOrPublicSafety = 'MILITARY_OR_PUBLIC_SAFETY',
  NurseHealthcareTechnicianOrHealthcareSupport = 'NURSE_HEALTHCARE_TECHNICIAN_OR_HEALTHCARE_SUPPORT',
  PersonalCareOrServiceWorker = 'PERSONAL_CARE_OR_SERVICE_WORKER',
  PilotDriverOperator = 'PILOT_DRIVER_OPERATOR',
  SalesRepresentativeBrokerAgent = 'SALES_REPRESENTATIVE_BROKER_AGENT',
  ScientistOrTechnologist = 'SCIENTIST_OR_TECHNOLOGIST',
  Student = 'STUDENT'
}

export type OpenEnrollmentDates = {
  __typename?: 'OpenEnrollmentDates';
  /**
   * endDate is the date that open enrollment ends for a value that is configured for the frontend. Not the real OE end date.
   * @deprecated This does not include end time
   */
  endDate: Scalars['Date']['output'];
  /** endTime (UTC) is the date and time that open enrollment ends */
  endTime: Scalars['Time']['output'];
  /** open enrollment coverage year */
  oeCoverageYear: Scalars['Int']['output'];
  /**
   * stateDate is the date that open enrollment starts for the current year.
   * @deprecated This does not include end time
   */
  startDate: Scalars['Date']['output'];
  /** startTime (UTC) is the date and time that open enrollment starts */
  startTime: Scalars['Time']['output'];
  /** windowShoppingOpenTime (UTC) is the date that new plan data is available for exploring */
  windowShoppingOpenTime: Scalars['Time']['output'];
};

export type OptOutRenewalResponse = {
  __typename?: 'OptOutRenewalResponse';
  error?: Maybe<ErrorItem>;
  insuranceEnrollment?: Maybe<HealthInsuranceEnrollment>;
};

export type OtherCoverage = {
  __typename?: 'OtherCoverage';
  /** #192 */
  insuranceMarketType?: Maybe<InsuranceMarketType>;
  /** #197 */
  insurancePlanName?: Maybe<Scalars['String']['output']>;
  /** #195 */
  insurancePolicyMemberID?: Maybe<Scalars['String']['output']>;
  /** #192 */
  insurancePolicyNumber?: Maybe<Scalars['String']['output']>;
};

export type OtherCoverageInput = {
  /** #192 */
  insuranceMarketType?: InputMaybe<InsuranceMarketType>;
  /** #197 */
  insurancePlanName?: InputMaybe<Scalars['String']['input']>;
  /** #195 */
  insurancePolicyMemberID?: InputMaybe<Scalars['String']['input']>;
  /** #192 */
  insurancePolicyNumber?: InputMaybe<Scalars['String']['input']>;
};

/** PageInfo is returned alongside the results of a paginated request */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The current page being provided */
  currentPageNumber: Scalars['Int']['output'];
  /** Whether or not the pagination has a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not the pagination has a previous page */
  hasPrevPage: Scalars['Boolean']['output'];
  /** the page size */
  pageSize: Scalars['Int']['output'];
  /** the total number of items possible to get */
  totalItems: Scalars['Int']['output'];
  /** the total number of pages possible to get */
  totalPages: Scalars['Int']['output'];
};

/** Pagination represents the input to a paginated request */
export type Pagination = {
  /**
   * The page number to get. Note that page numbers are 1 based - to get the first
   * page of results, pass 1, etc.
   */
  pageNumber: Scalars['Int']['input'];
  /** the page size to get - limit of 100 across paginated entities */
  pageSize: Scalars['Int']['input'];
};

/** DEPRECATED */
export type PaidFeature = {
  __typename?: 'PaidFeature';
  catchPaidFeature: CatchPaidFeature;
  feePaymentEvents: FeePaymentEventsConnection;
  isVisible: Scalars['Boolean']['output'];
  status: FeatureStatus;
  subscription?: Maybe<CatchFeeSubscription>;
  type: CatchPaidFeatureType;
};


/** DEPRECATED */
export type PaidFeatureFeePaymentEventsArgs = {
  pagination: Pagination;
};

export type PartnerApplicationMember = Member & {
  __typename?: 'PartnerApplicationMember';
  /** The application this applicant belongs to */
  application: PartnerHealthApplication;
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  homeAddress?: Maybe<Address>;
  /** The Catch UUID */
  id: Scalars['ID']['output'];
  /** Is this applicant disabled */
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is this applicant enrolled in Medicare? */
  isEnrolledInMedicare?: Maybe<Scalars['Boolean']['output']>;
  isSmoker?: Maybe<Scalars['Boolean']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Phone>;
  /** Relation */
  relation?: Maybe<Relation>;
  /** Is this applicant requesting coverage? */
  requestingCoverageIndicator?: Maybe<Scalars['Boolean']['output']>;
  sex?: Maybe<Sex>;
  ssn?: Maybe<Scalars['String']['output']>;
};

export type PartnerApplicationMemberInput = {
  /** The ID of the application this applicant is for */
  applicationID?: InputMaybe<Scalars['ID']['input']>;
  /** ID of thee associated Catch contact, if there is one */
  contactID?: InputMaybe<Scalars['ID']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the associated enrollment */
  enrollmentID?: InputMaybe<Scalars['ID']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  homeAddress?: InputMaybe<AddressInput>;
  /** The Catch UUID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Is this applicant disabled */
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this applicant enrolled in Medicare? */
  isEnrolledInMedicare?: InputMaybe<Scalars['Boolean']['input']>;
  isSmoker?: InputMaybe<Scalars['Boolean']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<PhoneInput>;
  /** Relation */
  relation?: InputMaybe<Relation>;
  /** Is this applicant requesting coverage? */
  requestingCoverageIndicator?: InputMaybe<Trinary>;
  sex?: InputMaybe<Sex>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

/** PartnerHealthApplication types are insurance applications that are made in Catch but sent to a third-party for enrollment and processing */
export type PartnerHealthApplication = HealthInsuranceApplication & {
  __typename?: 'PartnerHealthApplication';
  /** List of members on the application */
  allMembers: Array<PartnerApplicationMember>;
  /** Get the primary applicant (aka, the Catch user) */
  applicant?: Maybe<PartnerApplicationMember>;
  coverageStartDate?: Maybe<Scalars['Date']['output']>;
  /** plan state */
  coverageState?: Maybe<Scalars['String']['output']>;
  coverageYearNumber?: Maybe<Scalars['Int']['output']>;
  enrollment: HealthInsuranceEnrollment;
  /** Pediatric dental coverage for the policy (if applicable) */
  hasDental: Scalars['Boolean']['output'];
  healthInsuranceEnrollmentID?: Maybe<Scalars['ID']['output']>;
  /** Tells you the type of coverage for the health plan */
  healthPlanType?: Maybe<HealthPlanType>;
  /** household income */
  householdIncome: Scalars['Int']['output'];
  /** The Catch UUID */
  id: Scalars['ID']['output'];
  isStartedApplication: Scalars['Boolean']['output'];
  /** The date and time the data in the application was last updated */
  lastUpdated: Scalars['Time']['output'];
  lastUsedRoute?: Maybe<Scalars['String']['output']>;
  /** The date and time the data in the application was last updated by a user */
  lastUserUpdate?: Maybe<Scalars['Time']['output']>;
  /** tax household size */
  numTaxDependents: Scalars['Int']['output'];
  pathway?: Maybe<HealthPathwayType>;
  /**
   * The partner who will recieve this application
   * @deprecated Use pathway for auto determined instead
   */
  pathwayType: HealthPathway;
  /** Inferred from the coverage year */
  period: ApplicationPeriodType;
  /** Returns the plan based on selectedPlanID */
  plan: HealthPlan;
  /** HIOS ID (14 digit code) */
  selectedPlanID?: Maybe<Scalars['ID']['output']>;
  /** Qualifying Life Event Date */
  sepStart?: Maybe<Scalars['Date']['output']>;
  /** SEP code (mandatory during SEP) */
  sepType?: Maybe<SepType>;
  signatureDate?: Maybe<Scalars['Date']['output']>;
  signatureText?: Maybe<Scalars['String']['output']>;
  /** coverage start date */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** This field shows the current status of this application */
  status: HealthApplicationStatus;
};

/** PartnerHealthApplication types are insurance applications that are made in Catch but sent to a third-party for enrollment and processing */
export type PartnerHealthApplicationInput = {
  coverageStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** plan state */
  coverageState?: InputMaybe<Scalars['String']['input']>;
  coverageYearNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Pediatric dental coverage for the policy (if applicable) */
  hasDental?: InputMaybe<Scalars['Boolean']['input']>;
  /** household income */
  householdIncome?: InputMaybe<Scalars['Int']['input']>;
  /** The Catch UUID */
  id?: InputMaybe<Scalars['ID']['input']>;
  isStartedApplication?: InputMaybe<Scalars['Boolean']['input']>;
  lastUsedRoute?: InputMaybe<Scalars['String']['input']>;
  /** tax household size */
  numTaxDependents?: InputMaybe<Scalars['Int']['input']>;
  /** The partner who will recieve this application */
  pathwayType?: InputMaybe<HealthPathway>;
  /** HIOS ID (14 digit code) */
  selectedPlanID?: InputMaybe<Scalars['ID']['input']>;
  /** Qualifying Life Event Date */
  sepStart?: InputMaybe<Scalars['Date']['input']>;
  /** SEP code (mandatory during SEP) */
  sepType?: InputMaybe<SepType>;
  signatureText?: InputMaybe<Scalars['String']['input']>;
  /** coverage start date */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Set to Status=SUBMITTED when a person is done with the health application.
   * If the application submission fails, all other values will be kept except the status.
   * The status will be set back to IN_PROGRESS
   */
  status?: InputMaybe<HealthApplicationStatus>;
};

export type PartnerHealthTask = Task & {
  __typename?: 'PartnerHealthTask';
  assignee?: Maybe<User>;
  catchTask: CatchTask;
  createdOn: Scalars['Time']['output'];
  enrollment?: Maybe<HealthInsuranceEnrollment>;
  id: Scalars['ID']['output'];
  isAssignment: Scalars['Boolean']['output'];
  lastUpdated: Scalars['Time']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  personReference: PersonReference;
  priority?: Maybe<TaskPriority>;
  status: TaskStatus;
  type: TaskType;
  user: User;
};

export enum PaycheckType {
  /** The paycheck was from 1099 work */
  PaycheckType_1099 = 'PAYCHECK_TYPE_1099',
  /** The paycheck was from W2 work */
  PaycheckTypeW2 = 'PAYCHECK_TYPE_W2'
}

/** DEPRECATED */
export type Payee = {
  __typename?: 'Payee';
  /** Indicator if this payee is registered with BBVA */
  IsRegisteredWithProvider: Scalars['Boolean']['output'];
  /** Account number of the account which is being paid - health ins policy number `HealthInsurance.policyNumber` */
  accountNumber: Scalars['String']['output'];
  /** The UUID of the policy associated with the Payee- e.g. OUR `HealthInsurance` object */
  associatedPolicyID?: Maybe<Scalars['ID']['output']>;
  /** The ID of the payee */
  id: Scalars['ID']['output'];
  /** The name on the account of which is being paid: e.g. name on health ins. policy */
  nameOnAccount: Scalars['String']['output'];
  /** The unique ID of the payee from the ACI directory */
  payeeID?: Maybe<Scalars['String']['output']>;
  /** The name of the payee */
  payeeName: Scalars['String']['output'];
  /** The remittance address- or payment address of the payee */
  remittanceAddress: Address;
};

export type PayeeIdInput = {
  payeeID: Scalars['ID']['input'];
};

export type PayeeInput = {
  /** Account number of the account which is being paid - health ins policy number `HealthInsurance.policyNumber` */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the policy associated with the Payee- e.g. OUR `HealthInsurance` object */
  associatedPolicyID?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the payee. REQUIRED on update */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The name on the account of which is being paid: e.g. name on health ins. policy - REQUIRED on create */
  nameOnAccount?: InputMaybe<Scalars['String']['input']>;
  /** The name of the payee- REQUIRED to create by policy */
  payeeName?: InputMaybe<Scalars['String']['input']>;
  /** The remittance address or payment address of the payee */
  remittanceAddress?: InputMaybe<AddressInput>;
};

export enum PayeeVertical {
  PayeeVerticalHealth = 'PAYEE_VERTICAL_HEALTH'
}

export type Payment = {
  __typename?: 'Payment';
  executionDate: Scalars['Time']['output'];
};

export type PaymentEvent = Event & {
  __typename?: 'PaymentEvent';
  amount: Scalars['Dollars']['output'];
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  executionDate: Scalars['Date']['output'];
  fee?: Maybe<Scalars['Dollars']['output']>;
  /** The ID of the associated payment */
  id: Scalars['ID']['output'];
  payeeName: Scalars['String']['output'];
  paymentMethodId?: Maybe<Scalars['ID']['output']>;
  savingsTransferId: Scalars['ID']['output'];
  status?: Maybe<PaymentStatus>;
  time: Scalars['Time']['output'];
};

export enum PaymentFrequency {
  /** This should repeat once a month */
  PaymentFrequencyMonthly = 'PAYMENT_FREQUENCY_MONTHLY'
}

export type PaymentRedirectUrlResult = {
  __typename?: 'PaymentRedirectUrlResult';
  error?: Maybe<ErrorItem>;
  saml?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum PaymentStatus {
  /** Payment canceled by admin */
  PaymentStatusCanceled = 'PAYMENT_STATUS_CANCELED',
  /** Payment failed, needs investigation */
  PaymentStatusFailed = 'PAYMENT_STATUS_FAILED',
  /** Payment created but not sent */
  PaymentStatusInitial = 'PAYMENT_STATUS_INITIAL',
  /** Payment sent */
  PaymentStatusSent = 'PAYMENT_STATUS_SENT',
  /** Payment successful through bank partner */
  PaymentStatusSuccess = 'PAYMENT_STATUS_SUCCESS',
  /** Payment status not known */
  PaymentStatusUnknown = 'PAYMENT_STATUS_UNKNOWN'
}

export enum PaymentType {
  /** Pay for health insurance obtained through the Catch Platform. */
  PaymentTypeHealthPolicy = 'PAYMENT_TYPE_HEALTH_POLICY'
}

export type Person = {
  __typename?: 'Person';
  accountStatus: AccountStatus;
  /** Returns all agreement boolean fields related to this user */
  agreements: Agreements;
  applicationMember?: Maybe<ApplicationMember>;
  consentRequest?: Maybe<ConsentRequest>;
  consentRequests: Array<ConsentRequest>;
  /** Returns a conversion status by year lookup */
  conversionStatus: ConversionStatus;
  /** Returns all conversion statuses */
  conversionStatuses: Array<ConversionStatus>;
  /** This returns a single 3rd party API uploaded document document, use this for urls */
  document?: Maybe<DocumentMetadata>;
  /** This returns all of the user uploaded document metadata after an object has been uploaded to S3 */
  documentUploads: Array<DocumentMetadata>;
  /** This returns all 3rd party API uploaded document metadata e.g. 1040ES, account statements and health docs... */
  documents: DocumentGroup;
  events: Array<ActivityEvent>;
  /** Searches EDE for previous existing applications for this user and saves the metadata for future import. If any missing demographic data exists, will save it to the person if ssn matches */
  existingApplicationInfo: ExistingApplicationsResponse;
  flags: FeatureFlags;
  /** health returns the viewer's health details */
  health: HealthTwo;
  healthApplication?: Maybe<HealthApplication>;
  /** Retrieves health explorer data for user to play around with marketplace */
  healthExplorerData?: Maybe<HealthExplorerData>;
  /** Retrieves a health explorer dependent by id */
  healthExplorerDependent: HealthExplorerDependent;
  /** Retrieves a list of health explorer dependents under this user */
  healthExplorerDependents: Array<HealthExplorerDependent>;
  /** Get Plan details for an enrollment group, an application, a private explorer with a possible plan id override */
  healthPlanDetails: HealthPlan;
  /** id is the viewer's user ID in our system */
  id: Scalars['ID']['output'];
  /** Gets an identity by provider type */
  identity?: Maybe<Identity>;
  /** Returns a list of monthly grouped income, from Jan to Dec */
  incomeForYear: Array<MonthlyIncome>;
  taxPayment: TaxPayment;
  /** Returns a reverse chrono list of tax payments (Payment) */
  taxPayments: Array<TaxPayment>;
  /** Returns the User */
  user: User;
  wealthAccountData: Array<TimeSeriesData>;
};


export type PersonApplicationMemberArgs = {
  id: Scalars['ID']['input'];
};


export type PersonConsentRequestArgs = {
  consentType: ConsentType;
};


export type PersonConversionStatusArgs = {
  type: ConversionStatusType;
  year: Scalars['Int']['input'];
};


export type PersonDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type PersonHealthApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type PersonHealthExplorerDependentArgs = {
  id: Scalars['ID']['input'];
};


export type PersonHealthPlanDetailsArgs = {
  input: GetHealthPlanDetailsInput;
};


export type PersonIdentityArgs = {
  providerType: IdentityProvider;
};


export type PersonIncomeForYearArgs = {
  year: Scalars['Int']['input'];
};


export type PersonTaxPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type PersonTaxPaymentsArgs = {
  input?: InputMaybe<TaxPaymentsInput>;
};


export type PersonWealthAccountDataArgs = {
  range: TimeSeriesRange;
  wealthAccountID: Scalars['ID']['input'];
};

/** The preview of a person from person search query */
export type PersonPreview = {
  __typename?: 'PersonPreview';
  email: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  person: User;
  personReference: PersonReference;
};

/** The preview of a person from person search query */
export type PersonPreviewConnection = {
  __typename?: 'PersonPreviewConnection';
  /** edges will return a node of transaction */
  edges: Array<PersonPreview>;
  /** Information for paginating this connection */
  pageInfo: PageInfo;
};

/** Person Reference is the shared person reference with cross-service data */
export type PersonReference = {
  __typename?: 'PersonReference';
  /** base64 string of the person avatar */
  avatarImage?: Maybe<Scalars['String']['output']>;
  /** Wealth KYC/CIP status, if exists */
  cipStatus?: Maybe<KycStatus>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  filingStatus?: Maybe<FilingStatus>;
  givenName?: Maybe<Scalars['String']['output']>;
  healthApplicantEmail?: Maybe<Scalars['String']['output']>;
  healthApplicantFamilyName?: Maybe<Scalars['String']['output']>;
  healthApplicantGivenName?: Maybe<Scalars['String']['output']>;
  /** If the user is requesting video onboarding */
  healthApplicationStatus?: Maybe<HealthApplicationStatus>;
  healthInsuranceEnrollmentStatus?: Maybe<HealthInsuranceEnrollmentStatus>;
  healthPolicyStatus?: Maybe<PolicyStatus>;
  id: Scalars['ID']['output'];
  intercomID?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  payrollProductTier?: Maybe<DepositProductTier>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredLanguage: PreferredLanguage;
  /** @deprecated No longer supported */
  requestingOnboarding: Scalars['Boolean']['output'];
  /** Only exists if has a DDA */
  savingsKYC?: Maybe<KycStatus>;
  /** Only exists if has a DDA */
  savingsProviderUserID?: Maybe<Scalars['String']['output']>;
  signupCode?: Maybe<Scalars['String']['output']>;
  /** Signup context enum regarding why this person signed up */
  signupContext?: Maybe<SignupContext>;
  /**
   * User account status if the user has a savings account
   * @deprecated No longer supported
   */
  userAccountStatus?: Maybe<UserAccountStatus>;
  /** Only exists if has a Folio wealth acct */
  wealthProviderID?: Maybe<Scalars['String']['output']>;
  workType?: Maybe<WorkType>;
};

export type Phone = {
  __typename?: 'Phone';
  /** Optional phone extension */
  ext?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  type: PhoneType;
};

export type PhoneInput = {
  /** Optional phone extension */
  ext?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  type: PhoneType;
};

export enum PhoneType {
  /** Home phone */
  Home = 'HOME',
  /** Interchangeable with CELL */
  Mobile = 'MOBILE',
  /** Office phone */
  Office = 'OFFICE',
  /** Other phone */
  Other = 'OTHER'
}

export type PlaceInput = {
  countyFips: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

/** DEPRECATED */
export type PlanConfidence = {
  __typename?: 'PlanConfidence';
  ptoConfidence?: Maybe<ConfidenceLevel>;
  retirementConfidence?: Maybe<ConfidenceLevel>;
  taxesConfidence?: Maybe<ConfidenceLevel>;
};

export type PlanConfidenceInput = {
  ptoConfidence?: InputMaybe<ConfidenceLevel>;
  retirementConfidence?: InputMaybe<ConfidenceLevel>;
  taxesConfidence?: InputMaybe<ConfidenceLevel>;
};

export type PlanHistorySummary = {
  __typename?: 'PlanHistorySummary';
  /** The gross income in the requested period */
  grossIncome: Scalars['Dollars']['output'];
  /** The gross 1099 income in the requested period */
  grossIncome1099: Scalars['Dollars']['output'];
  /** The gross W2 income in the requested period */
  grossIncomeW2: Scalars['Dollars']['output'];
  /** The total savings in the requested period, *not including* deposits. */
  totalSavings: Scalars['Dollars']['output'];
  /**
   * The total 1099 savings in the requested period
   * @deprecated Not used. To be removed soon
   */
  totalSavings1099: Scalars['Dollars']['output'];
  /**
   * The total savings in the requested period, *including* deposits
   * @deprecated Not used. To be removed soon
   */
  totalSavingsAll: Scalars['Dollars']['output'];
  /**
   * The total W2 savings in the requested period
   * @deprecated Not used. To be removed soon
   */
  totalSavingsW2: Scalars['Dollars']['output'];
};

export enum PlanProgress {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING'
}

export type PlanSearchInput = {
  carriers?: InputMaybe<Array<Carrier>>;
  productType?: InputMaybe<ProductType>;
};

export enum PlanType {
  Plantype_529Plan = 'PLANTYPE_529_PLAN',
  PlantypeCustomSavings = 'PLANTYPE_CUSTOM_SAVINGS',
  PlantypeDental = 'PLANTYPE_DENTAL',
  PlantypeDisability = 'PLANTYPE_DISABILITY',
  PlantypeEmergencySavings = 'PLANTYPE_EMERGENCY_SAVINGS',
  PlantypeHealth = 'PLANTYPE_HEALTH',
  PlantypeHealthExpenses = 'PLANTYPE_HEALTH_EXPENSES',
  PlantypeLife = 'PLANTYPE_LIFE',
  PlantypeLongDisability = 'PLANTYPE_LONG_DISABILITY',
  PlantypeParentalLeave = 'PLANTYPE_PARENTAL_LEAVE',
  PlantypePto = 'PLANTYPE_PTO',
  PlantypeRetirement = 'PLANTYPE_RETIREMENT',
  PlantypeSavings = 'PLANTYPE_SAVINGS',
  PlantypeShortDisability = 'PLANTYPE_SHORT_DISABILITY',
  PlantypeStudentLoan = 'PLANTYPE_STUDENT_LOAN',
  PlantypeTax = 'PLANTYPE_TAX',
  PlantypeVision = 'PLANTYPE_VISION'
}

export type PlatformReference = {
  __typename?: 'PlatformReference';
  /**
   * blog returns a reference object with fields related to our webflow api
   * @deprecated No longer supported
   */
  blog: BlogReference;
  /**
   * catchTransactionTags returns a list of all the tags in our database.
   *
   * Note that there are over 300 tags, so use pagination as needed.
   */
  catchTransactionTags: CatchTransactionTagConnection;
  /**
   * counties returns a list of counties.
   *
   * For now, the counties query requires a filter - and for now, the only valid filter is to supply a zipcode value.
   */
  counties: Array<County>;
  /** health returns a reference object with fields related to our health vertical. */
  health: HealthReference;
  rewards: Array<ReferenceReward>;
  stateHealthReference: StateHealthReference;
  /** wealth returns a reference object with fields related to our wealth vertical. */
  wealth: WealthReference;
};


export type PlatformReferenceCatchTransactionTagsArgs = {
  pagination: Pagination;
  partnerSignupCode?: InputMaybe<Scalars['String']['input']>;
};


export type PlatformReferenceCountiesArgs = {
  zipcode: Scalars['ZipCode']['input'];
};


export type PlatformReferenceStateHealthReferenceArgs = {
  state: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type PoliciesInput = {
  coverageYearNumber?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<PolicyStatus>>;
};

export type PolicyInput = {
  /** Defined assistor's national producer number */
  agentID?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Tells you if a person should or should not make payments to the policy. */
  paymentStatus?: InputMaybe<PolicyPaymentStatus>;
  planName?: InputMaybe<Scalars['String']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  premium?: InputMaybe<Scalars['Dollars']['input']>;
  premiumEffective?: InputMaybe<Scalars['Dollars']['input']>;
  providerPlanID?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<PolicyStatus>;
  subscriberID?: InputMaybe<Scalars['String']['input']>;
};

export enum PolicyPaymentStatus {
  /** Do not make payment */
  PolicyPaymentStatusCancelled = 'POLICY_PAYMENT_STATUS_CANCELLED',
  /** already made first payment */
  PolicyPaymentStatusEffectuated = 'POLICY_PAYMENT_STATUS_EFFECTUATED',
  /** Cannot make payments yet must resolve issues */
  PolicyPaymentStatusNotEligible = 'POLICY_PAYMENT_STATUS_NOT_ELIGIBLE',
  /** Can pay, can do redirect. It needs the first binding payment */
  PolicyPaymentStatusPendingFirstPayment = 'POLICY_PAYMENT_STATUS_PENDING_FIRST_PAYMENT',
  /** Do not make payment */
  PolicyPaymentStatusTerminated = 'POLICY_PAYMENT_STATUS_TERMINATED'
}

export enum PolicyStatus {
  Active = 'ACTIVE',
  ActivePendingPayment = 'ACTIVE_PENDING_PAYMENT',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  /** If the policy is pending import from an external provider. */
  ImportPending = 'IMPORT_PENDING',
  /** DEPRECATED: This is not being used. */
  InitialEnrollment = 'INITIAL_ENROLLMENT',
  /** Pending SVI resolution - we're in a PPS state */
  Pending = 'PENDING',
  PendingStartDate = 'PENDING_START_DATE',
  Terminated = 'TERMINATED'
}

/** PoliticalExposure describes the user's political exposure */
export type PoliticalExposure = {
  __typename?: 'PoliticalExposure';
  /** The name of the user's political exposure */
  name?: Maybe<Scalars['String']['output']>;
  /** The organization in which the user is politically exposed */
  organization?: Maybe<Scalars['String']['output']>;
  /** The position of political exposure the user has */
  position?: Maybe<Scalars['String']['output']>;
  /** The user's political exposure status */
  status?: Maybe<PoliticalExposureStatus>;
};

/** The input to the updateUser politicalExposure input */
export type PoliticalExposureInput = {
  /** The name of the user's political exposure */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The organization in which the user is politically exposed */
  organization?: InputMaybe<Scalars['String']['input']>;
  /** The position of political exposure the user has */
  position?: InputMaybe<Scalars['String']['input']>;
  /** The user's political exposure status */
  status?: InputMaybe<PoliticalExposureStatus>;
};

/** The political exposure a person has, if any */
export enum PoliticalExposureStatus {
  /** A friend of the user is politically exposed */
  Friend = 'FRIEND',
  /** No Political Exposure */
  None = 'NONE',
  /** A relative of the user is politically exposed */
  Relative = 'RELATIVE',
  /** Are themselves politically exposed */
  Self = 'SELF',
  /** Unknown Political Exposure */
  UnknownPoliticalExposure = 'UNKNOWN_POLITICAL_EXPOSURE'
}

/** Portfolio represents a portfolio entity in our system */
export type Portfolio = {
  __typename?: 'Portfolio';
  /** The contents of the portfolio - security information */
  contents: Array<PortfolioSecurity>;
  /** The portfolio's ID */
  id: Scalars['ID']['output'];
  /** The name of the portfolio */
  name: Scalars['String']['output'];
};

/** PortfolioSecurity holds details about the securities held in the portfolio */
export type PortfolioSecurity = {
  __typename?: 'PortfolioSecurity';
  /** The name of the security */
  name: Scalars['String']['output'];
  /** The ticker of the security */
  ticker: Scalars['String']['output'];
  /** The weight of the associated security */
  weight: Scalars['Float']['output'];
};

/** The user's preferred language on our platform */
export enum PreferredLanguage {
  English = 'ENGLISH',
  Spanish = 'SPANISH'
}

export type PrefillHealthInsuranceEnrollmentResponse = {
  __typename?: 'PrefillHealthInsuranceEnrollmentResponse';
  insuranceEnrollment?: Maybe<HealthInsuranceEnrollment>;
};

export enum PreliminaryEmergencyMedicaidStatusReason {
  '109NotMeetRequirementsForEmergencyMdcaid' = '_109_NOT_MEET_REQUIREMENTS_FOR_EMERGENCY_MDCAID',
  '128DependentChildDoesntHaveMec' = '_128_DEPENDENT_CHILD_DOESNT_HAVE_MEC',
  '302ResidencyIncomePending' = '_302_RESIDENCY_INCOME_PENDING',
  '449DeterminedInelgblByState' = '_449_DETERMINED_INELGBL_BY_STATE',
  '467ChangedIncomeAttestationAboveMdcaidChipLevel' = '_467_CHANGED_INCOME_ATTESTATION_ABOVE_MDCAID_CHIP_LEVEL',
  '470ApplicantRecentlyDeniedMedicaid' = '_470_APPLICANT_RECENTLY_DENIED_MEDICAID',
  '470RecentlyDeniedMdcaidChipPreventReturnToState' = '_470_RECENTLY_DENIED_MDCAID_CHIP_PREVENT_RETURN_TO_STATE',
  '551NotRequestingFinancialAssistance' = '_551_NOT_REQUESTING_FINANCIAL_ASSISTANCE',
  '555NARuleDoesNotApply' = '_555_N_A_RULE_DOES_NOT_APPLY',
  '560IndividualNotRequestingCoverage' = '_560_INDIVIDUAL_NOT_REQUESTING_COVERAGE',
  '999NARuleIndicatorIsY' = '_999_N_A_RULE_INDICATOR_IS_Y'
}

export enum PreliminaryStatus {
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  Yes = 'YES'
}

export type PresignedUrl = {
  __typename?: 'PresignedUrl';
  /** The generated presigned URL */
  url: Scalars['String']['output'];
};

/**
 * This input, if provided, will use this instead of existing user data to find
 * the previous applications
 *
 * Use includePriorYear flag to indicate whether we should return prior year
 * applications information FOR IMPORT INFOMRATIONAL USE ONLY. Do not
 * modify this application for OE unless legitimately a CiC situation.
 *
 * Prior year applications returned with this flag will only be of COMPLETE_ENROLLED status
 */
export type PreviousApplicationsInput = {
  coverageYear: Scalars['Int']['input'];
  includePriorYear?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
};

export type PreviousApplicationsResponse = {
  __typename?: 'PreviousApplicationsResponse';
  error?: Maybe<ErrorItem>;
  existingApplicationsInformation: Array<ExistingApplicationInformation>;
};

export enum ProductType {
  Dental = 'DENTAL',
  Health = 'HEALTH'
}

export type ProfessionalAssistor = {
  __typename?: 'ProfessionalAssistor';
  applicationAssistorType?: Maybe<AssistorType>;
  assistorFFMUserName?: Maybe<Scalars['String']['output']>;
  assistorNPN?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  organizationID?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

/**
 * ProfessionalAssistorInput represents a ProfessionalAssistor for input.
 *
 * As far as I know, the fields are all optional except for the type.
 *
 * If the `applicationAssistorType` is AGENT_BROKER there must be an assistorNPN
 * to go with it.
 *
 * The `assistorFFMUserName` is NOT validated by EDE and is probably not required
 */
export type ProfessionalAssistorInput = {
  applicationAssistorType?: InputMaybe<AssistorType>;
  assistorFFMUserName?: InputMaybe<Scalars['String']['input']>;
  assistorNPN?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
};

export enum Provider {
  Health = 'HEALTH',
  Retirement = 'RETIREMENT',
  Savings = 'SAVINGS'
}

export type PublicConsentRequest = {
  __typename?: 'PublicConsentRequest';
  consentType: ConsentType;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sentAt?: Maybe<Scalars['Time']['output']>;
  status: ConsentStatus;
};

export type PublicHealthExplorerData = {
  __typename?: 'PublicHealthExplorerData';
  countyfips: Scalars['String']['output'];
  coverageYear: Scalars['Int']['output'];
  /**
   * Query MAPI/Ideon for available dental plans with the data in the explorer
   * @deprecated Use plans and specify DENTAL instead
   */
  dentalPlans: SortedHealthPlansResponse;
  dependents: Array<PublicHealthExplorerDependentOld>;
  deps: Array<PublicHealthExplorerDependent>;
  drugsWanted?: Maybe<Array<Drug>>;
  email?: Maybe<Scalars['String']['output']>;
  financialPreference?: Maybe<FinancialPreferenceType>;
  /** Query the Marketplace for plan details w/ the providerPlanID. Will return `nil` if providerPlanID empty */
  healthPlanDetails?: Maybe<HealthPlan>;
  /**
   * Query MAPI/Ideon for available plans w/ this data
   * @deprecated Use plans instead
   */
  healthPlans: SortedHealthPlansResponse;
  id: Scalars['ID']['output'];
  income?: Maybe<Scalars['Dollars']['output']>;
  isSEP: Scalars['Boolean']['output'];
  /** Query the Marketplace for eligibility results */
  marketplaceEligibility: Array<MarketplaceEligibility>;
  pathway?: Maybe<HealthPathwayType>;
  /** @deprecated Use pathway for auto determined instead */
  pathwayType?: Maybe<HealthPathway>;
  plannedUsage?: Maybe<HealthSortWeightType>;
  /** Query MAPI/Ideon for available plans w/ this data */
  plans: SortedHealthPlansResponse;
  /** List of possible coverage years for the state - will fallback if no state in data */
  possibleCoverageYears: Array<Scalars['Int']['output']>;
  providerPlanID?: Maybe<Scalars['String']['output']>;
  providersWanted?: Maybe<Array<HealthProvider>>;
  state: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};


export type PublicHealthExplorerDataPlansArgs = {
  input?: InputMaybe<PlanSearchInput>;
};

export type PublicHealthExplorerDataInput = {
  countyfips: Scalars['String']['input'];
  coverageYear: Scalars['Int']['input'];
  dependents?: InputMaybe<Array<PublicHealthExplorerDependentOldInput>>;
  drugsWanted?: InputMaybe<Array<DrugInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  financialPreference?: InputMaybe<FinancialPreferenceType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  income?: InputMaybe<Scalars['Dollars']['input']>;
  isSEP?: InputMaybe<Scalars['Boolean']['input']>;
  plannedUsage?: InputMaybe<HealthSortWeightType>;
  providerPlanID?: InputMaybe<Scalars['String']['input']>;
  providersWanted?: InputMaybe<Array<HealthProviderInput>>;
  state: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type PublicHealthExplorerDependent = {
  __typename?: 'PublicHealthExplorerDependent';
  age: Scalars['Int']['output'];
  aptcEligible: Scalars['Boolean']['output'];
  hasMec: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isApplying: Scalars['Boolean']['output'];
  isParent: Scalars['Boolean']['output'];
  isPregnant: Scalars['Boolean']['output'];
  isSmoker: Scalars['Boolean']['output'];
  relation: Relation;
  sex?: Maybe<Sex>;
};

/** AGE and RELATION are REQUIRED on creation */
export type PublicHealthExplorerDependentInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  aptcEligible?: InputMaybe<Scalars['Boolean']['input']>;
  hasMec?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isApplying?: InputMaybe<Scalars['Boolean']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  isPregnant?: InputMaybe<Scalars['Boolean']['input']>;
  isSmoker?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<Relation>;
  sex?: InputMaybe<Sex>;
};

export type PublicHealthExplorerDependentOld = {
  __typename?: 'PublicHealthExplorerDependentOld';
  age: Scalars['Int']['output'];
  aptcEligible: Scalars['Boolean']['output'];
  hasMec: Scalars['Boolean']['output'];
  isApplying: Scalars['Boolean']['output'];
  isParent: Scalars['Boolean']['output'];
  isPregnant: Scalars['Boolean']['output'];
  isSmoker: Scalars['Boolean']['output'];
  relation: Relation;
  sex?: Maybe<Sex>;
};

export type PublicHealthExplorerDependentOldInput = {
  age: Scalars['Int']['input'];
  aptcEligible?: InputMaybe<Scalars['Boolean']['input']>;
  hasMec?: InputMaybe<Scalars['Boolean']['input']>;
  isApplying?: InputMaybe<Scalars['Boolean']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  isPregnant?: InputMaybe<Scalars['Boolean']['input']>;
  isSmoker?: InputMaybe<Scalars['Boolean']['input']>;
  relation: Relation;
  sex?: InputMaybe<Sex>;
};

/** PushNotificationSettings represents the notifications the user wants pushed to their mobile device */
export type PushNotificationSettings = {
  __typename?: 'PushNotificationSettings';
  /** Linked Account notifications flag */
  linkedAccountStatus: Scalars['Boolean']['output'];
};

/** PushToken represents an expo push token for pushing notifications out to a user's mobile devices */
export type PushToken = {
  __typename?: 'PushToken';
  /** the device type this token is associated with */
  deviceType: DeviceType;
  /** the ID of the token in our system */
  id: Scalars['ID']['output'];
  /** the expo token */
  token: Scalars['String']['output'];
};

export type QualityRating = {
  __typename?: 'QualityRating';
  available: Scalars['Boolean']['output'];
  clinicalQualityManagementNotRatedReason: Scalars['String']['output'];
  clinicalQualityManagementRating: Scalars['Int']['output'];
  enrolleeExperienceNotRatedReason: Scalars['String']['output'];
  enrolleeExperienceRating: Scalars['Int']['output'];
  globalNotRatedReason: Scalars['String']['output'];
  globalRating: Scalars['Int']['output'];
  planEfficiencyNotRatedReason: Scalars['String']['output'];
  planEfficiencyRating: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  /** Given a consent request token, looks up the public consent request  */
  consentRequest?: Maybe<PublicConsentRequest>;
  getPublicHealthExplorerData: PublicHealthExplorerData;
  getPublicHealthExplorerDependent: PublicHealthExplorerDependent;
  /** List public dependents under public data of ID passed in */
  listPublicHealthExplorerDependents: Array<PublicHealthExplorerDependent>;
  /** Query the Marketplace for plan details */
  publicHealthPlanDetails: HealthPlan;
  /** Query the Marketplace for available plans */
  publicHealthPlans: SortedHealthPlansResponse;
  px: PublicHealthExplorerData;
};


export type QueryConsentRequestArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetPublicHealthExplorerDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPublicHealthExplorerDependentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListPublicHealthExplorerDependentsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicHealthPlanDetailsArgs = {
  id: Scalars['ID']['input'];
  planID: Scalars['ID']['input'];
};


export type QueryPublicHealthPlansArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPxArgs = {
  id: Scalars['ID']['input'];
};

export type Question = {
  __typename?: 'Question';
  /**
   * criteria corresponds to a list of answer keys
   * this should only be populated / be used if dependsOnQuestionKey is not null.
   */
  criteria?: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * If dependsOnQuestionKey is populated, this question should only be shown if:
   * a. the dependsOnQuestionKey question has already been answered, and
   * b. the answer key matches one of the answer keys listed in criteria
   */
  dependsOnQuestionKey?: Maybe<Scalars['ID']['output']>;
  /** question key */
  id: Scalars['ID']['output'];
  /** the answer choices available */
  possibleAnswers: Array<AnswerChoice>;
  /** the text of the question */
  text: Scalars['String']['output'];
  /** the way in which to answer this question */
  type: AnswerChoiceType;
  /**
   * IF this question should only be shown to specific worktypes,
   * this field will be populated with a worktype. If it should be shown
   * regardless of worktype, this will be null.
   */
  workTypeVisibleTo?: Maybe<Array<WorkType>>;
};

export type QuestionAnswer = {
  /** The (optional) list of answer IDs */
  answerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The question being answered */
  questionID: Scalars['ID']['input'];
};

export type QuestionAnswerInput = {
  answerKey: Scalars['String']['input'];
  questionKey: Scalars['String']['input'];
};

/** QueuedReward ... */
export type QueuedReward = {
  __typename?: 'QueuedReward';
  /** the amount this reward is worth */
  amount: Scalars['Dollars']['output'];
  code: Scalars['String']['output'];
  /** When this reward was created */
  createdOn: Scalars['Time']['output'];
  /** a description of what this reward is for */
  description: Scalars['String']['output'];
  status: RewardStatus;
};

export enum Race {
  AmericanIndianOrAlaskanNative = 'AMERICAN_INDIAN_OR_ALASKAN_NATIVE',
  AsianIndian = 'ASIAN_INDIAN',
  BlackOrAfricanAmerican = 'BLACK_OR_AFRICAN_AMERICAN',
  Chinese = 'CHINESE',
  Filipino = 'FILIPINO',
  GuamanianOrChamorro = 'GUAMANIAN_OR_CHAMORRO',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  NativeHawaiian = 'NATIVE_HAWAIIAN',
  Other = 'OTHER',
  OtherAsian = 'OTHER_ASIAN',
  OtherPacificIslander = 'OTHER_PACIFIC_ISLANDER',
  Samoan = 'SAMOAN',
  Vietnamese = 'VIETNAMESE',
  White = 'WHITE'
}

export type RateArea = {
  __typename?: 'RateArea';
  area: Scalars['Int']['output'];
  state: Scalars['String']['output'];
};

export type Recommendation = {
  __typename?: 'Recommendation';
  /** Unique ID of the recommendation in our system */
  id: Scalars['ID']['output'];
  /** The importance of the recommendation, designated by either us or the user */
  importance: RecommendationImportance;
  /** if the recommendation has been acted on by the user */
  isActedOn: Scalars['Boolean']['output'];
  /** if the user is interested in the recommendation */
  isInterested: Scalars['Boolean']['output'];
  /** Deprecated - use benefit.isLive */
  isLive?: Maybe<Scalars['Boolean']['output']>;
  /** timestamp when recomendation was last generated via the checkup */
  lastCheckup?: Maybe<Scalars['Time']['output']>;
  /** timestamp when recomendation was last updated */
  lastUpdated?: Maybe<Scalars['Time']['output']>;
  /** The importance of the recommendation, designated by us at the time of recommendation creation */
  needBasedImportance: RecommendationImportance;
  /** Some text about the plan (Deprecated - use benefit.name) */
  planText?: Maybe<Scalars['String']['output']>;
  /** progress of the plan associated with this recommendation */
  progress?: Maybe<PlanProgress>;
  /** the reason we're giving this recommendation for this user */
  reason: Scalars['String']['output'];
  /** url route of the plan associated with this recommendation */
  route?: Maybe<Scalars['String']['output']>;
  /** The type of recommendation this is (Deprecated - use benefit.type) */
  type?: Maybe<PlanType>;
};

export enum RecommendationImportance {
  Consider = 'CONSIDER',
  Contributing = 'CONTRIBUTING',
  Covered = 'COVERED',
  Important = 'IMPORTANT',
  None = 'NONE',
  Vital = 'VITAL'
}

/** DEPRECATED */
export type Recommendations = {
  __typename?: 'Recommendations';
  /** When the recommendations were generated */
  createdOn: Scalars['Time']['output'];
  /** indicates whether recommendations were generated by doing the guide or not */
  isSkipped?: Maybe<Scalars['Boolean']['output']>;
  /** timestamp when recomendation was last generated via the checkup */
  lastCheckup?: Maybe<Scalars['Time']['output']>;
  /** timestamp when recomendation was last updated */
  lastUpdated?: Maybe<Scalars['Time']['output']>;
  /** A list of recommendations */
  recommendations: Array<Recommendation>;
  /** The survey ID from which these recommendations were generated */
  surveyID?: Maybe<Scalars['ID']['output']>;
};

export type RecurringPayment = {
  __typename?: 'RecurringPayment';
  PaymentFrequency: PaymentFrequency;
  amount?: Maybe<Scalars['Dollars']['output']>;
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  payee: Payee;
  paymentMethodID?: Maybe<Scalars['ID']['output']>;
  paymentType?: Maybe<PaymentType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status: RecurringPaymentStatus;
};

export type RecurringPaymentInput = {
  __typename?: 'RecurringPaymentInput';
  PaymentFrequency?: Maybe<PaymentFrequency>;
  amount?: Maybe<Scalars['Dollars']['output']>;
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  payeeID?: Maybe<Scalars['ID']['output']>;
  paymentMethodID?: Maybe<Scalars['ID']['output']>;
  paymentType?: Maybe<PaymentType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<RecurringPaymentStatus>;
};

export enum RecurringPaymentStatus {
  /** This RecurringPayment has been set up and has scheduled payments that will be executed on their due date. */
  RecurringPaymentActive = 'RECURRING_PAYMENT_ACTIVE',
  /** This RecurringPayment does not have scheduled payments. */
  RecurringPaymentCanceled = 'RECURRING_PAYMENT_CANCELED',
  /** This RecurringPayment has information but does not have scheduled payments set up. Thus there are no automated payments. */
  RecurringPaymentInitial = 'RECURRING_PAYMENT_INITIAL'
}

export type ReferenceReward = {
  __typename?: 'ReferenceReward';
  amount: Scalars['Dollars']['output'];
  code: Scalars['String']['output'];
  /** When this reward was created */
  createdOn: Scalars['Time']['output'];
  description: Scalars['String']['output'];
};

export enum Relation {
  AdoptedChild = 'ADOPTED_CHILD',
  Annuitant = 'ANNUITANT',
  Aunt = 'AUNT',
  Child = 'CHILD',
  ChildInLaw = 'CHILD_IN_LAW',
  ChildOfDomesticPartner = 'CHILD_OF_DOMESTIC_PARTNER',
  CollateralDependent = 'COLLATERAL_DEPENDENT',
  CourtAppointedGuardian = 'COURT_APPOINTED_GUARDIAN',
  Cousin = 'COUSIN',
  DomesticPartner = 'DOMESTIC_PARTNER',
  ExSpouse = 'EX_SPOUSE',
  FosterChild = 'FOSTER_CHILD',
  Grandchild = 'GRANDCHILD',
  Grandparent = 'GRANDPARENT',
  Guardian = 'GUARDIAN',
  LifePartner = 'LIFE_PARTNER',
  Nephew = 'NEPHEW',
  Niece = 'NIECE',
  OtherDependent = 'OTHER_DEPENDENT',
  OtherRelative = 'OTHER_RELATIVE',
  Parent = 'PARENT',
  ParentInLaw = 'PARENT_IN_LAW',
  Self = 'SELF',
  Sibling = 'SIBLING',
  SiblingInLaw = 'SIBLING_IN_LAW',
  SponsoredDependent = 'SPONSORED_DEPENDENT',
  Spouse = 'SPOUSE',
  Stepchild = 'STEPCHILD',
  Stepparent = 'STEPPARENT',
  Trustee = 'TRUSTEE',
  Uncle = 'UNCLE',
  Unrelated = 'UNRELATED',
  Ward = 'WARD'
}

export type RemoveApplicationMemberInput = {
  id: Scalars['ID']['input'];
  /** The date of the change causing the user to be removed */
  removeDate?: InputMaybe<Scalars['Date']['input']>;
  /** The Reason this user is being removed from the application */
  removeReason: RemoveMemberReason;
};

/**
 * RemoveAvatarRequest defines the input to the `removeAvatar` mutation.
 *
 * Either the contact ID or the person ID must be populated.
 */
export type RemoveAvatarRequest = {
  contactID?: InputMaybe<Scalars['ID']['input']>;
  personID?: InputMaybe<Scalars['ID']['input']>;
};

export enum RemoveMemberReason {
  Death = 'DEATH',
  Divorce = 'DIVORCE',
  Other = 'OTHER'
}

export type ReportHealthEnrollmentChangesInput = {
  applicationInput?: InputMaybe<UpsertHealthApplicationInput>;
  memberInputs?: InputMaybe<Array<ApplicationMemberChangeInput>>;
};

export type ReportHealthEnrollmentChangesResponse = {
  __typename?: 'ReportHealthEnrollmentChangesResponse';
  error?: Maybe<ErrorItem>;
  insuranceEnrollment?: Maybe<HealthInsuranceEnrollment>;
};

export enum ReportType {
  BillingReport = 'BILLING_REPORT',
  MonthlyStatement = 'MONTHLY_STATEMENT',
  Tax_1099Document = 'TAX_1099_DOCUMENT',
  TaxStatement_1099R = 'TAX_STATEMENT_1099R',
  TaxStatement_5498 = 'TAX_STATEMENT_5498',
  TradeConfirmation = 'TRADE_CONFIRMATION'
}

export type RequestConciergeInput = {
  conciergeType: ConciergeType;
};

export type ResendConsentRequestInput = {
  token: Scalars['String']['input'];
};

/** Residency represents a user's residency information */
export type Residency = {
  __typename?: 'Residency';
  /** The birth country of the user */
  birthCountry?: Maybe<Scalars['String']['output']>;
  /** The country in which the user holds citizenship */
  citizenshipCountry?: Maybe<Scalars['String']['output']>;
  /** If the user is a green card holder */
  isGreenCardHolder?: Maybe<Scalars['Boolean']['output']>;
  isResidentAlien?: Maybe<Scalars['Boolean']['output']>;
  /** If the user is a US citizen */
  isUSCitizen?: Maybe<Scalars['Boolean']['output']>;
  /** The visa information of the user */
  visa?: Maybe<Visa>;
};

/** ResidencyInput is the input for the residency section of the updateUser mutation */
export type ResidencyInput = {
  /** The birth country of the user */
  birthCountry?: InputMaybe<Scalars['String']['input']>;
  /** The country in which the user holds citizenship */
  citizenshipCountry?: InputMaybe<Scalars['String']['input']>;
  /** If the user is a green card holder */
  isGreenCardHolder?: InputMaybe<Scalars['Boolean']['input']>;
  isResidentAlien?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the user is a US citizen */
  isUSCitizen?: InputMaybe<Scalars['Boolean']['input']>;
  /** The visa information of the user */
  visa?: InputMaybe<VisaInput>;
};

export enum ResolutionStatus {
  ContactingEmployerBecauseSubjectToEscSampling = 'CONTACTING_EMPLOYER_BECAUSE_SUBJECT_TO_ESC_SAMPLING',
  Expired = 'EXPIRED',
  PendingAdditionalDocumentation = 'PENDING_ADDITIONAL_DOCUMENTATION',
  PendingDocumentation = 'PENDING_DOCUMENTATION',
  Resolved = 'RESOLVED',
  UnderReview = 'UNDER_REVIEW'
}

export enum ResponseResultType {
  Error = 'ERROR',
  Success = 'SUCCESS',
  SuccessWithError = 'SUCCESS_WITH_ERROR'
}

/** Reward are the attributes of a valid referral or access code */
export type Reward = {
  __typename?: 'Reward';
  /** the amount this reward is worth */
  amount: Scalars['Dollars']['output'];
  /** a description of what this reward is for */
  description: Scalars['String']['output'];
};

/**
 * RewardStatuses the frontend can query for
 * For now, this doesn't include the statuses past PENDING as these will be
 * reflected in the goal transfers
 */
export enum RewardStatus {
  Deleted = 'DELETED',
  Initial = 'INITIAL',
  Paid = 'PAID',
  Pending = 'PENDING',
  TransactionPending = 'TRANSACTION_PENDING'
}

/** When a user deposists a sum into their account */
export type RolloverEvent = Event & {
  __typename?: 'RolloverEvent';
  /** The account that had the money rolled into */
  account: WealthAccount;
  amount: Scalars['Dollars']['output'];
  /** The ID of the event */
  id: Scalars['ID']['output'];
  time: Scalars['Time']['output'];
};

export type Sbcs = {
  __typename?: 'SBCS';
  baby: Summary;
  diabetes: Summary;
  fracture: Summary;
};

export type SepEligibility = {
  __typename?: 'SEPEligibility';
  earliestQhpEffective?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  latestQhpEffective?: Maybe<Scalars['Date']['output']>;
  sepReason?: Maybe<SepType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  verificationPending: Scalars['Boolean']['output'];
};

export enum SepType {
  Accelerated = 'ACCELERATED',
  AccessIchra = 'ACCESS_ICHRA',
  AccessQsehra = 'ACCESS_QSEHRA',
  AdminCustomEffectiveDate = 'ADMIN_CUSTOM_EFFECTIVE_DATE',
  AdminNonCustomEffectiveDate = 'ADMIN_NON_CUSTOM_EFFECTIVE_DATE',
  Adoption = 'ADOPTION',
  Aptc = 'APTC',
  Csr = 'CSR',
  ExceptionalCircumstance = 'EXCEPTIONAL_CIRCUMSTANCE',
  ExtendedOe = 'EXTENDED_OE',
  LawfulPresence = 'LAWFUL_PRESENCE',
  LossOfCoverage = 'LOSS_OF_COVERAGE',
  Marriage = 'MARRIAGE',
  MedicaidChipDenial = 'MEDICAID_CHIP_DENIAL',
  Move = 'MOVE',
  Newborn = 'NEWBORN',
  None = 'NONE',
  PlanAptcCsrEligibilityChange = 'PLAN_APTC_CSR_ELIGIBILITY_CHANGE',
  PlanNoLongerAvailable = 'PLAN_NO_LONGER_AVAILABLE',
  ReleaseFromIncarceration = 'RELEASE_FROM_INCARCERATION',
  TribeMembership = 'TRIBE_MEMBERSHIP'
}

export enum SsnStatus {
  Delay = 'DELAY',
  Error = 'ERROR',
  Hold = 'HOLD',
  HubCallCompleted = 'HUB_CALL_COMPLETED',
  Inconsistent = 'INCONSISTENT',
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING',
  Temporary = 'TEMPORARY',
  Yes = 'YES'
}

export enum SsnStatusReason {
  /** 456 */
  DataSourceNotCalledDueToFailedIdProof = 'DATA_SOURCE_NOT_CALLED_DUE_TO_FAILED_ID_PROOF',
  /** 187 */
  DeathDataPresent = 'DEATH_DATA_PRESENT',
  /** 432 */
  DmiResolvedByEswAdjudication = 'DMI_RESOLVED_BY_ESW_ADJUDICATION',
  /** 191 */
  EdsNotAvailable = 'EDS_NOT_AVAILABLE',
  /** 477 */
  EswExpiredAnotherDmiSoInelgble = 'ESW_EXPIRED_ANOTHER_DMI_SO_INELGBLE',
  /** 476 */
  EswExpiredDmi = 'ESW_EXPIRED_DMI',
  /** 341 */
  HubDidNotRespond = 'HUB_DID_NOT_RESPOND',
  /** 227 */
  NoEdsDataFound = 'NO_EDS_DATA_FOUND',
  /** 352 */
  NoSsnProvided = 'NO_SSN_PROVIDED',
  /** 714 */
  NAQhpStoppedByOfflineProcess = 'N_A_QHP_STOPPED_BY_OFFLINE_PROCESS',
  /** 555 */
  NARuleDoesNotApply = 'N_A_RULE_DOES_NOT_APPLY',
  /** 999 */
  NARuleIndicatorIsY = 'N_A_RULE_INDICATOR_IS_Y',
  /** 634 */
  SsaDataMismatch = 'SSA_DATA_MISMATCH',
  /** 573 */
  SsaHubCallHeldCallCounter_3OrMore = 'SSA_HUB_CALL_HELD_CALL_COUNTER_3_OR_MORE',
  /** 288 */
  SsnNotVerified = 'SSN_NOT_VERIFIED',
  /** 287 */
  SsnWasNotMatchedWithAttestedInformation = 'SSN_WAS_NOT_MATCHED_WITH_ATTESTED_INFORMATION'
}

/** Special Enrollment Period Verification Issue */
export type Svi = {
  __typename?: 'SVI';
  /** Edge back to the application tied to this SVI */
  application: HealthApplication;
  dependentIDs: Array<Scalars['ID']['output']>;
  generatedPhysicalDocuments?: Maybe<Array<GeneratedPhysicalDocument>>;
  id: Scalars['ID']['output'];
  lastReviewed?: Maybe<Scalars['Time']['output']>;
  /** The list of members relating to this SVI. */
  members: Array<ApplicationMember>;
  resolveBy?: Maybe<Scalars['Time']['output']>;
  status: ConsolidatedIssueStatus;
  statusCode: SviStatusCode;
};

export enum SviDocumentType {
  AdoptionLetterOrRecord = 'ADOPTION_LETTER_OR_RECORD',
  Affidavit = 'AFFIDAVIT',
  ArrivalDepartureRecordI_94I_94A = 'ARRIVAL_DEPARTURE_RECORD_I_94_I_94A',
  BillsFinancialStatementAtNewAddress = 'BILLS_FINANCIAL_STATEMENT_AT_NEW_ADDRESS',
  CourtOrder = 'COURT_ORDER',
  DenialLetterFromYourState = 'DENIAL_LETTER_FROM_YOUR_STATE',
  DhsImmigrationDocument = 'DHS_IMMIGRATION_DOCUMENT',
  DocumentForCoverageLossDueToDeath = 'DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DEATH',
  DocumentForCoverageLossDueToDivorceSeparation = 'DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DIVORCE_SEPARATION',
  DocumentFromAnEmployer = 'DOCUMENT_FROM_AN_EMPLOYER',
  FosterCarePapers = 'FOSTER_CARE_PAPERS',
  HealthCareProgramDocument = 'HEALTH_CARE_PROGRAM_DOCUMENT',
  LegalGuardianshipDocument = 'LEGAL_GUARDIANSHIP_DOCUMENT',
  LetterAboutCobraCoverage = 'LETTER_ABOUT_COBRA_COVERAGE',
  LetterForLossOfStudentCoverage = 'LETTER_FOR_LOSS_OF_STUDENT_COVERAGE',
  LetterFromAnEmployer = 'LETTER_FROM_AN_EMPLOYER',
  LetterFromAnInsuranceCompany = 'LETTER_FROM_AN_INSURANCE_COMPANY',
  LetterFromAGovernmentOrganization = 'LETTER_FROM_A_GOVERNMENT_ORGANIZATION',
  LetterOfExplanation = 'LETTER_OF_EXPLANATION',
  LetterStatingLostCoverage = 'LETTER_STATING_LOST_COVERAGE',
  MarketplaceLetter = 'MARKETPLACE_LETTER',
  MarriageCert = 'MARRIAGE_CERT',
  MarriageLicense = 'MARRIAGE_LICENSE',
  MedicalSupportOrder = 'MEDICAL_SUPPORT_ORDER',
  MortgageRentalDocumentAtNewAddress = 'MORTGAGE_RENTAL_DOCUMENT_AT_NEW_ADDRESS',
  OfficialPublicRecord = 'OFFICIAL_PUBLIC_RECORD',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  PayStub = 'PAY_STUB',
  ReligiousDocument = 'RELIGIOUS_DOCUMENT',
  ScreenshotOfResults = 'SCREENSHOT_OF_RESULTS',
  USPostalServiceChangeOfAddressLetter = 'U_S_POSTAL_SERVICE_CHANGE_OF_ADDRESS_LETTER'
}

export type SviDocumentUpload = {
  __typename?: 'SVIDocumentUpload';
  /** date document was uploaded */
  createdOn: Scalars['Date']['output'];
  /** The ID of the image metadata */
  id: Scalars['ID']['output'];
  /** The SVI ID this document relates to */
  issueID: Scalars['ID']['output'];
  /** key/name of the object in s3 */
  key: Scalars['String']['output'];
  /** The type of document */
  type: SviDocumentType;
  /**
   * The temporary URL from which the image can be accessed.
   * Gets the URL based on the application this SVI is related to.
   */
  url: Scalars['String']['output'];
};

export enum SviStatusCode {
  Adoption = 'ADOPTION',
  Marriage = 'MARRIAGE',
  MecLoss = 'MEC_LOSS',
  MovedToNewServiceArea = 'MOVED_TO_NEW_SERVICE_AREA',
  SepGrantedForMdcaidDenial = 'SEP_GRANTED_FOR_MDCAID_DENIAL'
}

/** SaveWalletCardInput is the input to the saveWalletCard mutation. */
export type SaveWalletCardInput = {
  /** filetype is the filetype of the image that was uploaded. */
  filetype: ImageFiletype;
  /** id is the ID of the WalletItem that this card should be associated with. */
  id: Scalars['ID']['input'];
  /** key is the the string key that was used for uploading the image to S3. */
  key: Scalars['String']['input'];
  /** side is the side of the card that's being saved. */
  side: WalletCardSide;
};

export type SavingsAccount = {
  __typename?: 'SavingsAccount';
  accountNumber?: Maybe<Scalars['String']['output']>;
  balance: Scalars['Dollars']['output'];
  /** Final balance for a closed account */
  finalBalance?: Maybe<Scalars['Dollars']['output']>;
  /** Is this account in the process of migrating from BBVA to Bond */
  isMigrating: Scalars['Boolean']['output'];
  /** For Bond DDAs KYC may be reattempted if KYC Denied */
  kyc?: Maybe<KycStatus>;
  kycIdvRequired?: Maybe<Array<KycNeeded>>;
  notes?: Maybe<Scalars['String']['output']>;
  preventIdentityLock: Scalars['Boolean']['output'];
  providerBaseAccountId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  savingsProviderType: SavingsProviderType;
  settledBalance: Scalars['Dollars']['output'];
  status: UserAccountStatus;
};

export type SavingsAccountMetadata = {
  __typename?: 'SavingsAccountMetadata';
  /** If the account is locked by our system. */
  isAccountLocked: Scalars['Boolean']['output'];
  /** If the account is considered ready. */
  isAccountReady: Scalars['Boolean']['output'];
  /** Is this account in the process of migrating from BBVA to Bond */
  isMigrating: Scalars['Boolean']['output'];
  /**
   * kycStatus returns the KYC status of the user with our savings provider, or
   * null if the user has not started the KYC process.
   */
  kycStatus?: Maybe<KycStatus>;
  /** restrictions returns a list of any restrictions in place for this user */
  restrictions?: Maybe<Array<SavingsAccountRestrictions>>;
  savingsProviderType: SavingsProviderType;
  /** The account's overall status. */
  status: UserAccountStatus;
};

export enum SavingsAccountRestrictions {
  SavingsaccountrestrictionsBanklink = 'SAVINGSACCOUNTRESTRICTIONS_BANKLINK',
  SavingsaccountrestrictionsWithdraw = 'SAVINGSACCOUNTRESTRICTIONS_WITHDRAW'
}

export enum SavingsProviderType {
  Bbva = 'BBVA',
  BbvaProdDeprecated = 'BBVA_PROD_DEPRECATED',
  Bond = 'BOND',
  Internal = 'INTERNAL',
  SynapseDeprecated = 'SYNAPSE_DEPRECATED',
  Unit = 'UNIT'
}

export type ScheduleConciergeInput = {
  conciergeType: ConciergeType;
};

export type ScheduledPayment = {
  __typename?: 'ScheduledPayment';
  amount?: Maybe<Scalars['Dollars']['output']>;
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  payee: Payee;
  paymentMethodID?: Maybe<Scalars['ID']['output']>;
  paymentType?: Maybe<PaymentType>;
  recurringPaymentID?: Maybe<Scalars['ID']['output']>;
};

export type ScoredHealthPlan = {
  __typename?: 'ScoredHealthPlan';
  drugCoverage: Array<Drug>;
  healthPlan: HealthPlan;
  /** The id of the health plan represented */
  id: Scalars['String']['output'];
  isBudgetPick: Scalars['Boolean']['output'];
  isCatchRecommended: Scalars['Boolean']['output'];
  isComprehensive: Scalars['Boolean']['output'];
  providerCoverage: Array<HealthProvider>;
  scores?: Maybe<Scores>;
};

export type Scores = {
  __typename?: 'Scores';
  avSubscore: Scalars['Float']['output'];
  budgetScore: Scalars['Float']['output'];
  comprehensiveScore: Scalars['Float']['output'];
  deductible: Scalars['Float']['output'];
  deductibleSubscore: Scalars['Float']['output'];
  drugsSubscore: Scalars['Float']['output'];
  maxAnnualCost: Scalars['Float']['output'];
  maxAnnualCostSubscore: Scalars['Float']['output'];
  planTypeSubscore: Scalars['Float']['output'];
  preferredPartnerSubscore: Scalars['Float']['output'];
  premiumSubscore: Scalars['Float']['output'];
  providersSubscore: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
};

/** The input for the SearchPersonReference query */
export type SearchPersonReferenceRequest = {
  cipStatuses?: InputMaybe<Array<KycStatus>>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  /** Will work with given name, email, health email, last name, folio provider ID, bbva provider ID */
  genericQuery?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  healthApplicantEmail?: InputMaybe<Scalars['String']['input']>;
  healthApplicantFamilyName?: InputMaybe<Scalars['String']['input']>;
  healthApplicantGivenName?: InputMaybe<Scalars['String']['input']>;
  healthApplicationStatuses?: InputMaybe<Array<HealthApplicationStatus>>;
  healthInsuranceEnrollmentStatuses?: InputMaybe<Array<HealthInsuranceEnrollmentStatus>>;
  healthPolicyStatuses?: InputMaybe<Array<PolicyStatus>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  identityProviders?: InputMaybe<Array<IdentityProvider>>;
  identityStatuses?: InputMaybe<Array<IdentityStatus>>;
  kycStatuses?: InputMaybe<Array<KycStatus>>;
  pagination: Pagination;
  payrollProductTiers?: InputMaybe<Array<DepositProductTier>>;
  requestingOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  signupContexts?: InputMaybe<Array<SignupContext>>;
  userAccountStatuses?: InputMaybe<Array<UserAccountStatus>>;
  workTypes?: InputMaybe<Array<WorkType>>;
};

/** The input for SearchPersons query */
export type SearchPersonsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  genericQuery?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  pagination: Pagination;
};

export type SendPlanDetailsInput = {
  /** hasDependents: does this user have dependents (other than themselves?) */
  hasDependents: Scalars['Boolean']['input'];
  /** health insurance enrollment input for plan detail calculation for members */
  healthInsuranceEnrollmentID: Scalars['ID']['input'];
  /** isEnrolling: is the user triggering this mutation with the Enroll Now button? */
  isEnrolling: Scalars['Boolean']['input'];
  selectedProviderPlanID?: InputMaybe<Scalars['ID']['input']>;
};

export type SessionInformation = {
  __typename?: 'SessionInformation';
  /** Keep track of the last ten user session starts */
  loginHistory?: Maybe<Array<LoginHistory>>;
  timezone?: Maybe<Scalars['String']['output']>;
};

/**
 * SetIncomeInput is the input for the setIncome mutation
 * NOTE: for mixed income users, make sure to supply both of these values at once.
 */
export type SetIncomeInput = {
  /** The user's estimated 1099 income */
  estimated1099Income?: InputMaybe<Scalars['Dollars']['input']>;
  /**
   * NOTE: If provided, this income will default to the WorkType of the person
   * It would be nice to remove this field in the future. API consumers should use
   * a specific income type.
   */
  estimatedIncome?: InputMaybe<Scalars['Dollars']['input']>;
  /** The user's estimated W2 income */
  estimatedW2Income?: InputMaybe<Scalars['Dollars']['input']>;
};

/** SetIncomeStateInput is the input for the setIncomeState mutation */
export type SetIncomeStateInput = {
  /** The state where the user received income */
  state: Scalars['String']['input'];
};

export type SetRecommendationImportanceInput = {
  /** The recommendation importance */
  importance: RecommendationImportance;
  /** The recommendation to target */
  recommendationID: Scalars['ID']['input'];
};

export type SetRecommendationIsActedOnInput = {
  /** If the recommendation has been acted on */
  isActedOn: Scalars['Boolean']['input'];
  /** The recommendation to target */
  recommendationID: Scalars['ID']['input'];
};

export type SetRecommendationIsInterestedInput = {
  /** If the user is interested in the recommendation */
  isInterested: Scalars['Boolean']['input'];
  /** The recommendation to target */
  recommendationID: Scalars['ID']['input'];
};

/** For now, if `estimatedIncome` isn't provided, this doesn't do anything. */
export type SetSpouseIncomeInput = {
  estimatedIncome?: InputMaybe<Scalars['Dollars']['input']>;
};

export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE'
}

export enum SexAssignedAtBirth {
  DontKnow = 'DONT_KNOW',
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER'
}

export enum SexualOrientation {
  Bisexual = 'BISEXUAL',
  DifferentTerm = 'DIFFERENT_TERM',
  DontKnow = 'DONT_KNOW',
  LesbianOrGay = 'LESBIAN_OR_GAY',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER',
  Straight = 'STRAIGHT'
}

export type SignAgreementInput = {
  agreementType: AgreementType;
  version: Scalars['String']['input'];
};

export type SignConsentRequestInput = {
  agreed: Scalars['Boolean']['input'];
  agreements?: InputMaybe<Array<SignAgreementInput>>;
  token: Scalars['String']['input'];
};

export enum SignatureType {
  AgentBroker = 'AGENT_BROKER',
  Applicant = 'APPLICANT',
  AuthorizedRepresentative = 'AUTHORIZED_REPRESENTATIVE'
}

/** What the user's main reason for signing up was */
export enum SignupContext {
  HealthApplication = 'HEALTH_APPLICATION',
  HealthLink = 'HEALTH_LINK',
  HealthRenew = 'HEALTH_RENEW',
  PremiumSlasher = 'PREMIUM_SLASHER',
  Retirement = 'RETIREMENT',
  Savings = 'SAVINGS',
  Tax = 'TAX'
}

/** Whether the user signed up on their own or was created through an admin */
export enum SignupSource {
  /** the user was created by an admin */
  AdminCreated = 'ADMIN_CREATED',
  /** the user signed up on their own */
  UserCreated = 'USER_CREATED'
}

export type SkipSurveyInput = {
  /** List of plans that the user wants to be interested in. If left as null, skipSurvey will default to ALL interested. @DEPRECATED - Please use benefit input */
  plans?: InputMaybe<Array<PlanType>>;
};

export enum SortDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type SortedHealthPlansResponse = {
  __typename?: 'SortedHealthPlansResponse';
  plans: Array<ScoredHealthPlan>;
  /** shows plans that have any of these true: isCatchRecommended, isBudgetPick, isComprehensive */
  topPlans: TopPlans;
};

export type StartSessionInput = {
  deviceType?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** State represents a state in the United States of America. */
export type State = {
  __typename?: 'State';
  /**
   * code is a 2 character state code for the state.
   *
   * See the scalar's documentation for more details.
   */
  code: StateCode;
  /**
   * The full name of the state.
   *
   * Examples: "Massachusetts", "New Hampshire"
   */
  name: Scalars['String']['output'];
};

export enum StateCode {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Georgia */
  Ga = 'GA',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY'
}

export type StateHealthReference = {
  __typename?: 'StateHealthReference';
  coverageYear?: Maybe<Scalars['Int']['output']>;
  /** Is this state supported on the EDE exchange? */
  isSupported: Scalars['Boolean']['output'];
  /** exchange name */
  name?: Maybe<Scalars['String']['output']>;
  /** endTime (UTC) is the date and time that open enrollment ends */
  oeEndTime: Scalars['Time']['output'];
  pathway?: Maybe<HealthPathwayType>;
  /** secondaryOEEndTime (UTC) is the time that open enrollment ends for Feb 1 policies, if appliciable */
  secondaryOEEndTime?: Maybe<Scalars['Time']['output']>;
  /** exchange url */
  url?: Maybe<Scalars['String']['output']>;
};

export type StateReferenceData = {
  __typename?: 'StateReferenceData';
  deprivationRequirementRetained: Scalars['Boolean']['output'];
  optionStudentResidency: Scalars['Boolean']['output'];
  stateCHIPWaitingPeriod: Scalars['Int']['output'];
  /** The app is in state that allows EDE to determine CHIP eligibility. The field is False if the state has their own CHIP agency that determines CHIP eligibility. */
  stateDeterminesChipEligibility: Scalars['Boolean']['output'];
  /** The app is in state that allows EDE to determine Medicaid eligibility */
  stateDeterminesMedicaidEligibility: Scalars['Boolean']['output'];
  under21AndFTSOption: Scalars['Boolean']['output'];
};

export type Statement = {
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

export enum StatementAccountType {
  Dda = 'DDA',
  Ira = 'IRA'
}

export type StatementAvailableEvent = Event & {
  __typename?: 'StatementAvailableEvent';
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the associated statement */
  id: Scalars['ID']['output'];
  periodEnding?: Maybe<Scalars['Date']['output']>;
  time: Scalars['Time']['output'];
  type: StatementType;
};

export enum StatementType {
  Savings = 'SAVINGS',
  Wealth = 'WEALTH'
}

export type SubmitDocumentInput = {
  /** ID of the DocumentMetadata object */
  documentID: Scalars['ID']['input'];
  /** ID of the documentRequired object */
  documentRequiredID: Scalars['ID']['input'];
};

export type SubmitDocumentListInput = {
  documentList: Array<SubmitDocumentInput>;
};

export type SubmitEnrollmentResponse = {
  __typename?: 'SubmitEnrollmentResponse';
  currentAppStatus: HealthApplicationStatus;
  error?: Maybe<ErrorItem>;
  /** Contains internal service/validation errors */
  healthServiceError?: Maybe<ErrorItem>;
  memberResponseCode?: Maybe<Scalars['String']['output']>;
  memberResponseSubcode?: Maybe<Scalars['String']['output']>;
  policyResponseCode: Scalars['String']['output'];
  policyResponseSubcode?: Maybe<Scalars['String']['output']>;
};

export type SubmitHealthApplicationAgreements = {
  isAbsentParentAgreement?: InputMaybe<Trinary>;
  isChangeInformationAgreement: Trinary;
  isMedicaidRequirementAgreement?: InputMaybe<Trinary>;
  isPenaltyOfPerjuryAgreement: Trinary;
  isRenewalAgreement?: InputMaybe<Trinary>;
  isTaxCreditReconciled?: InputMaybe<Trinary>;
  isTerminateCoverageOtherMecFoundAgreement?: InputMaybe<Trinary>;
  lastUsedRoute?: InputMaybe<Scalars['String']['input']>;
  renewEligibilityYearQuantity?: InputMaybe<Scalars['Int']['input']>;
  signatureDate: Scalars['Date']['input'];
  signatureText: Scalars['String']['input'];
  signatureType: SignatureType;
};

/**
 * SubmitHealthApplicationResponse contains the current application for
 * healthcare, and contains a validation error if there is one. This is a response
 * from the SubmitHealthApplication mutation.
 */
export type SubmitHealthApplicationResponse = {
  __typename?: 'SubmitHealthApplicationResponse';
  currApplication: HealthApplication;
  error?: Maybe<ErrorItem>;
  errors?: Maybe<Array<EdeValidationError>>;
  /** Raw JSONified error list from SUCCESS_WITH_ERROR. Will only exist if SUCCESS_WITH_ERROR resulted from the Ensure call */
  successWithError?: Maybe<Scalars['JSON']['output']>;
};

export type SubscriptionTask = Task & {
  __typename?: 'SubscriptionTask';
  assignee?: Maybe<User>;
  catchTask: CatchTask;
  createdOn: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isAssignment: Scalars['Boolean']['output'];
  lastUpdated: Scalars['Time']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  personReference: PersonReference;
  priority?: Maybe<TaskPriority>;
  status: TaskStatus;
  subscription?: Maybe<CatchSubscription>;
  type: TaskType;
  user: User;
};

export type SuggestedSourcesQuery = {
  prefix?: InputMaybe<Scalars['String']['input']>;
};

export type Summary = {
  __typename?: 'Summary';
  coinsurance: Scalars['Float']['output'];
  copay: Scalars['Float']['output'];
  deductible: Scalars['Float']['output'];
  limit: Scalars['Float']['output'];
};

/** DEPRECATED */
export type Survey = {
  __typename?: 'Survey';
  /** if the user has already finished this survey */
  hasFinished: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** A list of questions for the user to answer */
  questions: Array<Question>;
};

/** SyncStatusTypes represents the various sync statuses that can occur in our system */
export enum SyncStatusTypes {
  /** This is a general Catch error which can generally be resolved by a hard relink */
  CatchError = 'CATCH_ERROR',
  /**
   * a challenge is required to be answered before we can continue - a query needs
   * to be made for challenges after this to show the user which questions to
   * answer
   */
  ChallengeError = 'CHALLENGE_ERROR',
  /**
   * user needs to follow the instructions in "config_instructions", on this
   * banklink. Query for configinstructions for more information
   */
  ConfigError = 'CONFIG_ERROR',
  /** the sync completed successfully */
  Good = 'GOOD',
  /** there was an issue with the username or password - user has to go back to login screen. */
  LoginError = 'LOGIN_ERROR',
  /** there are no accounts in the banklink being synced */
  NoAccountsError = 'NO_ACCOUNTS_ERROR',
  /** syncing hasn't begun yet */
  Pending = 'PENDING',
  /**
   * We are missing a primary account in the banklink and are not currently syncing transactions.
   * Note that this is not a Plaid error - it is a Catch error.
   */
  PrimaryAccountMissing = 'PRIMARY_ACCOUNT_MISSING',
  /** our provider has been unable to sync an account that worked previously */
  Reconnecting = 'RECONNECTING',
  /** sync is in progress */
  Syncing = 'SYNCING',
  /**
   * a wider problem has occured which may not be resolved shortly - for now, the
   * user cannot view information around their account. we will send a
   * notification via the channels a user has selected to be contacted by once
   * this completes.
   */
  SystemError = 'SYSTEM_ERROR'
}

export type Task = {
  assignee?: Maybe<User>;
  catchTask: CatchTask;
  createdOn: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isAssignment: Scalars['Boolean']['output'];
  lastUpdated: Scalars['Time']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  personReference: PersonReference;
  priority?: Maybe<TaskPriority>;
  status: TaskStatus;
  type: TaskType;
  user: User;
};

export enum TaskPriority {
  PriorityHigh = 'PRIORITY_HIGH',
  PriorityLow = 'PRIORITY_LOW',
  PriorityMedium = 'PRIORITY_MEDIUM',
  PriorityUrgent = 'PRIORITY_URGENT'
}

export type TaskSort = {
  CreatedOn?: InputMaybe<SortDirection>;
  Priority?: InputMaybe<SortDirection>;
};

export enum TaskStatus {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Todo = 'TODO',
  Unknown = 'UNKNOWN'
}

export type TaskStatusHistory = {
  __typename?: 'TaskStatusHistory';
  actorID: Scalars['String']['output'];
  field: Scalars['String']['output'];
  updatedDate: Scalars['Time']['output'];
  value: Scalars['String']['output'];
};

export enum TaskType {
  Custom = 'CUSTOM',
  ExpertSetup = 'EXPERT_SETUP',
  HealthEnrollment = 'HEALTH_ENROLLMENT',
  PartnerHealth = 'PARTNER_HEALTH',
  Subscription = 'SUBSCRIPTION',
  TaxPayment = 'TAX_PAYMENT',
  Unknown = 'UNKNOWN'
}

export type TasksConnection = {
  __typename?: 'TasksConnection';
  edges: Array<Task>;
  pageInfo: PageInfo;
};

export type TaxForm = Document & {
  __typename?: 'TaxForm';
  createdOn: Scalars['Date']['output'];
  date: Scalars['Date']['output'];
  detail: Scalars['String']['output'];
  documentType: DocumentType;
  ext: FileType;
  id: Scalars['ID']['output'];
  month: Scalars['String']['output'];
  planType: PlanType;
  providerId?: Maybe<Scalars['String']['output']>;
  type: DocumentType;
  /** @deprecated use viewerTwo.document to fetch for url */
  url?: Maybe<Scalars['String']['output']>;
  vertical: Scalars['String']['output'];
};

export enum TaxIncomeDifferenceReason {
  HouseholdMemberChange = 'HOUSEHOLD_MEMBER_CHANGE',
  JobChange = 'JOB_CHANGE',
  Other = 'OTHER',
  SelfEmploymentIncomeFluctuation = 'SELF_EMPLOYMENT_INCOME_FLUCTUATION',
  WorkLocationChange = 'WORK_LOCATION_CHANGE'
}

export type TaxPayment = {
  __typename?: 'TaxPayment';
  amount: Scalars['Dollars']['output'];
  confirmationCode?: Maybe<Scalars['String']['output']>;
  confirmationEmailAddress?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['Time']['output'];
  document?: Maybe<TaxForm>;
  filingName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAuto: Scalars['Boolean']['output'];
  jurisdiction: Scalars['String']['output'];
  payment?: Maybe<Payment>;
  providerId?: Maybe<Scalars['String']['output']>;
  /** providerStatus to be removed after apps remove it from the query */
  providerStatus?: Maybe<TaxPaymentStatus>;
  signatureText?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TaxPaymentStatus>;
  timeframe?: Maybe<Scalars['String']['output']>;
  yearOfLastCompletedFiling?: Maybe<Scalars['Int']['output']>;
};

export type TaxPaymentAdmin = {
  __typename?: 'TaxPaymentAdmin';
  /** The address this user last used to complete tax filing. Blank if this is first time filing or old tax payment */
  addressOfLastCompletedFiling?: Maybe<Address>;
  /** The Admin user who worked on this payment */
  adminUser?: Maybe<User>;
  /** The amount that should be sent for the payment */
  amount: Scalars['Dollars']['output'];
  /** The confirmation code for this payment */
  confirmationCode?: Maybe<Scalars['String']['output']>;
  /** Email address to receive IRS confirmation email - Just default to Catch email if not used */
  confirmationEmailAddress?: Maybe<Scalars['String']['output']>;
  /** SSN of the user to confirm this is them - may not exist if older tax payment */
  confirmationSSN?: Maybe<Scalars['String']['output']>;
  /** When this was first created */
  createdOn: Scalars['Time']['output'];
  /** The name at the time of making this tax payment */
  filingName?: Maybe<Scalars['String']['output']>;
  /** The filing status at the time of making this tax payment */
  filingStatus?: Maybe<FilingStatus>;
  /** The id of the tax payment */
  id: Scalars['ID']['output'];
  /** whether this tax payment was made automatically or not */
  isAuto: Scalars['Boolean']['output'];
  /** The Jurisdiction we are filing for */
  jurisdiction?: Maybe<Scalars['String']['output']>;
  /** Any notes associated with this payment */
  notes?: Maybe<Scalars['String']['output']>;
  /** The personID this tax payment is for */
  person: User;
  /** User signature for agreements for using tax payments service - may not exist if older tax payment */
  signatureText?: Maybe<Scalars['String']['output']>;
  /** The Spouse's SSN if married filing jointly */
  spouseSSN?: Maybe<Scalars['String']['output']>;
  /** The current status of this tax payment */
  status: TaxPaymentStatus;
  /** The quarter we are filing for, format Q1, Q2, ... */
  timeframe?: Maybe<Scalars['String']['output']>;
  /** When this user last completed tax filing. Blank if this is first time filing or older tax payment */
  yearOfLastCompletedFiling?: Maybe<Scalars['Int']['output']>;
};

export enum TaxPaymentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type TaxPaymentTask = Task & {
  __typename?: 'TaxPaymentTask';
  assignee?: Maybe<User>;
  catchTask: CatchTask;
  createdOn: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isAssignment: Scalars['Boolean']['output'];
  lastUpdated: Scalars['Time']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  personReference: PersonReference;
  priority?: Maybe<TaskPriority>;
  status: TaskStatus;
  taxPayment?: Maybe<TaxPaymentAdmin>;
  type: TaskType;
  user: User;
};

export type TaxPaymentsInput = {
  status?: InputMaybe<TaxPaymentStatus>;
};

export enum TaxReturnFilingStatusType {
  HeadOfHousehold = 'HEAD_OF_HOUSEHOLD',
  MarriedFilingJointly = 'MARRIED_FILING_JOINTLY',
  MarriedFilingSeparately = 'MARRIED_FILING_SEPARATELY',
  SingleFiler = 'SINGLE_FILER'
}

export type TerminateHealthInsuranceEnrollmentResponse = {
  __typename?: 'TerminateHealthInsuranceEnrollmentResponse';
  InsuranceEnrollment?: Maybe<HealthInsuranceEnrollment>;
  error?: Maybe<ErrorItem>;
};

/** PushNotificationSettings represents the notifications the user wants to be texted about */
export type TextNotificationSettings = {
  __typename?: 'TextNotificationSettings';
  /** Updates regarding health insurance */
  healthInsurance: Scalars['Boolean']['output'];
};

export type TimeSeriesData = {
  __typename?: 'TimeSeriesData';
  allMoneyWeightedReturn?: Maybe<Scalars['Float']['output']>;
  dailyReturn?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  marketValue: Scalars['Dollars']['output'];
  monthMoneyWeightedReturn?: Maybe<Scalars['Float']['output']>;
  monthTimeWeightedReturn?: Maybe<Scalars['Float']['output']>;
  weekMoneyWeightedReturn?: Maybe<Scalars['Float']['output']>;
  weekTimeWeightedReturn?: Maybe<Scalars['Float']['output']>;
  yearMoneyWeightedReturn?: Maybe<Scalars['Float']['output']>;
  yearTimeWeightedReturn?: Maybe<Scalars['Float']['output']>;
};

export enum TimeSeriesRange {
  All = 'ALL',
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  LastYear = 'LAST_YEAR'
}

export type TopPlans = {
  __typename?: 'TopPlans';
  budgetPlan?: Maybe<ScoredHealthPlan>;
  /** shows plans that have any of the standards true, but will not repeat then if one is the same as the other */
  catchRecommended?: Maybe<ScoredHealthPlan>;
  comprehensivePlan?: Maybe<ScoredHealthPlan>;
  selectedPlan?: Maybe<ScoredHealthPlan>;
};

/** TransactionUpdateType is a type that indicates how the IncomeTransaction was detected in the platform. */
export enum TransactionUpdateType {
  InitialWebhook = 'INITIAL_WEBHOOK',
  NightlyBatch = 'NIGHTLY_BATCH',
  RealtimeWebhook = 'REALTIME_WEBHOOK',
  ReconnectSync = 'RECONNECT_SYNC',
  SetPrimarySync = 'SET_PRIMARY_SYNC'
}

export type TransferEvent = Event & {
  __typename?: 'TransferEvent';
  accountName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  amount: Scalars['Dollars']['output'];
  bankName: Scalars['String']['output'];
  /**
   * If status is PROCESSING, date is the expected completion date.
   * If status is COMPLETED, date is the completion date.
   * If status is FAILED, date is the date when the transfer failed.
   */
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  /** The ID of the associated transfer */
  id: Scalars['ID']['output'];
  /** Only a valid amount when type == INCOME. Otherwise, value will be 0 */
  incomeAmount: Scalars['Dollars']['output'];
  /** This transfer was processed via autopilot */
  isAutopilot: Scalars['Boolean']['output'];
  originalDescription: Scalars['String']['output'];
  source?: Maybe<IncomeTransactionSource>;
  status: TransferEventStatus;
  subtag?: Maybe<Scalars['String']['output']>;
  time: Scalars['Time']['output'];
  /** The associated transfer */
  transfer?: Maybe<CortexTransfer>;
  type: TransferEventType;
};

export enum TransferEventStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export enum TransferEventType {
  BankMigration = 'BANK_MIGRATION',
  BankTransfer = 'BANK_TRANSFER',
  BetweenGoals = 'BETWEEN_GOALS',
  Income = 'INCOME',
  Referral = 'REFERRAL',
  Reward = 'REWARD',
  SingleDeposit = 'SINGLE_DEPOSIT',
  Withdrawal = 'WITHDRAWAL'
}

export enum TransferType {
  Admin = 'ADMIN',
  /** A transfer from/to the bank outside of Catch */
  BankTransfer = 'BANK_TRANSFER',
  /** A transfer between two goals */
  BetweenGoalTransfer = 'BETWEEN_GOAL_TRANSFER',
  /** This is a deposit */
  Deposit = 'DEPOSIT',
  /** A fee */
  Fee = 'FEE',
  /** This is an income transaction */
  Income = 'INCOME',
  /** A payment */
  Payment = 'PAYMENT',
  /** This income comes from a referral or reward */
  Reward = 'REWARD',
  /** A wealth rollover */
  Rollover = 'ROLLOVER',
  /** A dividend from a stock */
  StockDividend = 'STOCK_DIVIDEND',
  /** This transfer is heading to retirement */
  ToRetirement = 'TO_RETIREMENT',
  /** A trade made within a retirement account */
  Trade = 'TRADE',
  /** Unsure where this transfer is coming from */
  Unknown = 'UNKNOWN',
  /** This is a withdrawal */
  Withdrawal = 'WITHDRAWAL'
}

export enum Trinary {
  Nil = 'NIL',
  No = 'NO',
  Yes = 'YES'
}

/**
 * A user's trusted contact, currently in use for our retirement provider.
 * It's expected that if this field exists, name and either phoneNumber or email will exist
 */
export type TrustedContact = {
  __typename?: 'TrustedContact';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * The input for TrustedContact
 * Note that it's expected for clients to supply the previously supplied name if
 * updating this field, otherwise the name will be cleared.
 */
export type TrustedContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UiQuestionToDisplay = {
  __typename?: 'UIQuestionToDisplay';
  key: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
};

/** The emailNotifications input used in the updateNotificationSettings mutation */
export type UpdateEmailNotificationSettingsInput = {
  /** Announcements for new Catch features, e.g. Family Leave or Autopilot */
  featureAnnouncements?: InputMaybe<Scalars['Boolean']['input']>;
  /** Linked Account notifications flag */
  linkedAccountStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updates regarding the user's active benefits */
  myBenefits?: InputMaybe<Scalars['Boolean']['input']>;
  /** Income Transaction notifications */
  planTransactionNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updates regarding benefits either recommended for the user */
  recommendedBenefits?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFlagsInput = {
  hasAccessToFintech: Scalars['Boolean']['input'];
};

/** UpdateIncomeTransactionInput is used in the updateIncomeTransaction mutation */
export type UpdateIncomeTransactionInput = {
  /** Include a expenses amount that will be deducted from the income_amount before calculations  */
  expenses?: InputMaybe<Scalars['Dollars']['input']>;
  /**
   * Include goal breakdowns and the desired action here, even if no change.
   * Note, if you include ANY goalBreakdownChanges, ALL goals to be acted on should be included.
   */
  goalBreakdownChanges?: InputMaybe<Array<ChangeGoalBreakdownInput>>;
  /**
   * The type of income this paycheck represents
   * This *must* be populated in the instance of the `status` field being APPROVED
   * - an error will be thrown otherwise.
   */
  paycheckType?: InputMaybe<PaycheckType>;
  /**
   * Set the status for what status this income transaction should move to.
   *     SKIPPED - Mark it as skipped
   *     NOT_INCOME - Mark it as not income
   *     APPROVED - Update the data (goal breakdowns, total amount), and Execute
   *     anything else - Update the data (goal breakdowns, total amount) and status. In theory, a user could use
   *       this to bring back a previously SKIPPED, or FAILED, or CANCELED transaction...
   */
  status?: InputMaybe<IncomeAction>;
  /** This corresponds to the IncomeTransactionID. */
  transactionID: Scalars['ID']['input'];
};

/** The input to the updateNotificationSettings mutation */
export type UpdateNotificationSettingsInput = {
  /** Email Notification Settings */
  emailNotificationSettings?: InputMaybe<UpdateEmailNotificationSettingsInput>;
  /** Push Notification Settings */
  pushNotificationSettings?: InputMaybe<UpdatePushNotificationSettingsInput>;
  /** Text Notification Settings */
  textNotificationSettings?: InputMaybe<UpdateTextNotificationSettingsInput>;
};

/** The pushNotifications input used in the updateNotificationSettings mutation */
export type UpdatePushNotificationSettingsInput = {
  /** Linked Account notifications flag */
  linkedAccountStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

/** UpdateSSNInput is the input to the updateSSN mutation. DEPRECATED: Update ssn using mutation `updateUserNew` */
export type UpdateSsnInput = {
  /** The user's social security number */
  ssn: Scalars['String']['input'];
};

export type UpdateTaxPaymentInput = {
  /** The admin user id assigned to this tax payment */
  adminUserID?: InputMaybe<Scalars['ID']['input']>;
  /** The confirmation code from the tax pay service */
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
  /** The id of the tax payment to update */
  id: Scalars['ID']['input'];
  /** Any notes to save for this tax payment */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The status to update */
  status?: InputMaybe<TaxPaymentStatus>;
};

/** The textNotifications input used in the updateNotificationSettings mutation */
export type UpdateTextNotificationSettingsInput = {
  /** Updates regarding health insurance */
  healthInsurance?: InputMaybe<Scalars['Boolean']['input']>;
};

/** UpdateUserInput is the input for the updateUser mutation */
export type UpdateUserInput = {
  /** If the user has acknowledged Unit's account disclosures */
  acknowledgedUnitAccountDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the user has authorized Abound to enroll EFTPS */
  authorizedAboundEftpsEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  dba?: InputMaybe<Scalars['String']['input']>;
  /** The User's date of birth */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** The User's EDD Questions Input */
  eddQuestions?: InputMaybe<EddQuestionsInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  /** The User's email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The User's employment details */
  employment?: InputMaybe<EmploymentInput>;
  /** The user's estimated 1099 income */
  estimated1099Income?: InputMaybe<Scalars['Dollars']['input']>;
  /** The user's estimated W2 income */
  estimatedW2Income?: InputMaybe<Scalars['Dollars']['input']>;
  /** User's external source of health coverage */
  externalHealthSource?: InputMaybe<ExternalHealthSource>;
  /** How much retirement savings do they have outside of Catch */
  externalRetirementSavings?: InputMaybe<Scalars['Dollars']['input']>;
  /** The user's family name */
  familyName?: InputMaybe<Scalars['String']['input']>;
  /** The user's filing status */
  filingStatus?: InputMaybe<FilingStatus>;
  /** The User's given name */
  givenName?: InputMaybe<Scalars['String']['input']>;
  /** If the user has health insurance */
  hasHealthInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  /** this will default to the currently viewer */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** If the user is a control person */
  isControlPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the user is firm affiliated */
  isFirmAffiliated?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the user is politically exposed */
  isPoliticallyExposed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's legal address */
  legalAddress?: InputMaybe<AddressInput>;
  /** The user's mailing address */
  mailingAddress?: InputMaybe<AddressInput>;
  /** The User's middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** The user's name prefix */
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  /** The user's name suffix */
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  /** The user's nickname (or preferred name) */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** How many tax dependents do they have? */
  numTaxDependents?: InputMaybe<Scalars['Int']['input']>;
  occupation?: InputMaybe<Occupation>;
  /** The User's phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The User's political exposure details */
  politicalExposure?: InputMaybe<PoliticalExposureInput>;
  /** The user's preferred language */
  preferredLanguage?: InputMaybe<PreferredLanguage>;
  /** The state in which the user resides */
  residenceState?: InputMaybe<Scalars['String']['input']>;
  /** The User's residency details */
  residency?: InputMaybe<ResidencyInput>;
  /** The User's biological sex. Used for things such as health care. */
  sex?: InputMaybe<Sex>;
  /** The code this user should be affiliated with */
  signupCode?: InputMaybe<Scalars['String']['input']>;
  /** Signup context enum regarding why this person signed up */
  signupContext?: InputMaybe<SignupContext>;
  /** The user's spouse's estimated income */
  spouseIncome?: InputMaybe<Scalars['Dollars']['input']>;
  /** The user's ssn. Format is xxx-xx-xxxx */
  ssn?: InputMaybe<Scalars['String']['input']>;
  /** If the user is subject to backup withholding */
  subjectBackupWithholding?: InputMaybe<Scalars['Boolean']['input']>;
  trustedContact?: InputMaybe<TrustedContactInput>;
  userScope?: InputMaybe<UserScope>;
  /** Whether the user should see a white label option */
  whiteLabel?: InputMaybe<WhiteLabelOption>;
  /** User's income state - same update as setIncomeState */
  workState?: InputMaybe<Scalars['String']['input']>;
  /** The user's source of income */
  workType?: InputMaybe<WorkType>;
};

export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  error?: Maybe<Error>;
  user?: Maybe<User>;
};

export type UpdateWealthAccountStatusInput = {
  setIsDisabled: Scalars['Boolean']['input'];
};

export type UpdateWealthAccountStatusResponse = {
  __typename?: 'UpdateWealthAccountStatusResponse';
  isDisabled: Scalars['Boolean']['output'];
};

/**
 * UploadAvatarRequest defines the input to the `uploadAvatar` mutation.
 *
 * Either the contact ID or the person ID must be populated.
 * The ImageFiletype will default to JPG if not provided.
 */
export type UploadAvatarRequest = {
  contactID?: InputMaybe<Scalars['ID']['input']>;
  imageFiletype?: InputMaybe<DocFileType>;
  /** image key of the uploaded S3 object */
  imageKey: Scalars['String']['input'];
  personID?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadHealthInsuranceCardInput = {
  /** The filetype of the image */
  filetype: ImageFiletype;
  /** The ID of Health Insurance Wallet item */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The key from s3 */
  key: Scalars['String']['input'];
  /** The side of the card that's being uploaded */
  side: InsuranceCardSide;
};

export type UploadHealthIssueDocumentInput = {
  /**
   * The document type being uploaded
   * Note that either dmiDocumentType should be populated, or sviDocumentType, not both.
   */
  dmiDocumentType?: InputMaybe<DmiDocumentType>;
  /** The filetype of the image */
  filetype: DocFileType;
  /** The id of the issue this document should resolve */
  issueID: Scalars['ID']['input'];
  /** The key from s3 */
  key: Scalars['String']['input'];
  /**
   * The document type being uploaded
   * Note that either dmiDocumentType should be populated, or sviDocumentType, not both.
   */
  sviDocumentType?: InputMaybe<SviDocumentType>;
};

export type UploadHealthIssueDocumentPayload = {
  __typename?: 'UploadHealthIssueDocumentPayload';
  dmi?: Maybe<Dmi>;
  svi?: Maybe<Svi>;
};

/** UploadIdentificationImageResponse is the response from the uploadIdentificationImage mutation. */
export type UploadIdentificationImageResponse = {
  __typename?: 'UploadIdentificationImageResponse';
  /** True if the upload completed successfully */
  accepted: Scalars['Boolean']['output'];
};

export type UpsertApplicationMemberInput = {
  /** Required only when adding new members */
  applicationID?: InputMaybe<Scalars['ID']['input']>;
  applicationMemberInput: ApplicationMemberInput;
};

export type UpsertApplicationMembersInput = {
  /** Required only when adding new members */
  applicationID?: InputMaybe<Scalars['ID']['input']>;
  applicationMembersInput: Array<ApplicationMemberInput>;
};

export type UpsertCatchFeatureInput = {
  /** default is false */
  chargesBillingAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of the Fee types this feature will have. */
  feeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** default is false */
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  /** default is false */
  isPaidFeature?: InputMaybe<Scalars['Boolean']['input']>;
  /** default is false */
  isVisibleByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** remove all IDs of fees associated with the paid feature */
  removeFeeIDs?: InputMaybe<Scalars['Boolean']['input']>;
  type: CatchFeatureType;
};

export type UpsertCatchPaidFeatureInput = {
  /** default is false */
  chargesBillingAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of the Fee types this feature will have. */
  feeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** default is false */
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  /** default is false */
  isVisibleByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** remove all IDs of fees associated with the paid feature */
  removeFeeIDs?: InputMaybe<Scalars['Boolean']['input']>;
  type: CatchPaidFeatureType;
};

export type UpsertContactResponse = {
  __typename?: 'UpsertContactResponse';
  contact?: Maybe<Contact>;
  error?: Maybe<Error>;
};

export type UpsertEnrollmentGroupsInput = {
  enrollmentGroupInputs: Array<EnrollmentGroupInput>;
};

export type UpsertEnrollmentGroupsResponse = {
  __typename?: 'UpsertEnrollmentGroupsResponse';
  enrollmentGroups?: Maybe<Array<EnrollmentGroup>>;
  error?: Maybe<ErrorItem>;
};

/** UpsertHealthApplicationInput represents an application for healthcare. */
export type UpsertHealthApplicationInput = {
  /** Complete list of application assistors if the user has any to attest to */
  applicationAssistors?: InputMaybe<Array<ProfessionalAssistorInput>>;
  applicationContext?: InputMaybe<ApplicationContext>;
  /** Application phase input */
  applicationPhase?: InputMaybe<ApplicationPhase>;
  applicationStateExchangeFields?: InputMaybe<ApplicationStateExchangeFieldsInput>;
  aptcAgreement?: InputMaybe<Trinary>;
  aptcHouseholdToApply?: InputMaybe<Scalars['Dollars']['input']>;
  /** Signature text */
  aptcSignature?: InputMaybe<Scalars['String']['input']>;
  /** S8 */
  areAllSameAddress?: InputMaybe<Trinary>;
  /** P2 #14 - are all dependents your children/stepchildren, single, and under 26 */
  areDependentsChildOrStepchildSingleUnder26?: InputMaybe<Trinary>;
  /** S26 */
  areDependentsLivingWithParentNotOnTaxReturn?: InputMaybe<Trinary>;
  countyfips?: InputMaybe<Scalars['String']['input']>;
  coverageState?: InputMaybe<Scalars['String']['input']>;
  coverageYearNumber?: InputMaybe<Scalars['Int']['input']>;
  /** S4 */
  householdIncome?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Pass in the Catch ID here if you want to upsert the application.
   * Previously, this was not required. But as of March 16, 2020 we want to be
   * able to support multiple applications. Due to this, we enable manipulation
   * by ID and we should ALWAYS assume to pass in the ID when updating an existing
   * application.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 248 */
  isAbsentParentAgreement?: InputMaybe<Trinary>;
  /** 254 */
  isChangeInformationAgreement?: InputMaybe<Trinary>;
  /** S22 */
  isClaimingAllDependentsOnTax?: InputMaybe<Trinary>;
  /** S20 */
  isCoveredThroughJobOrCobra?: InputMaybe<Trinary>;
  /** S23 */
  isDependentSingleChild25OrYounger?: InputMaybe<Trinary>;
  /** S19 */
  isIndianOrAlaskan?: InputMaybe<Trinary>;
  /** 247 */
  isMedicaidRequirementAgreement?: InputMaybe<Trinary>;
  /** Not in UI */
  isNonIncarcerationAgreement?: InputMaybe<Trinary>;
  /** S27 */
  isOfferedIchra?: InputMaybe<Trinary>;
  /** 256 */
  isPenaltyOfPerjuryAgreement?: InputMaybe<Trinary>;
  /** S9 */
  isPlanningToFileTax?: InputMaybe<Trinary>;
  /** 252 */
  isRenewalAgreement?: InputMaybe<Trinary>;
  /** S5, S6 */
  isRequestingFinancialAssistance?: InputMaybe<Trinary>;
  isResidesInApplicationState?: InputMaybe<Trinary>;
  /** S10 */
  isResponsibleForChildNotOnTaxReturn?: InputMaybe<Trinary>;
  /** 252 */
  isReuseTaxDataPermission?: InputMaybe<Trinary>;
  /** S3 */
  isSelfCoverage?: InputMaybe<Trinary>;
  /** S3 */
  isSpouseCoverage?: InputMaybe<Trinary>;
  /** Set this to true when a user starts the actual application process */
  isStartedApplication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the tax household anchor attested that the tax household reconciled to premium tax credits on last year's tax return */
  isTaxCreditReconciled?: InputMaybe<Trinary>;
  /** 255 */
  isTerminateCoverageOtherMecFoundAgreement?: InputMaybe<Trinary>;
  /** The last URL route we want to bring the user back to if in progress */
  lastUsedRoute?: InputMaybe<Scalars['String']['input']>;
  /** S1 */
  maritalStatus?: InputMaybe<MaritalStatus>;
  /** S3 */
  numDependentsRequestCoverage?: InputMaybe<Scalars['Int']['input']>;
  /** S2 */
  numTaxDependents?: InputMaybe<Scalars['Int']['input']>;
  planPremium?: InputMaybe<Scalars['Dollars']['input']>;
  planPremiumEffective?: InputMaybe<Scalars['Dollars']['input']>;
  /** 253 */
  renewEligibilityYearQuantity?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Screening questions - note that fields cannot be upserted normally if using this field
   * Only one format or the other will work
   */
  screening?: InputMaybe<HealthScreeningQuestionsInput>;
  /** The metal level of the selected plan */
  selectedMetalLevel?: InputMaybe<MetalLevel>;
  selectedPlanIssuerID?: InputMaybe<Scalars['String']['input']>;
  /** After fetch eligibility and BEFORE submit enrollment this must be populated */
  selectedProviderPlanID?: InputMaybe<Scalars['String']['input']>;
  /** 258 */
  signatureDate?: InputMaybe<Scalars['Date']['input']>;
  /** 258 */
  signatureText?: InputMaybe<Scalars['String']['input']>;
  /** 258 */
  signatureType?: InputMaybe<SignatureType>;
  /** Set the status of the application. This should only be done on app creation and set to renewal */
  status?: InputMaybe<HealthApplicationStatus>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertHealthApplicationResponse = {
  __typename?: 'UpsertHealthApplicationResponse';
  application: HealthApplication;
  error?: Maybe<ErrorItem>;
};

export type UpsertHealthExplorerDependentsInput = {
  healthExplorerDependentInputs: Array<HealthExplorerDependentInput>;
};

export type UpsertHealthInsuranceEnrollmentResponse = {
  __typename?: 'UpsertHealthInsuranceEnrollmentResponse';
  error?: Maybe<ErrorItem>;
  insuranceEnrollment?: Maybe<HealthInsuranceEnrollment>;
};

export type UpsertIncomeAutomationRulesInput = {
  upsertIncomeAutomationRuleInputs: Array<IncomeAutomationRuleInput>;
};

export type UpsertIncomeAutomationRulesResponse = {
  __typename?: 'UpsertIncomeAutomationRulesResponse';
  error?: Maybe<ErrorItem>;
  incomeAutomationRules?: Maybe<Array<IncomeAutomationRule>>;
};

export type UpsertIncomeSourceInput = {
  transactionTagID: Scalars['ID']['input'];
};

export type UpsertPartnerApplicationMemberResponse = {
  __typename?: 'UpsertPartnerApplicationMemberResponse';
  applicant: PartnerApplicationMember;
  errors?: Maybe<Array<HealthErrorItem>>;
};

export type UpsertPartnerApplicationResponse = {
  __typename?: 'UpsertPartnerApplicationResponse';
  application: PartnerHealthApplication;
  errors?: Maybe<Array<Maybe<ErrorItem>>>;
};

export type UpsertPublicHealthExplorerDependentsInput = {
  explorerDataID: Scalars['ID']['input'];
  publicHealthExplorerDependentInputs: Array<PublicHealthExplorerDependentInput>;
};

export type UpsertSubscriptionInput = {
  featureType?: InputMaybe<CatchFeatureType>;
  /** If ID is passed, subscription must exist */
  id?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Can upsert ACTIVE or INACTIVE */
  status?: InputMaybe<CatchSubscriptionStatus>;
  /** Type can be used to create a new subscription, or update an existing one. Only autopilot/banklinks may be created */
  type?: InputMaybe<CatchFeeTypes>;
};

export type UpsertTaskInput = {
  assignee?: InputMaybe<Scalars['ID']['input']>;
  chargePayment?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<TaskPriority>;
  status?: InputMaybe<TaskStatus>;
  type?: InputMaybe<TaskType>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertUserFlagsInput = {
  hasCatchUnemployment?: InputMaybe<Scalars['Boolean']['input']>;
  hasHealthUnemployment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertWealthAccountInput = {
  /** All beneficiaries upserted overwrites the existing. Upsert [] to delete all beneficiaries. Must have primaryBeneficiaries to upsert contingentBeneficiaries */
  contingentBeneficiaries?: InputMaybe<Array<BeneficiaryInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All beneficiaries upserted overwrites the existing. Upsert [] to delete all beneficiaries */
  primaryBeneficiaries?: InputMaybe<Array<BeneficiaryInput>>;
};

/** User represents a user of our platform */
export type User = {
  __typename?: 'User';
  /**
   * User provides consent for the Catch platform to use Health Data in other Catch products
   * @deprecated No longer supported
   */
  HealthDataSyncConsent: Trinary;
  /**
   * If the user has acknowledged BBVA's account disclosures
   * @deprecated No longer supported
   */
  acknowledgedAccountDisclosures: Scalars['Boolean']['output'];
  /**
   * If the user has acknowledged CBW's account disclosures
   * @deprecated No longer supported
   */
  acknowledgedCBWAccountDisclosures: Scalars['Boolean']['output'];
  /**
   * If the user has acknowledged the BBVA to CBW migration
   * @deprecated No longer supported
   */
  acknowledgedCBWMigration: Scalars['Boolean']['output'];
  /**
   * If the user has acknowledged Unit's account disclosures
   * @deprecated Use viewerTwo.agreements.acknowledgedUnitAccountDisclosures
   */
  acknowledgedUnitAccountDisclosures: Scalars['Boolean']['output'];
  /** The agreements for a user */
  agreements: Agreements;
  /**
   * answers to questions given on signup
   * @deprecated No longer supported
   */
  answers?: Maybe<Answers>;
  /**
   * If the user has authorized Abound to enroll EFTPS
   * @deprecated Use viewerTwo.agreements.authorizedAboundEftpsEnrollment
   */
  authorizedAboundEftpsEnrollment: Scalars['Boolean']['output'];
  /** base64 string of the person avatar */
  avatarImage?: Maybe<Scalars['String']['output']>;
  /**
   * The user's confidence in their various plans
   * @deprecated No longer supported
   */
  confidence?: Maybe<PlanConfidence>;
  /** Date the user was created. If it doesn't have a created_on, it means that it's really old */
  createdOn?: Maybe<Scalars['Time']['output']>;
  dba?: Maybe<Scalars['String']['output']>;
  /** The User's date of birth */
  dob?: Maybe<Scalars['Date']['output']>;
  /** The User's EDD Questions */
  eddQuestions?: Maybe<EddQuestions>;
  ein?: Maybe<Scalars['String']['output']>;
  /** The User's email - This may not exist for users that created accts after SMS signup (rare) */
  email?: Maybe<Scalars['String']['output']>;
  /** The User's employment information */
  employment?: Maybe<Employment>;
  /**
   * The user's estimated 1099 income
   * @deprecated Does not resolve properly
   */
  estimated1099Income?: Maybe<Scalars['Dollars']['output']>;
  /**
   * The user's estimated W2 income
   * @deprecated Does not resolve properly
   */
  estimatedW2Income?: Maybe<Scalars['Dollars']['output']>;
  /** User's external source of health coverage */
  externalHealthSource?: Maybe<ExternalHealthSource>;
  /** How much retirement savings do they have outside of Catch */
  externalRetirementSavings?: Maybe<Scalars['Dollars']['output']>;
  /** The User's family name */
  familyName: Scalars['String']['output'];
  /** The user's filing status */
  filingStatus?: Maybe<FilingStatus>;
  /** The full social security number */
  fullSSN?: Maybe<Scalars['String']['output']>;
  /** The User's given name */
  givenName: Scalars['String']['output'];
  /**
   * this is the internal UUID that matches up with the user service - this is
   * generally not required as services will map the JWT token internally of your
   * request.
   */
  id: Scalars['ID']['output'];
  /** Provides information about user's estimated income */
  income: EstimatedIncome;
  /** User's intercom ID */
  intercomID?: Maybe<Scalars['String']['output']>;
  /** If the user is legally a 'control person' */
  isControlPerson?: Maybe<Scalars['Boolean']['output']>;
  /** If the user is firm affiliated */
  isFirmAffiliated?: Maybe<Scalars['Boolean']['output']>;
  /** If the user is politically exposed */
  isPoliticallyExposed?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The user's job title/occupation
   * @deprecated Use the occupation field instead
   */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** The user's KYC status of their internal savings account */
  kycSavings?: Maybe<KycInfo>;
  /** The User's legal address */
  legalAddress?: Maybe<Address>;
  /** The User's mailing address */
  mailingAddress?: Maybe<Address>;
  /** The User's middle name */
  middleName?: Maybe<Scalars['String']['output']>;
  /** The prefix to the User's name */
  namePrefix?: Maybe<Scalars['String']['output']>;
  /** The suffix to the User's name */
  nameSuffix?: Maybe<Scalars['String']['output']>;
  /** The user's nickname (or preferred name) */
  nickname?: Maybe<Scalars['String']['output']>;
  /** How many tax dependents do they have? */
  numTaxDependents: Scalars['Int']['output'];
  /** The user's occupation */
  occupation?: Maybe<Occupation>;
  /** The user's acccount tier, populated from PersonReference */
  payrollProductTier?: Maybe<DepositProductTier>;
  /** The User's phone number - This may not exist for users that created accts before SMS signup */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The User's political exposure, if it exists */
  politicalExposure?: Maybe<PoliticalExposure>;
  /** The user's preferred language (defaults to ENGLISH) */
  preferredLanguage: PreferredLanguage;
  /** A code a user can use to refer others to join the platform */
  referralCode: Scalars['String']['output'];
  /** User has requested video onboarding help, and has not yet completed it */
  requestingOnboarding: Scalars['Boolean']['output'];
  /** The state in which a user resides */
  residenceState?: Maybe<Scalars['String']['output']>;
  /** The User's residency information */
  residency?: Maybe<Residency>;
  /** The Users's biological sex. Used for things such as health care. */
  sex?: Maybe<Sex>;
  /** The code this user used when they signed up */
  signupCode?: Maybe<Scalars['String']['output']>;
  /** Signup context enum regarding why this person signed up */
  signupContext?: Maybe<SignupContext>;
  /** Stringified JSON to store any signup paramters */
  signupParams?: Maybe<Scalars['String']['output']>;
  /** How the user's account was created */
  signupSource?: Maybe<SignupSource>;
  /**
   * The user's spouse's estimated income
   * @deprecated Does not resolve properly
   */
  spouseIncome?: Maybe<Scalars['Dollars']['output']>;
  /** The last 4 digits of a user's social security number */
  ssn?: Maybe<Scalars['String']['output']>;
  /** If the user is subject to backup withholding */
  subjectBackupWithholding?: Maybe<Scalars['Boolean']['output']>;
  /** The User's supported health pathways, based on legalAddress */
  supportedPathways?: Maybe<Array<HealthPathway>>;
  /** The user's trusted contact */
  trustedContact?: Maybe<TrustedContact>;
  /**
   * The scope of the user, the whole platform or health only
   * @deprecated No longer supported
   */
  userScope: UserScope;
  /**
   * Which verticals the user has denoted interest in
   * @deprecated No longer supported
   */
  verticalInterest: VerticalInterest;
  /** White label experience the user should see */
  whiteLabel?: Maybe<WhiteLabelOption>;
  /** User's work state - same state as viewer.incomeState */
  workState?: Maybe<Scalars['String']['output']>;
  /** The user's source of income */
  workType?: Maybe<WorkType>;
};

export enum UserAccountStatus {
  Deleted = 'DELETED',
  Denied = 'DENIED',
  Initial = 'INITIAL',
  Invalid = 'INVALID',
  Locked = 'LOCKED',
  Ready = 'READY',
  ServerWaiting = 'SERVER_WAITING',
  User = 'USER',
  UserWaiting = 'USER_WAITING'
}

export type UserFlags = {
  __typename?: 'UserFlags';
  hasCatchUnemployment: Scalars['Boolean']['output'];
  hasHealthUnemployment: Scalars['Boolean']['output'];
};

/** The user's scope in the app, platform or health only */
export enum UserScope {
  /** the user is a health only user */
  Health = 'HEALTH',
  /** the user is a full Catch user */
  Platform = 'PLATFORM'
}

/** ValidateSSNInput is the input to the validateSSN mutation */
export type ValidateSsnInput = {
  ssn: Scalars['String']['input'];
};

export type VerificationAnswer = {
  __typename?: 'VerificationAnswer';
  key: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type VerificationQuestion = {
  __typename?: 'VerificationQuestion';
  answers: Array<VerificationAnswer>;
  key: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export enum VerifyAliasError {
  /** issue with cognito update */
  VerifyAliasErrorCognito = 'VERIFY_ALIAS_ERROR_COGNITO',
  /** invalid mfa code */
  VerifyAliasErrorInvalidMfa = 'VERIFY_ALIAS_ERROR_INVALID_MFA',
  /** alias change was never initiated or already finished */
  VerifyAliasErrorNoActiveChange = 'VERIFY_ALIAS_ERROR_NO_ACTIVE_CHANGE',
  /** alias change expired, request a new mfa code */
  VerifyAliasErrorRequestExpired = 'VERIFY_ALIAS_ERROR_REQUEST_EXPIRED',
  /** exceeded max retries, request a new mfa code */
  VerifyAliasErrorRequestNoMoreRetries = 'VERIFY_ALIAS_ERROR_REQUEST_NO_MORE_RETRIES'
}

/** VerifyEmail changes a user's email given a correct MFA code */
export type VerifyEmailInput = {
  mfaCode: Scalars['String']['input'];
};

export type VerifyEmailResponse = {
  __typename?: 'VerifyEmailResponse';
  error?: Maybe<VerifyAliasError>;
  newEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['String']['output']>;
};

/** VerifyPhone changes a user's phone given a correct MFA code */
export type VerifyPhoneInput = {
  mfaCode: Scalars['String']['input'];
};

export type VerifyPhoneResponse = {
  __typename?: 'VerifyPhoneResponse';
  error?: Maybe<VerifyAliasError>;
  newPhone?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['String']['output']>;
};

/** DEPRECATED */
export type VerticalInterest = {
  __typename?: 'VerticalInterest';
  healthInsuranceInterest?: Maybe<Scalars['Boolean']['output']>;
  lifeInsuranceInterest?: Maybe<Scalars['Boolean']['output']>;
  retirementInterest?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type Viewer = {
  __typename?: 'Viewer';
  activity: ActivityConnection;
  /** Returns a single activity by ID */
  activityItem: Event;
  /**
   * Retrieves an individual bank statement
   * @deprecated use viewerTwo.documents.statements
   */
  bankStatement?: Maybe<BankStatement>;
  /**
   * Retrieves a single bank statement URL by ID
   * @deprecated use viewerTwo.document
   */
  bankStatementURL: Scalars['String']['output'];
  /**
   * Retrieves a list of the user's bank statements
   * @deprecated use viewerTwo.documents.statements
   */
  bankStatements?: Maybe<Array<BankStatement>>;
  /**
   * Returns a feature by type
   * @deprecated No longer supported
   */
  catchFeature: Feature;
  /**
   * Returns all features
   * @deprecated No longer supported
   */
  catchFeatures: Array<Feature>;
  /**
   * Retrieves a catch fee subscription for this user by id or type
   * @deprecated use catchSubscription instead
   */
  catchFeeSubscription: CatchFeeSubscription;
  /**
   * Retrieves a list of catch fee subscriptions for this user. Look at Input schema to check filter options
   * @deprecated use catchSubscriptions instead
   */
  catchFeeSubscriptions: Array<CatchFeeSubscription>;
  /**
   * Retrieves a catch subscription for this user by id or type
   * @deprecated No longer supported
   */
  catchSubscription: CatchSubscription;
  /**
   * Retrieves a list of catch subscriptions for this user. Look at Input schema to check filter options
   * @deprecated No longer supported
   */
  catchSubscriptions: Array<CatchSubscription>;
  /**
   * contact gets a contact by ID
   * @deprecated No longer supported
   */
  contact: Contact;
  /**
   * contacts lists the viewer's contacts
   * @deprecated No longer supported
   */
  contacts?: Maybe<Array<Contact>>;
  /**
   * health returns the viewer's health details
   * @deprecated use viewerTwo.health
   */
  health: Health;
  /**
   * Returns an HealthInsuranceEnrollment by ID
   * @deprecated Please use the healthInsuranceEnrollment query under health viewer
   */
  healthInsuranceEnrollment?: Maybe<InsuranceEnrollment>;
  /** id is the viewer's user ID in our system */
  id: Scalars['ID']['output'];
  /** Return an incomeAutomationRule for autopilot by the IncomeSource ID  */
  incomeAutomationRule?: Maybe<IncomeAutomationRule>;
  /** Return incomeAutomationRules for autopilot */
  incomeAutomationRules?: Maybe<Array<IncomeAutomationRule>>;
  /** Return an incomePreferences for how to auto process income */
  incomePreferences: IncomePreferences;
  /** Find one single income source by ID */
  incomeSource: IncomeTransactionSource;
  /**
   * incomeSourcesV2 returns the viewer's unique income sources, with subtags.
   * If a unique tag has multiple subtags, there will be a separate source for
   * each of them.
   *
   * Use the `text` and the `sourceDetail` fields for income source display.
   *
   * If none of this user's transactions are tagged, returns empty.
   *
   * The input is deprecated. Please do not send an input!
   *
   * The results are pre-sorted with the most frequently occurring Catch Tag 1st.
   * If a Catch tag has multiple subtags, the subtags are also sorted by frequency
   * with the tags taking priority.
   */
  incomeSources?: Maybe<Array<IncomeTransactionSource>>;
  /** gets the US state in which the user earned income in (e.g. MA), or null if it does not exist */
  incomeState?: Maybe<Scalars['String']['output']>;
  /** Gets a single income transaction. Errors if the transaction does not exist */
  incomeTransaction: IncomeTransaction;
  /**
   * incomeTransactions returns the viewer's income transactions
   * If the user has no incomeTransactions, this will return null
   * Otherwise, it'll return a list of Transactions
   * If range is passed in, we'll restrict the transactions returned to only be
   * within the period designated
   * If incomeAction is passed in, we'll restrict the transactions returned to the
   * given Income Action status
   * @deprecated Use incomeTransactionsPaged for pagination compatibility. We should not be using this without paging.
   */
  incomeTransactions?: Maybe<Array<IncomeTransaction>>;
  /**
   * incomeTransactionsPaged returns the viewer's income transactions
   * If the user has no incomeTransactions, this will return null
   * Otherwise, it'll return a list of Transactions
   * If range is passed in, we'll restrict the transactions returned to only be
   * within the period designated
   * If incomeAction is passed in, we'll restrict the transactions returned to the
   * given Income Action status
   */
  incomeTransactionsPaged: IncomeTransactionConnection;
  /**
   * Returns all InsuranceEnrollments for the user in the Catch platform
   * @deprecated No longer supported
   */
  insuranceEnrollments: Array<Maybe<InsuranceEnrollment>>;
  /** Returns an HMAC hash of the user's ID using intercom's secret key */
  intercomIdentityHash: Scalars['String']['output'];
  /**
   * latestApprovedPaycheck returns the user's latest approved paycheck.
   * If the paycheck was approved, executed or settled, the last paycheck will appear
   * here.
   */
  latestApprovedPaycheck: LatestApprovedPaycheck;
  /**
   * latestRecommendations returns the user's latest recommendations based on
   * their answers to the guide questions, or null if the user has not answered
   * the survey.
   * @deprecated Guide/survey deprecated
   */
  latestRecommendations?: Maybe<Recommendations>;
  /**
   * returns the user's legal address, or null if it does not exist
   * @deprecated Use `user.legalAddress`
   */
  legalAddress?: Maybe<Address>;
  /** Gets the user's notification settings */
  notificationSettings: NotificationSettings;
  /** nudge returns the viewers nudge by identifier */
  nudge?: Maybe<Nudge>;
  /** nudges returns the viewer's nudges if they exist. Otherwise returns empty list. */
  nudges: Array<Nudge>;
  /**
   * Returns a paid feature by type
   * @deprecated use catchFeature instead
   */
  paidFeature: PaidFeature;
  /**
   * Returns all paid features
   * @deprecated use catchFeatures instead
   */
  paidFeatures: Array<PaidFeature>;
  /**
   * payees returns the viewer's payees if they exist. Otherwise returns null. Optional filter on payee's vertical.
   * @deprecated No longer supported
   */
  payees?: Maybe<Array<Payee>>;
  /** Lists the pending rewards of a given status */
  pendingRewards?: Maybe<Array<QueuedReward>>;
  planHistorySummary: PlanHistorySummary;
  /**
   * A sum total of the user's deposits within 24 hours.
   * An error is returned in the case of a gRPC error.
   * @deprecated No longer supported
   */
  recentDeposits: Scalars['Dollars']['output'];
  /**
   * recommendations returns the user's recommendations based on
   * generateRecommendations. If that was never called, returns null
   * @deprecated Guide/survey deprecated
   */
  recommendations?: Maybe<Recommendations>;
  /** savingsAccount retrieves the user's savings account */
  savingsAccount?: Maybe<SavingsAccount>;
  /** If the viewer has a savings account, this will return metadata about the account, nil otherwise */
  savingsAccountMetadata?: Maybe<SavingsAccountMetadata>;
  /** Basic analytics about user activity */
  sessionInformation?: Maybe<SessionInformation>;
  /**
   * edge to the spouse's income, if it exists
   * @deprecated use viewer.user.spouseIncome
   */
  spouseIncome?: Maybe<Scalars['Dollars']['output']>;
  /** List of suggested sources for a user, in order */
  suggestedSources: CatchTransactionTagConnection;
  /**
   * Survey returns a survey for the user to answer
   * @deprecated No longer supported
   */
  survey: Survey;
  /** Get the cortex transfer by id */
  transfer: CortexTransfer;
  /**
   * A list of the user's savings account transfers
   * Providing either direction, paycheckType or transferType limits the list to
   * just the transfers that fulfill all of the conditions specified.
   *
   * If period is supplied and is the value CUSTOM, one of `fromDate` or `toDate`
   * must be supplied, else an error will be returned.
   */
  transfers: CortexTransferConnection;
  /** user will return the user. Specifying nocache as True will cause us to bypass the cache and get the user fresh from the database */
  user: User;
  /** Returns the items in the viewer's wallet, optionally filtering by the WalletItemVertical. */
  wallet?: Maybe<Array<WalletItem>>;
  /** Return a wallet item in the viewer's wallet by ID. */
  walletItem: WalletItem;
  /** wealthAccount retrieves a wealth account optionally by ID. */
  wealthAccount?: Maybe<WealthAccount>;
  /** If the viewer has a wealth account, this will return metadata about the account, nil otherwise */
  wealthAccountMetadata?: Maybe<WealthAccountMetadata>;
  /** wealthAccounts retrieves a user's wealth accounts */
  wealthAccounts: Array<WealthAccount>;
  /**
   * Retrieves a specific wealth statements
   * @deprecated use viewerTwo.documents.statements
   */
  wealthStatement?: Maybe<WealthStatement>;
  /**
   * Retrieves a single wealth statement URL by ID
   * @deprecated use viewerTwo.document
   */
  wealthStatementURL: Scalars['String']['output'];
  /**
   * Retrieves a list of the user's wealth statements
   * @deprecated use viewerTwo.documents.statements
   */
  wealthStatements?: Maybe<Array<WealthStatement>>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerActivityArgs = {
  adminEventTypes?: InputMaybe<Array<AdminEventType>>;
  applicationID?: InputMaybe<Scalars['ID']['input']>;
  enrollmentID?: InputMaybe<Scalars['ID']['input']>;
  eventTypes?: InputMaybe<Array<EventType>>;
  pagination: Pagination;
  sourceID?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerActivityItemArgs = {
  eventType?: InputMaybe<EventType>;
  id: Scalars['ID']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerBankStatementArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerBankStatementUrlArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerCatchFeatureArgs = {
  type: CatchFeatureType;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerCatchFeeSubscriptionArgs = {
  input: GetCatchFeeSubscriptionInput;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerCatchFeeSubscriptionsArgs = {
  input?: InputMaybe<ListCatchFeeSubscriptionsInput>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerCatchSubscriptionArgs = {
  input: GetCatchSubscriptionInput;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerCatchSubscriptionsArgs = {
  input?: InputMaybe<ListCatchSubscriptionsInput>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerContactArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerHealthInsuranceEnrollmentArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerIncomeAutomationRuleArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerIncomeSourceArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerIncomeSourcesArgs = {
  input?: InputMaybe<IncomeSourcesInput>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerIncomeTransactionArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerIncomeTransactionsArgs = {
  incomeAction?: InputMaybe<Array<IncomeAction>>;
  pagination?: InputMaybe<Pagination>;
  paycheckType?: InputMaybe<PaycheckType>;
  period?: InputMaybe<DatePeriod>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerIncomeTransactionsPagedArgs = {
  incomeAction?: InputMaybe<Array<IncomeAction>>;
  onlyAuto?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<Pagination>;
  paycheckType?: InputMaybe<PaycheckType>;
  period?: InputMaybe<DatePeriod>;
  sourceID?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerInsuranceEnrollmentsArgs = {
  input?: InputMaybe<InsuranceEnrollmentInput>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerIntercomIdentityHashArgs = {
  appPlatform: AppPlatform;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerNudgeArgs = {
  nudgeIdentifier: Scalars['String']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerPaidFeatureArgs = {
  type: CatchPaidFeatureType;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerPendingRewardsArgs = {
  status: RewardStatus;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerPlanHistorySummaryArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  period: DatePeriod;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerSuggestedSourcesArgs = {
  pagination: Pagination;
  query?: InputMaybe<SuggestedSourcesQuery>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerSurveyArgs = {
  tag?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerTransferArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerTransfersArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  pagination: Pagination;
  paycheckType?: InputMaybe<PaycheckType>;
  period?: InputMaybe<DatePeriod>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  transferType?: InputMaybe<TransferType>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerUserArgs = {
  nocache?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerWalletArgs = {
  itemVertical?: InputMaybe<WalletItemVertical>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerWalletItemArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerWealthAccountArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerWealthStatementArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Viewer is the current viewer of the schema
 * This is a useful concept to have for when we have users of our system that have
 * access to multiple accounts, e.g. beneficiaries, spouses, etc.
 */
export type ViewerWealthStatementUrlArgs = {
  id: Scalars['ID']['input'];
};

/** Visa represents a user's visa information */
export type Visa = {
  __typename?: 'Visa';
  /** defined in enum.gql */
  code?: Maybe<VisaTypes>;
  /** When the user's visa expires */
  expiry?: Maybe<Scalars['Date']['output']>;
};

/** VisaInput is the input for the visa section of ResidencyInput */
export type VisaInput = {
  /** defined in enum.gql */
  code?: InputMaybe<VisaTypes>;
  /** When the user's visa expires */
  expiry?: InputMaybe<Scalars['Date']['input']>;
};

/**
 * VisaTypes lists the different types of a Visa a user might have
 * https://en.wikipedia.org/wiki/Visa_policy_of_the_United_States#Nonimmigrant_visas
 */
export enum VisaTypes {
  /** B1 Visa */
  B1 = 'B1',
  /** C1 Visa */
  C1 = 'C1',
  /** E1 Visa */
  E1 = 'E1',
  /** E2 Visa */
  E2 = 'E2',
  /** E3 Visa */
  E3 = 'E3',
  /** F1 Visa */
  F1 = 'F1',
  /** H1B Visa */
  H1B = 'H1B',
  /** H2B Visa */
  H2B = 'H2B',
  /** H3 Visa */
  H3 = 'H3',
  /** K1 Visa */
  K1 = 'K1',
  /** L1 Visa */
  L1 = 'L1',
  /** Other Visa */
  OtherVisa = 'OTHER_VISA',
  /** Unknown Visa Type */
  UnknownVisaType = 'UNKNOWN_VISA_TYPE'
}

export type VisionWalletItem = WalletItem & {
  __typename?: 'VisionWalletItem';
  card: WalletCard;
  carrier?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<InsuranceSource>;
  vertical: WalletItemVertical;
};

export type VisionWalletItemInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InsuranceSource>;
};

export type WalletCard = {
  __typename?: 'WalletCard';
  /** back is the URL of the uploaded back image, if it exists. */
  back?: Maybe<Scalars['URL']['output']>;
  /** front is the URL of the uploaded front image, if it exists. */
  front?: Maybe<Scalars['URL']['output']>;
};

export enum WalletCardSide {
  Back = 'BACK',
  Front = 'FRONT'
}

export type WalletItem = {
  carrier?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<InsuranceSource>;
  vertical: WalletItemVertical;
};

export enum WalletItemVertical {
  Dental = 'DENTAL',
  Health = 'HEALTH',
  Life = 'LIFE',
  Vision = 'VISION'
}

export type WealthAccount = {
  __typename?: 'WealthAccount';
  accountID: Scalars['String']['output'];
  accountType: WealthAccountTypes;
  balance: Scalars['Dollars']['output'];
  contingentBeneficiaries?: Maybe<Array<Beneficiary>>;
  folioID?: Maybe<Scalars['String']['output']>;
  growth: Scalars['Float']['output'];
  /**
   * balance returns the dollar amount in the user's account. This is used for
   * performance comparisons between amount put into a retirement goal and the
   * actual value of the account.
   *
   * In the case of the balance not existing, or an error in retrieving the
   * balance, the balance field will be a 0 amount, rather than throwing an error.
   */
  id: Scalars['ID']['output'];
  /**
   * isDisabled indicates if the account is currently disabled for invesment, we use
   * this to temporarily stop investing new money while we are making a withdrawal from
   * a user's IRA
   */
  isDisabled: Scalars['Boolean']['output'];
  isPrimaryAccount: Scalars['Boolean']['output'];
  primaryBeneficiaries?: Maybe<Array<Beneficiary>>;
  totalContributions: Scalars['Dollars']['output'];
  userID: Scalars['String']['output'];
};

export type WealthAccountMetadata = {
  __typename?: 'WealthAccountMetadata';
  /** If the account is considered ready. */
  isAccountReady: Scalars['Boolean']['output'];
  /**
   * kycStatus returns the KYC status of the user with our wealth provider, or
   * null if the user has not started the KYC process.
   */
  kycStatus?: Maybe<KycStatus>;
};

/** The different types of wealth account a user might have in our system */
export enum WealthAccountTypes {
  /** Traditional IRA */
  Ira = 'IRA',
  /** ROTH IRA */
  RothIra = 'ROTH_IRA',
  /** SEP IRA */
  SepIra = 'SEP_IRA',
  UnknownWealthAccountType = 'UNKNOWN_WEALTH_ACCOUNT_TYPE'
}

/** The different types of wealth documents a user might need to provide */
export enum WealthDocumentTypes {
  /** An identification document */
  IdDocument = 'ID_DOCUMENT',
  /** An image of the user's signature */
  SignatureImage = 'SIGNATURE_IMAGE',
  /** Unknown wealth document type */
  UnknownWealthDocumentType = 'UNKNOWN_WEALTH_DOCUMENT_TYPE'
}

/** WealthReference contains information concerning our wealth platform. */
export type WealthReference = {
  __typename?: 'WealthReference';
  /** portfolio retrieves a single portfolio by ID. */
  portfolio: Portfolio;
  /** portfolios retrieves all the portfolios in our platform. */
  portfolios?: Maybe<Array<Portfolio>>;
};


/** WealthReference contains information concerning our wealth platform. */
export type WealthReferencePortfolioArgs = {
  id: Scalars['ID']['input'];
};

export type WealthStatement = Statement & {
  __typename?: 'WealthStatement';
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  reportType: ReportType;
};

export enum WhiteLabelOption {
  Aetna = 'AETNA'
}

/**
 * Where a user receives their income
 * These are prefixed as you cannot begin an enum with a number
 */
export enum WorkType {
  /** the user receives 1099 income */
  WorkType_1099 = 'WORK_TYPE_1099',
  /** the user receives both W2 and 1099 income */
  WorkTypeDiversified = 'WORK_TYPE_DIVERSIFIED',
  /** the user receives W2 income */
  WorkTypeW2 = 'WORK_TYPE_W2'
}

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type PlanFieldsFragment = { __typename?: 'HealthPlan', id: string, name: string, type: string, hsaEligible: boolean, benefitsURL: string, brochureURL: string, metalLevel: string, premium: number, premiumWithCredit: number, ehbPremium: number, hasDental: boolean, isStandard: boolean, issuer: { __typename?: 'Issuer', id: string, name: string }, deductibles: Array<{ __typename?: 'Deductibles', amount: number, familyCost: string, type: string }>, qualityRating: { __typename?: 'QualityRating', available: boolean, globalRating: number, clinicalQualityManagementRating: number, enrolleeExperienceRating: number, planEfficiencyRating: number } };

export type PlanFieldsLongFragment = { __typename?: 'HealthPlan', id: string, name: string, type: string, hsaEligible: boolean, benefitsURL: string, networkURL: string, metalLevel: string, premium: number, premiumWithCredit: number, hasDental: boolean, hasVision: boolean, isStandard: boolean, issuer: { __typename?: 'Issuer', id: string, name: string, individualURL: string, state: string }, benefits: Array<{ __typename?: 'Benefits', name: string, covered: boolean, explanation: string, hasLimits: boolean, limitUnit: string, limitQuantity: number, costSharings: Array<{ __typename?: 'CostSharing', coinsuranceOptions: string, coinsuranceRate: number, copayAmount: number, copayOptions: string, networkTier: string, csr: string, displayString: string }> }>, deductibles: Array<{ __typename?: 'Deductibles', amount: number, familyCost: string, type: string }>, moops: Array<{ __typename?: 'Moops', amount: number, familyCost: string, type: string }>, qualityRating: { __typename?: 'QualityRating', available: boolean, globalRating: number, clinicalQualityManagementRating: number, enrolleeExperienceRating: number, planEfficiencyRating: number } };

export type CoverageFieldsFragment = { __typename?: 'ScoredHealthPlan', providerCoverage: Array<{ __typename?: 'HealthProvider', npi: string, name: string, isCovered: boolean }>, drugCoverage: Array<{ __typename?: 'Drug', rxcui: string, name: string, isCovered: boolean, isGenericCovered: boolean }> };

export type PublicHealthPlansQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<PlanSearchInput>;
}>;


export type PublicHealthPlansQuery = { __typename?: 'Query', getPublicHealthExplorerData: { __typename?: 'PublicHealthExplorerData', id: string, dependents: Array<{ __typename?: 'PublicHealthExplorerDependentOld', age: number, relation: Relation, sex?: Sex | null, isSmoker: boolean }>, marketplaceEligibility: Array<{ __typename?: 'MarketplaceEligibility', aptc: any, csr: string, hardshipExemption: boolean, isMedicaidChip: boolean }>, plans: { __typename?: 'SortedHealthPlansResponse', plans: Array<{ __typename?: 'ScoredHealthPlan', id: string, isCatchRecommended: boolean, healthPlan: { __typename?: 'HealthPlan', id: string, name: string, type: string, hsaEligible: boolean, benefitsURL: string, brochureURL: string, metalLevel: string, premium: number, premiumWithCredit: number, ehbPremium: number, hasDental: boolean, isStandard: boolean, issuer: { __typename?: 'Issuer', id: string, name: string }, deductibles: Array<{ __typename?: 'Deductibles', amount: number, familyCost: string, type: string }>, qualityRating: { __typename?: 'QualityRating', available: boolean, globalRating: number, clinicalQualityManagementRating: number, enrolleeExperienceRating: number, planEfficiencyRating: number } }, scores?: { __typename?: 'Scores', score: number } | null, providerCoverage: Array<{ __typename?: 'HealthProvider', npi: string, name: string, isCovered: boolean }>, drugCoverage: Array<{ __typename?: 'Drug', rxcui: string, name: string, isCovered: boolean, isGenericCovered: boolean }> }> } } };

export type PublicHealthPlanDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  planID: Scalars['ID']['input'];
}>;


export type PublicHealthPlanDetailsQuery = { __typename?: 'Query', publicHealthPlanDetails: { __typename?: 'HealthPlan', id: string, name: string, type: string, hsaEligible: boolean, benefitsURL: string, networkURL: string, metalLevel: string, premium: number, premiumWithCredit: number, hasDental: boolean, hasVision: boolean, isStandard: boolean, issuer: { __typename?: 'Issuer', id: string, name: string, individualURL: string, state: string }, benefits: Array<{ __typename?: 'Benefits', name: string, covered: boolean, explanation: string, hasLimits: boolean, limitUnit: string, limitQuantity: number, costSharings: Array<{ __typename?: 'CostSharing', coinsuranceOptions: string, coinsuranceRate: number, copayAmount: number, copayOptions: string, networkTier: string, csr: string, displayString: string }> }>, deductibles: Array<{ __typename?: 'Deductibles', amount: number, familyCost: string, type: string }>, moops: Array<{ __typename?: 'Moops', amount: number, familyCost: string, type: string }>, qualityRating: { __typename?: 'QualityRating', available: boolean, globalRating: number, clinicalQualityManagementRating: number, enrolleeExperienceRating: number, planEfficiencyRating: number } } };

export type MarketplaceEligibilityFragment = { __typename?: 'MarketplaceEligibility', aptc: any, csr: string, hardshipExemption: boolean, isMedicaidChip: boolean };

export type PxDependentFragment = { __typename?: 'PublicHealthExplorerDependentOld', age: number, relation: Relation, sex?: Sex | null, isSmoker: boolean };

export type SessionFieldsFragment = { __typename?: 'PublicHealthExplorerData', id: string, email?: string | null, zipcode: string, countyfips: string, coverageYear: number, state: string, income?: any | null, providerPlanID?: string | null, pathwayType?: HealthPathway | null, financialPreference?: FinancialPreferenceType | null, plannedUsage?: HealthSortWeightType | null, drugsWanted?: Array<{ __typename?: 'Drug', rxcui: string, name: string }> | null, providersWanted?: Array<{ __typename?: 'HealthProvider', npi: string, name: string }> | null, dependents: Array<{ __typename?: 'PublicHealthExplorerDependentOld', age: number, relation: Relation, sex?: Sex | null, isSmoker: boolean }> };

export type UpsertSessionMutationVariables = Exact<{
  input: PublicHealthExplorerDataInput;
}>;


export type UpsertSessionMutation = { __typename?: 'Mutation', upsertPublicHealthExplorerData: { __typename?: 'PublicHealthExplorerData', id: string, email?: string | null, zipcode: string, countyfips: string, coverageYear: number, state: string, income?: any | null, providerPlanID?: string | null, pathwayType?: HealthPathway | null, financialPreference?: FinancialPreferenceType | null, plannedUsage?: HealthSortWeightType | null, drugsWanted?: Array<{ __typename?: 'Drug', rxcui: string, name: string }> | null, providersWanted?: Array<{ __typename?: 'HealthProvider', npi: string, name: string }> | null, dependents: Array<{ __typename?: 'PublicHealthExplorerDependentOld', age: number, relation: Relation, sex?: Sex | null, isSmoker: boolean }> } };

export type PublicHealthSessionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PublicHealthSessionQuery = { __typename?: 'Query', getPublicHealthExplorerData: { __typename?: 'PublicHealthExplorerData', id: string, email?: string | null, zipcode: string, countyfips: string, coverageYear: number, state: string, income?: any | null, providerPlanID?: string | null, pathwayType?: HealthPathway | null, financialPreference?: FinancialPreferenceType | null, plannedUsage?: HealthSortWeightType | null, drugsWanted?: Array<{ __typename?: 'Drug', rxcui: string, name: string }> | null, providersWanted?: Array<{ __typename?: 'HealthProvider', npi: string, name: string }> | null, dependents: Array<{ __typename?: 'PublicHealthExplorerDependentOld', age: number, relation: Relation, sex?: Sex | null, isSmoker: boolean }> } };

export const PlanFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HealthPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hsaEligible"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsURL"}},{"kind":"Field","name":{"kind":"Name","value":"brochureURL"}},{"kind":"Field","name":{"kind":"Name","value":"metalLevel"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"premiumWithCredit"}},{"kind":"Field","name":{"kind":"Name","value":"ehbPremium"}},{"kind":"Field","name":{"kind":"Name","value":"hasDental"}},{"kind":"Field","name":{"kind":"Name","value":"isStandard"}},{"kind":"Field","name":{"kind":"Name","value":"issuer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deductibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"familyCost"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualityRating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"globalRating"}},{"kind":"Field","name":{"kind":"Name","value":"clinicalQualityManagementRating"}},{"kind":"Field","name":{"kind":"Name","value":"enrolleeExperienceRating"}},{"kind":"Field","name":{"kind":"Name","value":"planEfficiencyRating"}}]}}]}}]} as unknown as DocumentNode<PlanFieldsFragment, unknown>;
export const PlanFieldsLongFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFieldsLong"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HealthPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hsaEligible"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsURL"}},{"kind":"Field","name":{"kind":"Name","value":"networkURL"}},{"kind":"Field","name":{"kind":"Name","value":"metalLevel"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"premiumWithCredit"}},{"kind":"Field","name":{"kind":"Name","value":"hasDental"}},{"kind":"Field","name":{"kind":"Name","value":"hasVision"}},{"kind":"Field","name":{"kind":"Name","value":"isStandard"}},{"kind":"Field","name":{"kind":"Name","value":"issuer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"individualURL"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"covered"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}},{"kind":"Field","name":{"kind":"Name","value":"hasLimits"}},{"kind":"Field","name":{"kind":"Name","value":"limitUnit"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"costSharings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coinsuranceOptions"}},{"kind":"Field","name":{"kind":"Name","value":"coinsuranceRate"}},{"kind":"Field","name":{"kind":"Name","value":"copayAmount"}},{"kind":"Field","name":{"kind":"Name","value":"copayOptions"}},{"kind":"Field","name":{"kind":"Name","value":"networkTier"}},{"kind":"Field","name":{"kind":"Name","value":"csr"}},{"kind":"Field","name":{"kind":"Name","value":"displayString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deductibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"familyCost"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"familyCost"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualityRating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"globalRating"}},{"kind":"Field","name":{"kind":"Name","value":"clinicalQualityManagementRating"}},{"kind":"Field","name":{"kind":"Name","value":"enrolleeExperienceRating"}},{"kind":"Field","name":{"kind":"Name","value":"planEfficiencyRating"}}]}}]}}]} as unknown as DocumentNode<PlanFieldsLongFragment, unknown>;
export const CoverageFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoverageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScoredHealthPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerCoverage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"npi"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isCovered"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drugCoverage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rxcui"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isCovered"}},{"kind":"Field","name":{"kind":"Name","value":"isGenericCovered"}}]}}]}}]} as unknown as DocumentNode<CoverageFieldsFragment, unknown>;
export const MarketplaceEligibilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplaceEligibility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplaceEligibility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aptc"}},{"kind":"Field","name":{"kind":"Name","value":"csr"}},{"kind":"Field","name":{"kind":"Name","value":"hardshipExemption"}},{"kind":"Field","name":{"kind":"Name","value":"isMedicaidChip"}}]}}]} as unknown as DocumentNode<MarketplaceEligibilityFragment, unknown>;
export const PxDependentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PXDependent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicHealthExplorerDependentOld"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"relation"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"isSmoker"}}]}}]} as unknown as DocumentNode<PxDependentFragment, unknown>;
export const SessionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicHealthExplorerData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"countyfips"}},{"kind":"Field","name":{"kind":"Name","value":"coverageYear"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"income"}},{"kind":"Field","name":{"kind":"Name","value":"providerPlanID"}},{"kind":"Field","name":{"kind":"Name","value":"pathwayType"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"financialPreference"}},{"kind":"Field","name":{"kind":"Name","value":"plannedUsage"}},{"kind":"Field","name":{"kind":"Name","value":"drugsWanted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rxcui"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providersWanted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"npi"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dependents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PXDependent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PXDependent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicHealthExplorerDependentOld"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"relation"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"isSmoker"}}]}}]} as unknown as DocumentNode<SessionFieldsFragment, unknown>;
export const PublicHealthPlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicHealthPlans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PlanSearchInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPublicHealthExplorerData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dependents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PXDependent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceEligibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketplaceEligibility"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCatchRecommended"}},{"kind":"Field","name":{"kind":"Name","value":"healthPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanFields"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoverageFields"}},{"kind":"Field","name":{"kind":"Name","value":"scores"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PXDependent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicHealthExplorerDependentOld"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"relation"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"isSmoker"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplaceEligibility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplaceEligibility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aptc"}},{"kind":"Field","name":{"kind":"Name","value":"csr"}},{"kind":"Field","name":{"kind":"Name","value":"hardshipExemption"}},{"kind":"Field","name":{"kind":"Name","value":"isMedicaidChip"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HealthPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hsaEligible"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsURL"}},{"kind":"Field","name":{"kind":"Name","value":"brochureURL"}},{"kind":"Field","name":{"kind":"Name","value":"metalLevel"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"premiumWithCredit"}},{"kind":"Field","name":{"kind":"Name","value":"ehbPremium"}},{"kind":"Field","name":{"kind":"Name","value":"hasDental"}},{"kind":"Field","name":{"kind":"Name","value":"isStandard"}},{"kind":"Field","name":{"kind":"Name","value":"issuer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deductibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"familyCost"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualityRating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"globalRating"}},{"kind":"Field","name":{"kind":"Name","value":"clinicalQualityManagementRating"}},{"kind":"Field","name":{"kind":"Name","value":"enrolleeExperienceRating"}},{"kind":"Field","name":{"kind":"Name","value":"planEfficiencyRating"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoverageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScoredHealthPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerCoverage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"npi"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isCovered"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drugCoverage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rxcui"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isCovered"}},{"kind":"Field","name":{"kind":"Name","value":"isGenericCovered"}}]}}]}}]} as unknown as DocumentNode<PublicHealthPlansQuery, PublicHealthPlansQueryVariables>;
export const PublicHealthPlanDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicHealthPlanDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicHealthPlanDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"planID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanFieldsLong"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFieldsLong"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HealthPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hsaEligible"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsURL"}},{"kind":"Field","name":{"kind":"Name","value":"networkURL"}},{"kind":"Field","name":{"kind":"Name","value":"metalLevel"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"premiumWithCredit"}},{"kind":"Field","name":{"kind":"Name","value":"hasDental"}},{"kind":"Field","name":{"kind":"Name","value":"hasVision"}},{"kind":"Field","name":{"kind":"Name","value":"isStandard"}},{"kind":"Field","name":{"kind":"Name","value":"issuer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"individualURL"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"covered"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}},{"kind":"Field","name":{"kind":"Name","value":"hasLimits"}},{"kind":"Field","name":{"kind":"Name","value":"limitUnit"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"costSharings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coinsuranceOptions"}},{"kind":"Field","name":{"kind":"Name","value":"coinsuranceRate"}},{"kind":"Field","name":{"kind":"Name","value":"copayAmount"}},{"kind":"Field","name":{"kind":"Name","value":"copayOptions"}},{"kind":"Field","name":{"kind":"Name","value":"networkTier"}},{"kind":"Field","name":{"kind":"Name","value":"csr"}},{"kind":"Field","name":{"kind":"Name","value":"displayString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deductibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"familyCost"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moops"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"familyCost"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualityRating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"globalRating"}},{"kind":"Field","name":{"kind":"Name","value":"clinicalQualityManagementRating"}},{"kind":"Field","name":{"kind":"Name","value":"enrolleeExperienceRating"}},{"kind":"Field","name":{"kind":"Name","value":"planEfficiencyRating"}}]}}]}}]} as unknown as DocumentNode<PublicHealthPlanDetailsQuery, PublicHealthPlanDetailsQueryVariables>;
export const UpsertSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicHealthExplorerDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertPublicHealthExplorerData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PXDependent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicHealthExplorerDependentOld"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"relation"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"isSmoker"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicHealthExplorerData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"countyfips"}},{"kind":"Field","name":{"kind":"Name","value":"coverageYear"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"income"}},{"kind":"Field","name":{"kind":"Name","value":"providerPlanID"}},{"kind":"Field","name":{"kind":"Name","value":"pathwayType"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"financialPreference"}},{"kind":"Field","name":{"kind":"Name","value":"plannedUsage"}},{"kind":"Field","name":{"kind":"Name","value":"drugsWanted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rxcui"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providersWanted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"npi"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dependents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PXDependent"}}]}}]}}]} as unknown as DocumentNode<UpsertSessionMutation, UpsertSessionMutationVariables>;
export const PublicHealthSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicHealthSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPublicHealthExplorerData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PXDependent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicHealthExplorerDependentOld"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"relation"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"isSmoker"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublicHealthExplorerData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"countyfips"}},{"kind":"Field","name":{"kind":"Name","value":"coverageYear"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"income"}},{"kind":"Field","name":{"kind":"Name","value":"providerPlanID"}},{"kind":"Field","name":{"kind":"Name","value":"pathwayType"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"financialPreference"}},{"kind":"Field","name":{"kind":"Name","value":"plannedUsage"}},{"kind":"Field","name":{"kind":"Name","value":"drugsWanted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rxcui"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providersWanted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"npi"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dependents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PXDependent"}}]}}]}}]} as unknown as DocumentNode<PublicHealthSessionQuery, PublicHealthSessionQueryVariables>;